import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PaginatorModule } from 'primeng/paginator';
import { MenubarModule } from 'primeng/menubar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { FileUploadModule } from 'primeng/fileupload';
import { MatIconModule } from '@angular/material/icon';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SESSION_STORAGE, StorageTranscoders, isStorageAvailable } from 'ngx-webstorage-service';
import { AES, enc } from 'crypto-js';
import { DOCUMENT, BrowserModule } from '@angular/platform-browser';
import { MessageService as MessageService$1 } from 'primeng/components/common/messageservice';
import { marker, icon, latLng, tileLayer } from 'leaflet';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { __values, __awaiter, __generator } from 'tslib';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map, tap } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { formatDate, DatePipe, CommonModule } from '@angular/common';
import { BlockUIModule } from 'primeng/blockui';
import { Injectable, InjectionToken, Inject, Component, Input, NgModule, EventEmitter, LOCALE_ID, Output, defineInjectable, inject, Renderer2, ViewChild, ElementRef } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONFIGURATION = new InjectionToken('CONFIGURATION');
var ConfigService = /** @class */ (function () {
    function ConfigService(_config) {
        this._config = _config;
        this.config = _config;
    }
    Object.defineProperty(ConfigService.prototype, "api_url", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.api_url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "oauth2_client_id", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.oauth2_client_id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "oauth2_client_secret", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.oauth2_client_secret;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "authentication_session_encrypt_key", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.authentication_session_encrypt_key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "authentication_roles_all", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.authentication_roles_all;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "authentication_roles_any", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.authentication_roles_any;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "authentication_login_page", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.authentication_login_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "authentication_forbidden_page", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.authentication_forbidden_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfigService.prototype, "default_locale", {
        get: /**
         * @return {?}
         */
        function () {
            return this.config.default_locale;
        },
        enumerable: true,
        configurable: true
    });
    ConfigService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ConfigService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [CONFIGURATION,] }] }
    ]; };
    /** @nocollapse */ ConfigService.ngInjectableDef = defineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(inject(CONFIGURATION)); }, token: ConfigService, providedIn: "root" });
    return ConfigService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/incidencia.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var EstadoIncidencia = {
    Pendiente: 1,
    Aceptada: 2,
    Rechazada: 3,
};
EstadoIncidencia[EstadoIncidencia.Pendiente] = 'Pendiente';
EstadoIncidencia[EstadoIncidencia.Aceptada] = 'Aceptada';
EstadoIncidencia[EstadoIncidencia.Rechazada] = 'Rechazada';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/util.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UtilService = /** @class */ (function () {
    function UtilService() {
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    UtilService.prototype.getUrlParams = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        var e_1, _a;
        /** @type {?} */
        var url_params = '?';
        if (filters != null) {
            for (var filter_key in filters) {
                /** @type {?} */
                var filter = filters[filter_key];
                if (url_params !== '?') {
                    url_params += '&';
                }
                url_params += this.getUrlParam(filter_key, filter);
            }
        }
        if (sort_by != null && sort_by.length > 0) {
            try {
                for (var sort_by_1 = __values(sort_by), sort_by_1_1 = sort_by_1.next(); !sort_by_1_1.done; sort_by_1_1 = sort_by_1.next()) {
                    var data = sort_by_1_1.value;
                    if (url_params !== '?') {
                        url_params += '&';
                    }
                    url_params += 'orderBy=' + data.field + ':' + (data.order >= 0 ? 'asc' : 'desc');
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (sort_by_1_1 && !sort_by_1_1.done && (_a = sort_by_1.return)) _a.call(sort_by_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (offset != null) {
            if (url_params !== '?') {
                url_params += '&';
            }
            url_params += 'refistroInicial=' + offset;
        }
        if (limit != null) {
            if (url_params !== '?') {
                url_params += '&';
            }
            url_params += 'registros=' + limit;
        }
        return url_params;
    };
    /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    UtilService.prototype.getUrlParam = /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    function (key, filter) {
        if (key.endsWith(':in') || filter.matchMode === 'in') {
            return this.getUrlParamFromFilterArray(key, filter);
        }
        else {
            return this.getUrlParamFromFilter(key, filter);
        }
    };
    /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    UtilService.prototype.getUrlParamFromFilterArray = /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    function (key, filter) {
        var e_2, _a;
        /** @type {?} */
        var url_params = '';
        if (filter.value == null || filter.value == '') {
            return url_params;
        }
        /** @type {?} */
        var values = filter.value.split(',');
        if (values.length == 0) {
            return url_params;
        }
        try {
            for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var value = values_1_1.value;
                if (url_params !== '') {
                    url_params += '&';
                }
                /** @type {?} */
                var filter_value = (/** @type {?} */ ({}));
                filter_value.value = value.trim();
                filter_value.matchMode = filter.matchMode;
                url_params += this.getUrlParamFromFilter(key, filter_value);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return url_params;
    };
    /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    UtilService.prototype.getUrlParamFromFilter = /**
     * @private
     * @param {?} key
     * @param {?} filter
     * @return {?}
     */
    function (key, filter) {
        /** @type {?} */
        var url_params = key;
        if (filter.matchMode != null) {
            url_params += ":" + filter.matchMode;
        }
        url_params += '=' + filter.value;
        return url_params;
    };
    /**
     * @return {?}
     */
    UtilService.prototype.getLocalizacion = /**
     * @return {?}
     */
    function () {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            if (!!navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((/**
                 * @param {?} position
                 * @return {?}
                 */
                function (position) {
                    resolve(position);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    reject(error);
                }));
            }
            else {
                reject('Localización no soportado');
            }
        }));
    };
    UtilService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UtilService.ctorParameters = function () { return []; };
    /** @nocollapse */ UtilService.ngInjectableDef = defineInjectable({ factory: function UtilService_Factory() { return new UtilService(); }, token: UtilService, providedIn: "root" });
    return UtilService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/incidencia.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IncidenciaService = /** @class */ (function () {
    function IncidenciaService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/incidencias';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    IncidenciaService.prototype.getIncidencias = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} incidenciasRest
         * @return {?}
         */
        function (incidenciasRest) {
            /** @type {?} */
            var incidencias = incidenciasRest.map((/**
             * @param {?} incidenciaRest
             * @return {?}
             */
            function (incidenciaRest) {
                return (/** @type {?} */ (incidenciaRest));
            }));
            return incidencias;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    IncidenciaService.prototype.getIncidenciasCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    IncidenciaService.prototype.getOneIncidencia = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getIncidencias(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} incidencias
         * @return {?}
         */
        function (incidencias) {
            if (incidencias == null || incidencias.length == 0) {
                return null;
            }
            else {
                return incidencias[0];
            }
        })));
    };
    /**
     * @param {?} incidencia
     * @return {?}
     */
    IncidenciaService.prototype.anyadirIncidencia = /**
     * @param {?} incidencia
     * @return {?}
     */
    function (incidencia) {
        /** @type {?} */
        var incidencia_post = (/** @type {?} */ ({
            texto: incidencia.texto,
            empleado: incidencia.empleado
        }));
        return this.http.post(this.base_url, incidencia_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idIncidencia
     * @return {?}
     */
    IncidenciaService.prototype.eliminarIncidencia = /**
     * @param {?} idIncidencia
     * @return {?}
     */
    function (idIncidencia) {
        return this.http.delete(this.base_url + '/' + idIncidencia).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} incidencia
     * @return {?}
     */
    IncidenciaService.prototype.actualizarIncidencia = /**
     * @param {?} incidencia
     * @return {?}
     */
    function (incidencia) {
        /** @type {?} */
        var incidencia_put = (/** @type {?} */ ({
            id: incidencia.id,
            texto: incidencia.texto,
            fechaResolucion: incidencia.fechaResolucion,
            estado: incidencia.estado,
            comentario: incidencia.comentario,
            empleado: incidencia.empleado
        }));
        return this.http.put(this.base_url + '/' + incidencia_put.id, incidencia_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    IncidenciaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    IncidenciaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ IncidenciaService.ngInjectableDef = defineInjectable({ factory: function IncidenciaService_Factory() { return new IncidenciaService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: IncidenciaService, providedIn: "root" });
    return IncidenciaService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/prime-locale.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PrimeLocaleService = /** @class */ (function () {
    function PrimeLocaleService(_locale_id) {
        this._locale_id = _locale_id;
        this.locale_id = _locale_id;
        this.locales = (/** @type {?} */ ({}));
        // ALEMAN
        this.locales['de'] = {
            closeText: 'Schließen',
            prevText: 'Zurück',
            nextText: 'Weiter',
            monthNames: ['Januar', 'Februar', 'MÃ¤rz', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthNamesShort: ['Jan', 'Feb', 'MÃ¤r', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
            dayNamesMin: ['S', 'M', 'D', 'M ', 'D', 'F ', 'S'],
            weekHeader: 'Woche',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Nur Zeit',
            timeText: 'Zeit',
            hourText: 'Stunde',
            minuteText: 'Minute',
            secondText: 'Sekunde',
            currentText: 'Aktuelles Datum',
            ampm: false,
            month: 'Monat',
            week: 'Woche',
            day: 'Tag',
            allDayText: 'Ganzer Tag',
            dateFormat: 'mm/dd/yy'
        };
        // ARABE
        this.locales['ar'] = {
            closeText: 'إغلق',
            prevText: 'إلى الخلف',
            nextText: 'إلى الأمام',
            currentText: 'بداية',
            monthNames: ['ديسمبر', 'نوفمبر', 'أكتوبر', 'سبتمبر', 'أغسطس', 'يوليو', 'يونيو', 'مايو', 'ابريل', 'مارس', 'فبراير', 'يناير'],
            monthNamesShort: ['ديسمبر', 'نوفمبر', 'أكتوبر', 'سبتمبر', 'أغسطس', 'يوليو', 'يونيو', 'مايو', 'ابريل', 'مارس', 'فبراير', 'يناير'],
            dayNames: ['يوم الأحد‎', 'يوم الإثنين‎', 'يوم الثلاثاء‎', '‏يوم الأَرْبعاء‎', '‏يوم الخَمِيس‎', 'يوم الجُمْعَة‎‎', 'يوم السَّبْت'],
            dayNamesShort: ['الأحد‎', 'الإثنين‎', 'الثلاثاء‎', 'الأَرْبعاء‎', 'الخَمِيس‎', 'الجُمْعَة‎‎', 'السَّبْت'],
            dayNamesMin: ['الأحد‎', 'الإثنين‎', 'الثلاثاء‎', 'الأَرْبعاء‎', 'الخَمِيس‎', 'الجُمْعَة‎‎', 'السَّبْت'],
            weekHeader: 'الأسبوع',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'الوقت فقط',
            timeText: 'الوقت',
            hourText: 'ساعة',
            minuteText: 'دقيقة',
            secondText: 'ثانية',
            ampm: false,
            month: 'الشهر',
            week: 'الأسبوع',
            day: 'اليوم',
            allDayText: 'سا ئراليوم',
            dateFormat: 'mm/dd/yy'
        };
        // CHINO
        this.locales['zh_CN'] = {
            closeText: '关闭',
            prevText: '上个月',
            nextText: '下个月',
            currentText: '今天',
            monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
            dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
            weekHeader: '周',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: true,
            yearSuffix: '',
            // 年
            timeOnlyTitle: '仅时间',
            timeText: '时间',
            hourText: '时',
            minuteText: '分',
            secondText: '秒',
            ampm: false,
            month: '月',
            week: '周',
            day: '日',
            allDayText: '全天',
            dateFormat: 'mm/dd/yy'
        };
        //ESPAÑOL
        this.locales['es'] = {
            closeText: 'Cerrar',
            prevText: 'Anterior',
            nextText: 'Siguiente',
            monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            weekHeader: 'Semana',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Sólo hora',
            timeText: 'Tiempo',
            hourText: 'Hora',
            minuteText: 'Minuto',
            secondText: 'Segundo',
            currentText: 'Fecha actual',
            ampm: false,
            month: 'Mes',
            week: 'Semana',
            day: 'Día',
            allDayText: 'Todo el día',
            dateFormat: 'dd/mm/yy'
        };
        //CATALAN
        this.locales['ca'] = {
            closeText: 'Tancar',
            prevText: 'Anterior',
            nextText: 'Següent',
            monthNames: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'],
            monthNamesShort: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
            dayNames: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
            dayNamesShort: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
            dayNamesMin: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
            weekHeader: 'Setmana',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Només hora',
            timeText: 'Temps',
            hourText: 'Hora',
            minuteText: 'Minut',
            secondText: 'Segon',
            currentText: 'Data actual',
            ampm: false,
            month: 'Mes',
            week: 'Setmana',
            day: 'Dia',
            allDayText: 'Tot el día',
            dateFormat: 'dd/mm/yy'
        };
        // INGLES
        this.locales['en'] = {
            closeText: 'Close',
            prevText: 'Previous',
            nextText: 'Next',
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Tue', 'Fri', 'Sat'],
            dayNamesMin: ['S', 'M', 'T', 'W ', 'T', 'F ', 'S'],
            weekHeader: 'Week',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Only Time',
            timeText: 'Time',
            hourText: 'Time',
            minuteText: 'Minute',
            secondText: 'Second',
            currentText: 'Current Date',
            ampm: false,
            month: 'Month',
            week: 'week',
            day: 'Day',
            allDayText: 'All Day',
            dateFormat: 'mm/dd/yy'
        };
        // FRANCES
        this.locales['fr'] = {
            closeText: 'Fermer',
            prevText: 'Précédent',
            nextText: 'Suivant',
            monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
            dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            weekHeader: 'Semaine',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Choisir l\'heure',
            timeText: 'Heure',
            hourText: 'Heures',
            minuteText: 'Minutes',
            secondText: 'Secondes',
            currentText: 'Maintenant',
            ampm: false,
            month: 'Mois',
            week: 'Semaine',
            day: 'Jour',
            allDayText: 'Toute la journée',
            dateFormat: 'mm/dd/yy'
        };
        // GRIEGO
        this.locales['el'] = {
            closeText: 'Κλείσιμο',
            prevText: 'Προηγούμενο',
            nextText: 'Επόμενο',
            monthNames: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάϊος', 'Ιούνιος', 'Ιούλιος', 'Άυγουστος', 'Σεπτέμβιος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
            monthNamesShort: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαι', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
            dayNames: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
            dayNamesShort: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
            dayNamesMin: ['Κ', 'Δ', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σ'],
            weekHeader: 'Εβδ',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Επιλογή Ώρας',
            timeText: 'Χρόνος',
            hourText: 'Ώρα',
            minuteText: 'Λεπτό',
            secondText: 'Δεύτερολεπτο',
            currentText: 'Τώρα',
            ampm: false,
            month: 'Μήνας',
            week: 'Εβδομάδα',
            day: 'Μέρα',
            allDayText: 'Όλη Μέρα',
            dateFormat: 'mm/dd/yy'
        };
        // HEBREO
        this.locales['he'] = {
            closeText: 'סגור',
            prevText: 'הקודם',
            nextText: 'הבא',
            monthNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
            monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
            dayNamesShort: ['א\'', 'ב\'', 'ג\'', 'ד\'', 'ה\'', 'ו\'', 'שבת'],
            dayNamesMin: ['א\'', 'ב\'', 'ג\'', 'ד\'', 'ה\'', 'ו\'', 'שבת'],
            weekHeader: 'שבוע',
            firstDay: 0,
            firstDayOfWeek: 0,
            isRTL: true,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'זמן בלבד',
            timeText: 'זמן',
            hourText: 'שעה',
            minuteText: 'דקה',
            secondText: 'שניה',
            currentText: 'היום',
            ampm: false,
            month: 'חודש',
            week: 'שבוע',
            day: 'יום',
            allDayText: 'כל היום',
            dateFormat: 'mm/dd/yy'
        };
        // HOLANDES
        this.locales['nl'] = {
            closeText: 'Sluiten',
            prevText: 'Terug',
            nextText: 'Volgende',
            currentText: 'Huidig',
            monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
            monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
            dayNamesShort: ['zo', 'ma', 'di', 'woe', 'do', 'vr', 'za'],
            dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo ', 'Do', 'Vr ', 'Za'],
            weekHeader: 'Week',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Alleen tijd',
            timeText: 'Tijd',
            hourText: 'Uur',
            minuteText: 'Minuut',
            secondText: 'Seconde',
            ampm: false,
            month: 'Maand',
            week: 'week',
            day: 'Dag',
            allDayText: 'Alle Dagen',
            dateFormat: 'mm/dd/yy'
        };
        // HUNGARO
        this.locales['hu'] = {
            closeText: 'Bezárás',
            prevText: 'Előző',
            nextText: 'Következő',
            monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
            monthNamesShort: ['Jan', 'Febr', 'Márc', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szept', 'Okt', 'Nov', 'Dec'],
            dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
            dayNamesShort: ['Vas', 'H', 'K', 'Sze', 'Csüt', 'P', 'Szo'],
            dayNamesMin: ['V', 'H', 'K', 'Sze ', 'Cs', 'P ', 'Szo'],
            weekHeader: 'Hét',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: true,
            yearSuffix: '.',
            timeOnlyTitle: 'Csak óra',
            timeText: 'Időpont',
            hourText: 'Óra',
            minuteText: 'Perc',
            secondText: 'Másodperc',
            currentText: 'Ma',
            ampm: false,
            month: 'Hónap',
            week: 'Hét',
            day: 'Nap',
            allDayText: 'Egész nap',
            dateFormat: 'mm/dd/yy'
        };
        // ITALIANO
        this.locales['it'] = {
            closeText: 'Chiudi',
            prevText: 'Precedente',
            nextText: 'Prossimo',
            monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
            monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
            dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            dayNamesMin: ['D', 'L', 'M', 'M ', 'G', 'V ', 'S'],
            weekHeader: 'Sett',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Solo Tempo',
            timeText: 'Ora',
            hourText: 'Ore',
            minuteText: 'Minuto',
            secondText: 'Secondo',
            currentText: 'Data Odierna',
            ampm: false,
            month: 'Mese',
            week: 'Settimana',
            day: 'Giorno',
            allDayText: 'Tutto il Giorno',
            dateFormat: 'mm/dd/yy'
        };
        // POLACO
        this.locales['pl'] = {
            closeText: 'Zamknij',
            prevText: 'Poprzedni',
            nextText: 'Następny',
            monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
            monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
            dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
            dayNamesShort: ['Nie', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
            dayNamesMin: ['N', 'P', 'W', 'Ś', 'Cz', 'P', 'S'],
            weekHeader: 'Tydzień',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: 'r',
            timeOnlyTitle: 'Tylko czas',
            timeText: 'Czas',
            hourText: 'Godzina',
            minuteText: 'Minuta',
            secondText: 'Sekunda',
            currentText: 'Teraz',
            ampm: false,
            month: 'Miesiąc',
            week: 'Tydzień',
            day: 'Dzień',
            allDayText: 'Cały dzień',
            dateFormat: 'mm/dd/yy'
        };
        // RUMANO
        this.locales['ro'] = {
            closeText: 'Închide',
            prevText: 'Înapoi',
            nextText: 'Înainte',
            currentText: 'Acasă',
            monthNames: ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'],
            monthNamesShort: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec'],
            dayNames: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
            dayNamesShort: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
            dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            weekHeader: 'Săptămâna',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Numai timp',
            timeText: 'Timp',
            hourText: 'Ora',
            minuteText: 'Minut',
            secondText: 'Secunde',
            ampm: false,
            month: 'Luna',
            week: 'Săptămâna',
            day: 'Zi',
            allDayText: 'Toată ziua',
            dateFormat: 'mm/dd/yy'
        };
        // RUSO
        this.locales['ru'] = {
            closeText: 'Закрыть',
            prevText: 'Назад',
            nextText: 'Вперёд',
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Субота'],
            dayNamesShort: ['Воск', 'Пон', 'Вт', 'Ср', 'Четв', 'Пят', 'Суб'],
            dayNamesMin: ['В', 'П', 'Вт', 'С ', 'Ч', 'П ', 'Сб'],
            weekHeader: 'Неделя',
            firstDay: 1,
            firstDayOfWeek: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            timeOnlyTitle: 'Только время',
            timeText: 'Время',
            hourText: 'Час',
            minuteText: 'Минута',
            secondText: 'Секунда',
            currentText: 'Сегодня',
            ampm: false,
            month: 'Месяц',
            week: 'неделя',
            day: 'День',
            allDayText: 'Весь день',
            dateFormat: 'mm/dd/yy'
        };
    }
    Object.defineProperty(PrimeLocaleService.prototype, "user_locale", {
        get: /**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var locale = this.locale_id;
            /** @type {?} */
            var locale_tokens = this.locale_id.split('-');
            if (locale_tokens.length == 2) {
                locale = locale_tokens[0];
            }
            /** @type {?} */
            var ret_locale = this.locales[locale];
            if (ret_locale == null) {
                ret_locale = this.locales['en'];
            }
            return ret_locale;
        },
        enumerable: true,
        configurable: true
    });
    PrimeLocaleService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    PrimeLocaleService.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
    ]; };
    /** @nocollapse */ PrimeLocaleService.ngInjectableDef = defineInjectable({ factory: function PrimeLocaleService_Factory() { return new PrimeLocaleService(inject(LOCALE_ID)); }, token: PrimeLocaleService, providedIn: "root" });
    return PrimeLocaleService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/oauth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthService = /** @class */ (function () {
    function OauthService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.base_url = this.configService.api_url + '/oauth/token';
        console.log('OAuth2 base url: ' + this.base_url);
    }
    /**
     * @param {?} username
     * @param {?} password
     * @return {?}
     */
    OauthService.prototype.requestToken = /**
     * @param {?} username
     * @param {?} password
     * @return {?}
     */
    function (username, password) {
        /** @type {?} */
        var url_params = 'client_id=' + encodeURI(this.configService.oauth2_client_id) + '&' +
            'client_secret=' + encodeURI(this.configService.oauth2_client_secret) + '&' +
            'grant_type=password&' +
            'username=' + encodeURI(username) + '&' +
            'password=' + encodeURI(password);
        return this.http.post(this.base_url + '?' + url_params, null)
            .pipe(map((/**
         * @param {?} retValue
         * @return {?}
         */
        function (retValue) {
            return retValue;
        })));
    };
    OauthService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    OauthService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService }
    ]; };
    /** @nocollapse */ OauthService.ngInjectableDef = defineInjectable({ factory: function OauthService_Factory() { return new OauthService(inject(HttpClient), inject(ConfigService)); }, token: OauthService, providedIn: "root" });
    return OauthService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AUTH_TIPO_USUARIO = 'usuario';
/** @type {?} */
var AUTH_TIPO_EMPLEADO = 'empleado';
/** @type {?} */
var SESSION_AUTHENTICATION_KEY = '2befd0c6-9266-4cf1-8f87-2f77b60ec144';
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(oauthService, storage, configService, utilService) {
        this.oauthService = oauthService;
        this.storage = storage;
        this.configService = configService;
        this.utilService = utilService;
        this.jwtHelperService = new JwtHelperService();
        this.authenticationStorage = storage.withDefaultTranscoder(StorageTranscoders.STRING);
        this._authentication$ = new BehaviorSubject((/** @type {?} */ ({})));
        this.session_encrypt_key = this.configService.authentication_session_encrypt_key;
        this.usuarios_url = configService.api_url + '/api/v1/usuarios';
        /** @type {?} */
        var authentication_session = null;
        if (isStorageAvailable(sessionStorage)) {
            authentication_session = this.getAuthenticationSession();
        }
        if (authentication_session == null) {
            this.logout();
        }
        else {
            this._authentication$.next(authentication_session);
        }
    }
    Object.defineProperty(AuthenticationService.prototype, "authentication$", {
        get: /**
         * @return {?}
         */
        function () {
            this.getAuthenticationIntr();
            return this._authentication$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "authentication", {
        get: /**
         * @return {?}
         */
        function () {
            this.getAuthenticationIntr();
            return this._authentication$.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "authUsuario", {
        get: /**
         * @return {?}
         */
        function () {
            return AUTH_TIPO_USUARIO;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "authEmpleado", {
        get: /**
         * @return {?}
         */
        function () {
            return AUTH_TIPO_EMPLEADO;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @return {?}
     */
    AuthenticationService.prototype.getAuthenticationIntr = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var authentication = this._authentication$.getValue();
        if (authentication.token !== null) {
            //Comprobamos que el access token esté vigente
            if (this.jwtHelperService.isTokenExpired(authentication.token.access_token)) {
                //De haber caducado, intentamos renovarlo
                this.logout();
            }
        }
    };
    /**
     * @param {?} usuario
     * @param {?} password
     * @return {?}
     */
    AuthenticationService.prototype.loginUsuario = /**
     * @param {?} usuario
     * @param {?} password
     * @return {?}
     */
    function (usuario, password) {
        return this.login(usuario, password);
    };
    /**
     * @param {?} codigo_empresa
     * @param {?} nif
     * @param {?} codigo_empleado
     * @return {?}
     */
    AuthenticationService.prototype.loginEmpleado = /**
     * @param {?} codigo_empresa
     * @param {?} nif
     * @param {?} codigo_empleado
     * @return {?}
     */
    function (codigo_empresa, nif, codigo_empleado) {
        return this.login(codigo_empresa, nif + ':' + codigo_empleado);
    };
    /**
     * @param {?} empresaSeleccionada
     * @return {?}
     */
    AuthenticationService.prototype.cambiarEmpresaUsuario = /**
     * @param {?} empresaSeleccionada
     * @return {?}
     */
    function (empresaSeleccionada) {
        this._authentication$.getValue().empresa = empresaSeleccionada;
        this.setAuthenticationSession(this._authentication$.getValue());
        this._authentication$.next(this._authentication$.getValue());
    };
    /**
     * @private
     * @param {?} usuario
     * @param {?} password
     * @return {?}
     */
    AuthenticationService.prototype.login = /**
     * @private
     * @param {?} usuario
     * @param {?} password
     * @return {?}
     */
    function (usuario, password) {
        var _this = this;
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.logout();
            _this.oauthService.requestToken(usuario, password).toPromise()
                .then((/**
             * @param {?} token
             * @return {?}
             */
            function (token) {
                /** @type {?} */
                var decodedToken = _this.jwtHelperService.decodeToken(token.access_token);
                /** @type {?} */
                var authentication = (/** @type {?} */ ({
                    token: token,
                    user: null,
                    tipo: null,
                    user_name: decodedToken['user_name'],
                    roles: decodedToken['authorities'],
                    locale: _this.configService.default_locale,
                    empresa: null
                }));
                if (decodedToken['empleado'] != null) {
                    authentication.user = decodedToken['empleado'];
                    authentication.tipo = AUTH_TIPO_EMPLEADO;
                }
                else if (decodedToken['usuario'] != null) {
                    /** @type {?} */
                    var listaEmpresas;
                    listaEmpresas = decodedToken['usuario'].listaEmpresas;
                    authentication.user = decodedToken['usuario'];
                    authentication.tipo = AUTH_TIPO_USUARIO;
                    if (listaEmpresas != null && listaEmpresas.length > 0) {
                        authentication.empresa = listaEmpresas[0];
                    }
                }
                _this.setAuthenticationSession(authentication);
                _this._authentication$.next(authentication);
                resolve(true);
            }))
                .catch((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                if (error.status === 401) {
                    resolve(false);
                }
                else {
                    //Si no es un error de autenticación lanzamos la excepción
                    reject(error);
                }
            }));
        }));
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.logout = /**
     * @return {?}
     */
    function () {
        this.setAuthenticationSession(null);
        /** @type {?} */
        var authentication = (/** @type {?} */ ({
            token: null,
            user: null,
            tipo: null,
            user_name: null,
            roles: null,
            locale: null
        }));
        this._authentication$.next(authentication);
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.isUserLogged = /**
     * @return {?}
     */
    function () {
        return this.authentication.token != null;
    };
    /**
     * @param {?} roles
     * @return {?}
     */
    AuthenticationService.prototype.userHasAnyRole = /**
     * @param {?} roles
     * @return {?}
     */
    function (roles) {
        var e_1, _a;
        if (roles == null) {
            return true;
        }
        /** @type {?} */
        var authentication = this.authentication;
        if (authentication == null || authentication.roles == null) {
            return false;
        }
        try {
            for (var roles_1 = __values(roles), roles_1_1 = roles_1.next(); !roles_1_1.done; roles_1_1 = roles_1.next()) {
                var role = roles_1_1.value;
                if (this.checkIsRoleInList(role, authentication.roles)) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (roles_1_1 && !roles_1_1.done && (_a = roles_1.return)) _a.call(roles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    /**
     * @param {?} roles
     * @return {?}
     */
    AuthenticationService.prototype.userHasAllRoles = /**
     * @param {?} roles
     * @return {?}
     */
    function (roles) {
        var e_2, _a;
        if (roles == null) {
            return true;
        }
        /** @type {?} */
        var authentication = this.authentication;
        if (authentication == null || authentication.roles == null) {
            return false;
        }
        try {
            for (var roles_2 = __values(roles), roles_2_1 = roles_2.next(); !roles_2_1.done; roles_2_1 = roles_2.next()) {
                var role = roles_2_1.value;
                if (!this.checkIsRoleInList(role, authentication.roles)) {
                    return false;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (roles_2_1 && !roles_2_1.done && (_a = roles_2.return)) _a.call(roles_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return true;
    };
    /**
     * @private
     * @param {?} role
     * @param {?} roles
     * @return {?}
     */
    AuthenticationService.prototype.checkIsRoleInList = /**
     * @private
     * @param {?} role
     * @param {?} roles
     * @return {?}
     */
    function (role, roles) {
        /** @type {?} */
        var roles_str = '#' + roles.join('#').toUpperCase() + '#';
        /** @type {?} */
        var rol_str = '#' + role.toUpperCase() + '#';
        return roles_str.indexOf(rol_str) >= 0;
    };
    /**
     * @private
     * @return {?}
     */
    AuthenticationService.prototype.getAuthenticationSession = /**
     * @private
     * @return {?}
     */
    function () {
        try {
            /** @type {?} */
            var authentication = this.authenticationStorage.get(SESSION_AUTHENTICATION_KEY);
            if (authentication == null) {
                return null;
            }
            return JSON.parse(AES.decrypt(authentication, this.session_encrypt_key).toString(enc.Utf8));
        }
        catch (error) {
            console.error(error);
        }
        return null;
    };
    /**
     * @private
     * @param {?} authentication
     * @return {?}
     */
    AuthenticationService.prototype.setAuthenticationSession = /**
     * @private
     * @param {?} authentication
     * @return {?}
     */
    function (authentication) {
        try {
            if (authentication !== null) {
                /** @type {?} */
                var authentication_encrypt = AES.encrypt(JSON.stringify(authentication), this.session_encrypt_key).toString();
                this.authenticationStorage.set(SESSION_AUTHENTICATION_KEY, authentication_encrypt);
            }
            else {
                this.authenticationStorage.remove(SESSION_AUTHENTICATION_KEY);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    /**
     * @return {?}
     */
    AuthenticationService.prototype.getLocale = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var authentication = this.authentication;
        if (authentication == null || authentication.locale == null) {
            return this.configService.default_locale;
        }
        else {
            return authentication.locale;
        }
    };
    AuthenticationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AuthenticationService.ctorParameters = function () { return [
        { type: OauthService },
        { type: undefined, decorators: [{ type: Inject, args: [SESSION_STORAGE,] }] },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ AuthenticationService.ngInjectableDef = defineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(inject(OauthService), inject(SESSION_STORAGE), inject(ConfigService), inject(UtilService)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/empleado.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpleadoService = /** @class */ (function () {
    function EmpleadoService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/empleados';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    EmpleadoService.prototype.getEmpleados = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} empleadosRest
         * @return {?}
         */
        function (empleadosRest) {
            /** @type {?} */
            var empleados = empleadosRest.map((/**
             * @param {?} empleadoRest
             * @return {?}
             */
            function (empleadoRest) {
                return (/** @type {?} */ (empleadoRest));
            }));
            return empleados;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    EmpleadoService.prototype.getEmpleadosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    EmpleadoService.prototype.getOneEmpleado = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getEmpleados(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} empleados
         * @return {?}
         */
        function (empleados) {
            if (empleados == null || empleados.length == 0) {
                return null;
            }
            else {
                return empleados[0];
            }
        })));
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    EmpleadoService.prototype.anyadirEmpleado = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        /** @type {?} */
        var empleado_post = (/** @type {?} */ ({
            nif: empleado.nif,
            idTarjeta: empleado.idTarjeta,
            codigo: empleado.codigo,
            nombre: empleado.nombre,
            apellidos: empleado.apellidos,
            idEmpresa: empleado.idEmpresa,
            verRegistros: empleado.verRegistros,
            localizar_registros: empleado.localizar_registros,
            ficharWeb: empleado.ficharWeb,
            ficharMovil: empleado.ficharMovil,
            ficharTablet: empleado.ficharTablet,
            ficharHuella: empleado.ficharHuella,
            email: empleado.email,
            idCentro: empleado.idCentro,
            idPeriodo: empleado.idPeriodo,
            dedicacionHoras: empleado.dedicacionHoras,
            observaciones: empleado.observaciones,
            diasPorSemana: empleado.diasPorSemana
        }));
        return this.http.post(this.base_url, empleado_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    EmpleadoService.prototype.actualizarEmpleado = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        /** @type {?} */
        var empleado_put = (/** @type {?} */ ({
            id: empleado.id,
            idTarjeta: empleado.idTarjeta,
            nif: empleado.nif,
            codigo: empleado.codigo,
            nombre: empleado.nombre,
            apellidos: empleado.apellidos,
            idEmpresa: empleado.idEmpresa,
            activo: empleado.activo,
            verRegistros: empleado.verRegistros,
            localizar_registros: empleado.localizar_registros,
            ficharWeb: empleado.ficharWeb,
            ficharMovil: empleado.ficharMovil,
            ficharTablet: empleado.ficharTablet,
            ficharHuella: empleado.ficharHuella,
            fecha_modificado: empleado.fecha_modificado,
            email: empleado.email,
            idCentro: empleado.idCentro,
            idPeriodo: empleado.idPeriodo,
            dedicacionHoras: empleado.dedicacionHoras,
            observaciones: empleado.observaciones,
            diasPorSemana: empleado.diasPorSemana
        }));
        return this.http.put(this.base_url + '/' + empleado_put.id, empleado_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idEmpleado
     * @return {?}
     */
    EmpleadoService.prototype.eliminarEmpleado = /**
     * @param {?} idEmpleado
     * @return {?}
     */
    function (idEmpleado) {
        return this.http.delete(this.base_url + '/' + idEmpleado).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    EmpleadoService.prototype.generarCodigo = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/codigo' + url_params)
            .pipe(map((/**
         * @param {?} codigoRest
         * @return {?}
         */
        function (codigoRest) {
            return codigoRest.codigo;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    EmpleadoService.prototype.enviarInfoEmpleado = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/infoEmpleado' + url_params).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    EmpleadoService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EmpleadoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ EmpleadoService.ngInjectableDef = defineInjectable({ factory: function EmpleadoService_Factory() { return new EmpleadoService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: EmpleadoService, providedIn: "root" });
    return EmpleadoService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/block-ui/block-ui.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BlockUiService = /** @class */ (function () {
    function BlockUiService() {
        this._bloquear$ = new BehaviorSubject(false);
    }
    Object.defineProperty(BlockUiService.prototype, "bloquear$", {
        get: /**
         * @return {?}
         */
        function () {
            return this._bloquear$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlockUiService.prototype, "bloquear", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return this._bloquear$.getValue();
        },
        set: /**
         * @private
         * @param {?} bloquear
         * @return {?}
         */
        function (bloquear) {
            this._bloquear$.next(bloquear);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} accion
     * @return {?}
     */
    BlockUiService.prototype.ejecutarConBloqueo = /**
     * @param {?} accion
     * @return {?}
     */
    function (accion) {
        var _this = this;
        /** @type {?} */
        var con_bloqueo = this.inicializarBloqueo();
        accion.then((/**
         * @return {?}
         */
        function () {
            _this.finalizarBloqueo(con_bloqueo);
        })).catch((/**
         * @return {?}
         */
        function () {
            _this.finalizarBloqueo(con_bloqueo);
        }));
    };
    /**
     * @private
     * @return {?}
     */
    BlockUiService.prototype.inicializarBloqueo = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var con_bloqueo = !this.bloquear;
        if (con_bloqueo) {
            this.bloquear = true;
        }
        return con_bloqueo;
    };
    /**
     * @private
     * @param {?} con_bloqueo
     * @return {?}
     */
    BlockUiService.prototype.finalizarBloqueo = /**
     * @private
     * @param {?} con_bloqueo
     * @return {?}
     */
    function (con_bloqueo) {
        if (con_bloqueo) {
            this.bloquear = false;
        }
    };
    BlockUiService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    BlockUiService.ctorParameters = function () { return []; };
    /** @nocollapse */ BlockUiService.ngInjectableDef = defineInjectable({ factory: function BlockUiService_Factory() { return new BlockUiService(); }, token: BlockUiService, providedIn: "root" });
    return BlockUiService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/event-emiter.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EventEmiterService = /** @class */ (function () {
    function EventEmiterService() {
        this._registroActualOnChange = new EventEmitter();
        this._empresaActualOnChange = new EventEmitter();
    }
    Object.defineProperty(EventEmiterService.prototype, "registroActualOnChange", {
        get: /**
         * @return {?}
         */
        function () {
            return this._registroActualOnChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventEmiterService.prototype, "empresaActualOnChange", {
        get: /**
         * @return {?}
         */
        function () {
            return this._empresaActualOnChange;
        },
        enumerable: true,
        configurable: true
    });
    EventEmiterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EventEmiterService.ctorParameters = function () { return []; };
    /** @nocollapse */ EventEmiterService.ngInjectableDef = defineInjectable({ factory: function EventEmiterService_Factory() { return new EventEmiterService(); }, token: EventEmiterService, providedIn: "root" });
    return EventEmiterService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/incidencia/lista-incidencias/lista-incidencias.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaIncidenciasComponent = /** @class */ (function () {
    function ListaIncidenciasComponent(translateService, incidenciaService, primeLocaleService, authenticationService, empleadoService, confirmationService, blockUiService, eventEmiterService) {
        this.translateService = translateService;
        this.incidenciaService = incidenciaService;
        this.primeLocaleService = primeLocaleService;
        this.authenticationService = authenticationService;
        this.empleadoService = empleadoService;
        this.confirmationService = confirmationService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.first_page = 0;
        this.rows_per_page = 10;
        this.empleado_select_items = [];
    }
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.eventEmiterService.empresaActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargaOnInit();
        }));
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.get('app.mensaje.confirmacion').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.mensajeConfirmacion = texto;
        }));
        this.submenu_items = [
            {
                label: '',
                command: (/**
                 * @param {?} event
                 * @return {?}
                 */
                function (event) {
                    _this.mostarDialogoNuevaIncidencia(null);
                })
            }
        ];
        this.translateService.get('app.incidencia.submenu.nueva').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.submenu_items[0].label = texto;
        }));
        this.estado_select_items = [
            { label: '', value: EstadoIncidencia.Pendiente },
            { label: '', value: EstadoIncidencia.Aceptada },
            { label: '', value: EstadoIncidencia.Rechazada }
        ];
        var _loop_1 = function (index) {
            /** @type {?} */
            var select_item = this_1.estado_select_items[index];
            if (select_item.value != null) {
                this_1.translateService.get('app.incidencia.estado.id_' + select_item.value).subscribe((/**
                 * @param {?} texto
                 * @return {?}
                 */
                function (texto) {
                    _this.estado_select_items[index].label = texto;
                }));
            }
        };
        var this_1 = this;
        for (var index in this.estado_select_items) {
            _loop_1(index);
        }
        this.auth_empresa = false;
        this.mostrar_dialogo_nueva_incidencia = false;
        this.lazyLoadEvent = null;
        this.incidencias_loading = false;
        this.incidencias = [];
        this.incidencias_count = 0;
        if (this.authenticationService.authentication.tipo == this.authenticationService.authUsuario) {
            this.cargarEmpleados();
            this.auth_empresa = true;
        }
        this.loadIncidencias();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.loadIncidenciasLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, fecha_reporte_hasta, empresaId, _a, first, rows, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.incidencias_loading = true;
                        this.lazyLoadEvent = event;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 6, 7]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtro_fecha_reporte_desde != null) {
                            filters['fechaReporte:ge'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
                        }
                        if (this.filtro_fecha_reporte_hasta != null) {
                            fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
                            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
                            filters['fechaReporte:lt'] = { value: String(fecha_reporte_hasta.getTime()) };
                        }
                        if (this.filtro_estados != null) {
                            filters['estado:in'] = { value: this.filtro_estados.join(',') };
                        }
                        if (this.filtro_empleados != null) {
                            filters['empleado:in'] = { value: this.filtro_empleados.join(',') };
                        }
                        if (this.auth_empresa) {
                            empresaId = new String(this.authenticationService.authentication.empresa.id);
                            filters['empresa'] = { value: String(empresaId) };
                        }
                        _a = this;
                        return [4 /*yield*/, this.incidenciaService.getIncidenciasCount(filters).toPromise()];
                    case 2:
                        _a.incidencias_count = _c.sent();
                        if (!(this.incidencias_count === 0)) return [3 /*break*/, 3];
                        this.incidencias = [];
                        return [3 /*break*/, 5];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _b = this;
                        return [4 /*yield*/, this.incidenciaService.getIncidencias(filters, null, first, rows)
                                .toPromise()];
                    case 4:
                        _b.incidencias = _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.incidencias_loading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.loadIncidencias = /**
     * @return {?}
     */
    function () {
        this.loadIncidenciasLazy(this.lazyLoadEvent);
    };
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.filtro_fecha_reporte_desde = null;
        this.filtro_fecha_reporte_hasta = null;
        this.filtro_estados = null;
        this.filtro_empleados = null;
        this.loadIncidencias();
    };
    /**
     * @param {?} incidencia
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.mostarDialogoNuevaIncidencia = /**
     * @param {?} incidencia
     * @return {?}
     */
    function (incidencia) {
        var _this = this;
        if (incidencia == null) {
            this.translateService.get('app.incidencia.nuevo').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        else {
            this.translateService.get('app.incidencia.edicion').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        this.incidenciaEdicion = incidencia;
        this.mostrar_dialogo_nueva_incidencia = true;
    };
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.cerrarDialogoNuevaIncidencia = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nueva_incidencia = false;
    };
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.nuevaIncidenciaCreada = /**
     * @return {?}
     */
    function () {
        this.loadIncidencias();
        this.cerrarDialogoNuevaIncidencia();
    };
    /**
     * @private
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.cargarEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.empleado_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() }
        };
        this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            var e_1, _a;
            _this.empleados = listaEmpleados;
            try {
                for (var listaEmpleados_1 = __values(listaEmpleados), listaEmpleados_1_1 = listaEmpleados_1.next(); !listaEmpleados_1_1.done; listaEmpleados_1_1 = listaEmpleados_1.next()) {
                    var empleado = listaEmpleados_1_1.value;
                    _this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado.id });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (listaEmpleados_1_1 && !listaEmpleados_1_1.done && (_a = listaEmpleados_1.return)) _a.call(listaEmpleados_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }));
    };
    /**
     * @param {?} incidencia
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.confirmarEliminar = /**
     * @param {?} incidencia
     * @return {?}
     */
    function (incidencia) {
        var _this = this;
        this.incidenciaEdicion = incidencia;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.eliminarIncidencia();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaIncidenciasComponent.prototype.eliminarIncidencia = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.incidenciaEdicion != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.incidenciaService.eliminarIncidencia(String(this.incidenciaEdicion.id)).toPromise()];
                        case 1:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 3:
                            this.loadIncidencias();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    ListaIncidenciasComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-lista-incidencias',
                    template: "<p-menubar [model]=\"submenu_items\"></p-menubar>\n\n<div id=\"contenido\">\n  <p-panel class=\"filtro_busqueda\" header=\"{{ 'app.filtro' | translate }}\">\n    <div class=\"ui-g\">\n      <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n        <label [translate]=\"'app.filtro.desde'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n        <p-calendar [(ngModel)]=\"filtro_fecha_reporte_desde\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n          [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n        <label [translate]=\"'app.filtro.hasta'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n        <p-calendar [(ngModel)]=\"filtro_fecha_reporte_hasta\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n          [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n        <label>{{ 'app.incidencia.estado' | translate }}</label>\n        <p-multiSelect [(ngModel)]=\"filtro_estados\" [options]=\"estado_select_items\" defaultLabel=\"\"></p-multiSelect>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\" *ngIf=\"auth_empresa\">\n        <label>{{ 'app.filtro.empleado' | translate }}</label>\n        <p-multiSelect [(ngModel)]=\"filtro_empleados\" [options]=\"empleado_select_items\"\n        defaultLabel=\"\" ></p-multiSelect>\n      </div>\n\n      <div class=\"ui-g-12\">\n          <p-footer class=\"botones\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadIncidencias()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n  </p-footer>\n      </div>\n    </div>\n  </p-panel>\n\n  <p-card class=\"texto_centrado\" *ngIf=\"incidencias_loading || incidencias_count == 0\">\n    <i class=\"pi pi-spin pi-spinner\" *ngIf=\"incidencias_loading\"></i>\n    <span *ngIf=\"!incidencias_loading && incidencias_count == 0\">{{ 'app.sin_registros' | translate }}</span>\n  </p-card>\n\n  <div class=\"ui-g\" *ngIf=\"!incidencias_loading && incidencias_count > 0\">\n    <p-card class=\"incidencia ui-g-12\" *ngFor=\"let incidencia of incidencias\">\n      <div class=\"ui-g\">\n        <div class=\"ui-g-2 ui-md-2 ui-lg-2\">\n          <label>{{ 'app.incidencia.empleado' | translate }}</label>\n          <span>{{ incidencia.empleado.nombre }} {{ incidencia.empleado.apellidos }}</span>\n        </div>\n        <div class=\"ui-g-1 ui-md-1 ui-lg-1\">\n          <label>{{ 'app.incidencia.fecha_reporte' | translate }}</label>\n          <span>{{ incidencia.fechaReporte | date: 'dd/MM/yyyy' }}</span>\n        </div>\n\n        <div class=\"{{ incidencia.usuarioModificacion != null ? 'ui-g-1 ui-md-1 ui-lg-1' : 'ui-g-8 ui-md-8 ui-lg-8' }}\">\n          <label>{{ 'app.incidencia.estado' | translate }}</label>\n          <span>{{ 'app.incidencia.estado.id_' + incidencia.estado | translate }}</span>\n        </div>\n        <div class=\"ui-g-4 ui-md-4 ui-lg-2\" *ngIf=\"incidencia.usuarioModificacion != null\">\n          <label>{{ 'app.incidencia.usuarioModificacion' | translate }}</label>\n          <span>{{ incidencia.usuarioModificacion.nombre  }} {{ incidencia.usuarioModificacion.apellidos }}</span>\n        </div>\n        <div class=\"{{ incidencia.usuarioResolucion != null ? 'ui-g-4 ui-md-4 ui-lg-2' : 'ui-g-5 ui-md-5 ui-lg-5' }}\" *ngIf=\"incidencia.fechaModificacion != null\">\n          <label>{{ 'app.incidencia.fechaModificacion' | translate }}</label>\n          <span>{{ incidencia.fechaModificacion | date: 'dd/MM/yyyy HH:mm' }}</span>\n        </div>\n        <div class=\"ui-g-4 ui-md-4 ui-lg-2\" *ngIf=\"incidencia.usuarioResolucion != null\">\n          <label>{{ 'app.incidencia.usuarioResolucion' | translate }}</label>\n          <span>{{ incidencia.usuarioResolucion.nombre }} {{ incidencia.usuarioResolucion.apellidos }}</span>\n        </div>\n        <div class=\"ui-g-1 ui-md-1 ui-lg-1\" *ngIf=\"incidencia.fechaResolucion != null\">\n          <label>{{ 'app.incidencia.fecha_resolucion' | translate }}</label>\n          <span>{{ incidencia.fechaResolucion | date: 'dd/MM/yyyy' }}</span>\n        </div>\n\n        <div class=\"ui-g-1 flotarIzq\" *ngIf=\"auth_empresa\" >\n            <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevaIncidencia(incidencia)\"></button>\n            <button type=\"button\" pButton icon=\"pi pi-trash\" class=\"botonDerecho\" (click)=\"confirmarEliminar(incidencia)\"></button>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-12 ui-lg-12\" *ngIf=\"incidencia.texto != null && incidencia.texto !== ''\">\n          <label>{{ 'app.incidencia.texto' | translate }}</label>\n          <span class=\"multiline\">{{ incidencia.texto }}</span>\n        </div>\n        <div class=\"ui-g-12 ui-md-12 ui-lg-12\" *ngIf=\"incidencia.comentario != null && incidencia.comentario !== ''\">\n          <label>{{ 'app.incidencia.comentario' | translate }}</label>\n          <span class=\"multiline\">{{ incidencia.comentario }}</span>\n        </div>\n\n      </div>\n    </p-card>\n  </div>\n\n  <p-paginator class=\"espaciado_superior\"\n    [rows]=\"rows_per_page\" [totalRecords]=\"incidencias_count\" [templateRight]=\"incidencias_count == 0 ? null : registros\"\n    (onPageChange)=\"loadIncidenciasLazy($event)\"></p-paginator>\n\n  <ng-template #registros>\n    <div [translate]=\"'app.total_registros'\" [translateParams]=\"{ total: incidencias_count}\"></div>\n  </ng-template>\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ tituloDialogo }}\" [contentStyle]=\"{'overflow':'visible'}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [(visible)]=\"mostrar_dialogo_nueva_incidencia\">\n  <core-nueva-incidencia\n    *ngIf=\"mostrar_dialogo_nueva_incidencia\"\n    [incidenciaEdicion]=\"incidenciaEdicion\"\n    (successCallback)=\"nuevaIncidenciaCreada()\"\n    (cancelCallback)=\"cerrarDialogoNuevaIncidencia()\"></core-nueva-incidencia>\n</p-dialog>\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [".flotarIzq{float:left}.botonDerecho{margin-left:1em}"]
                }] }
    ];
    /** @nocollapse */
    ListaIncidenciasComponent.ctorParameters = function () { return [
        { type: TranslateService },
        { type: IncidenciaService },
        { type: PrimeLocaleService },
        { type: AuthenticationService },
        { type: EmpleadoService },
        { type: ConfirmationService },
        { type: BlockUiService },
        { type: EventEmiterService }
    ]; };
    ListaIncidenciasComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaIncidenciasComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/registro.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var TipoRegistro = {
    Entrada: 1,
    Salida: 2,
};
TipoRegistro[TipoRegistro.Entrada] = 'Entrada';
TipoRegistro[TipoRegistro.Salida] = 'Salida';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/sort-by.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var Order = {
    ASC: 1,
    DESC: -1,
};
Order[Order.ASC] = 'ASC';
Order[Order.DESC] = 'DESC';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/registro.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RegistroService = /** @class */ (function () {
    function RegistroService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/registros';
        this.informes_base_url = configService.api_url + '/api/v1/informes';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    RegistroService.prototype.getRegistros = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} registrosRest
         * @return {?}
         */
        function (registrosRest) {
            /** @type {?} */
            var registros = registrosRest.map((/**
             * @param {?} registroRest
             * @return {?}
             */
            function (registroRest) {
                return (/** @type {?} */ (registroRest));
            }));
            return registros;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    RegistroService.prototype.getRegistrosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    RegistroService.prototype.getUltimoRegistro = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var sort_by = [{
                field: 'fecha',
                order: Order.DESC
            },
            {
                field: 'id',
                order: Order.DESC
            }];
        return this.getOneRegistro(filters, sort_by);
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    RegistroService.prototype.getOneRegistro = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getRegistros(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} registros
         * @return {?}
         */
        function (registros) {
            if (registros == null || registros.length == 0) {
                return null;
            }
            else {
                return registros[0];
            }
        })));
    };
    /**
     * @param {?} registro
     * @return {?}
     */
    RegistroService.prototype.anyadirRegistro = /**
     * @param {?} registro
     * @return {?}
     */
    function (registro) {
        /** @type {?} */
        var registro_post = (/** @type {?} */ ({
            idEmpresa: registro.idEmpresa,
            idEmpleado: registro.idEmpleado,
            tipo: registro.tipo,
            subtipo: registro.subtipo,
            localizacion: registro.localizacion,
            fecha: registro.fecha
        }));
        return this.http.post(this.base_url, registro_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} registro
     * @return {?}
     */
    RegistroService.prototype.actualizarRegistro = /**
     * @param {?} registro
     * @return {?}
     */
    function (registro) {
        /** @type {?} */
        var registro_put = (/** @type {?} */ ({
            idEmpresa: registro.idEmpresa,
            idEmpleado: registro.idEmpleado,
            tipo: registro.tipo,
            subtipo: registro.subtipo,
            localizacion: registro.localizacion,
            fecha: registro.fecha,
            id: registro.id,
            fecha_modificado: registro.fecha_modificado,
            sistema: registro.sistema
        }));
        return this.http.put(this.base_url + '/' + registro_put.id, registro_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idRegistro
     * @param {?=} filters
     * @return {?}
     */
    RegistroService.prototype.eliminarRegistro = /**
     * @param {?} idRegistro
     * @param {?=} filters
     * @return {?}
     */
    function (idRegistro, filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.delete(this.base_url + '/' + idRegistro + url_params).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    RegistroService.prototype.getRegistrosInforme = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + '/informe' + url_params)
            .pipe(map((/**
         * @param {?} registrosRest
         * @return {?}
         */
        function (registrosRest) {
            /** @type {?} */
            var registros = registrosRest.map((/**
             * @param {?} registroRest
             * @return {?}
             */
            function (registroRest) {
                return (/** @type {?} */ (registroRest));
            }));
            return registros;
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    RegistroService.prototype.generarInforme = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.informes_base_url + '/empleado' + url_params)
            .pipe(map((/**
         * @param {?} informeRest
         * @return {?}
         */
        function (informeRest) {
            return (/** @type {?} */ (informeRest));
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    RegistroService.prototype.generarInformeTotales = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.informes_base_url + '/totales' + url_params)
            .pipe(map((/**
         * @param {?} informeRest
         * @return {?}
         */
        function (informeRest) {
            return (/** @type {?} */ (informeRest));
        })));
    };
    RegistroService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RegistroService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ RegistroService.ngInjectableDef = defineInjectable({ factory: function RegistroService_Factory() { return new RegistroService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: RegistroService, providedIn: "root" });
    return RegistroService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/registro/grafico-registros/grafico-registros.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GraficoRegistrosComponent = /** @class */ (function () {
    function GraficoRegistrosComponent(registroService, eventEmiterService, authenticationService, primeLocaleService, translateService, locale, _renderer2, _document) {
        this.registroService = registroService;
        this.eventEmiterService = eventEmiterService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.translateService = translateService;
        this.locale = locale;
        this._renderer2 = _renderer2;
        this._document = _document;
        this.mostrar_chart = false;
        this.dataTable = [];
        this.colores = [];
        this.semanaActual = true;
        this.timelineChartData = {
            chartType: 'Timeline',
            dataTable: [],
            options: {
                height: '395',
                width: '90%',
                chartArea: {
                    height: '94%',
                    width: '94%'
                },
                timeline: { rowLabelStyle: { fontName: 'Helvetica', fontSize: 14, color: '#000000' },
                    barLabelStyle: { fontName: 'Helvetica', fontSize: 14 },
                    singleColor: '#00355F' },
                backgroundColor: '#ffd',
                hAxis: {
                    format: 'HH:mm'
                }
            }
        };
        this.listaRegistros = [];
    }
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.eventEmiterService.registroActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargarDatosListaRegistros();
        }));
        this.cargarDatosListaRegistros();
    };
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.recargarSemanaSiguiente = /**
     * @return {?}
     */
    function () {
        this.recargarSemana('S');
    };
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.recargarSemanaAnterior = /**
     * @return {?}
     */
    function () {
        this.recargarSemana('A');
    };
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.recargarSemanaActual = /**
     * @return {?}
     */
    function () {
        this.filtro_fecha_reporte = null;
        this.recargarSemanaBusqueda();
    };
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.recargarSemanaBusqueda = /**
     * @return {?}
     */
    function () {
        if (this.filtro_fecha_reporte != null) {
            this.fechaFiltro = this.filtro_fecha_reporte;
        }
        else {
            this.fechaFiltro = null;
        }
        this.recargarSemana('');
    };
    /**
     * @private
     * @param {?} tipoRecarga
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.recargarSemana = /**
     * @private
     * @param {?} tipoRecarga
     * @return {?}
     */
    function (tipoRecarga) {
        if (this.fechaFiltro == null) {
            this.fechaFiltro = new Date();
        }
        if (tipoRecarga == 'S') {
            this.fechaFiltro.setDate(this.fechaFiltro.getDate() + 7);
        }
        if (tipoRecarga == 'A') {
            this.fechaFiltro.setDate(this.fechaFiltro.getDate() - 7);
        }
        this.cargarDatosListaRegistros();
    };
    /**
     * @private
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.cargarDatosListaRegistros = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.fechaFiltro == null) {
            this.fechaFiltro = new Date();
        }
        this.getWeekArray(this.fechaFiltro);
        /** @type {?} */
        var filters = {
            'fecha:ge': { value: this.fechaInicioSemana.getTime() },
            'fecha:le': { value: this.fechaFinSemana.getTime() }
        };
        //Comprobamos si estamos en la semana actual
        /** @type {?} */
        var fechaActual = new Date();
        if (fechaActual >= this.fechaInicioSemana && fechaActual <= this.fechaFinSemana) {
            this.semanaActual = true;
        }
        else {
            this.semanaActual = false;
        }
        /** @type {?} */
        var sort = (/** @type {?} */ ({}));
        sort.field = 'fecha';
        sort.order = Order.ASC;
        /** @type {?} */
        var listaSort = [];
        listaSort.push(sort);
        this.registroService.getRegistros(filters, listaSort).subscribe((/**
         * @param {?} listaRegistros
         * @return {?}
         */
        function (listaRegistros) {
            _this.listaRegistros = listaRegistros;
            _this.tratarListaRegistros().then((/**
             * @param {?} _
             * @return {?}
             */
            function (_) {
                _this.mostrar_chart = true;
                if (_this.timelineChartData.component != null) {
                    _this.timelineChartData.component.draw();
                }
            }));
        }));
    };
    /**
     * @private
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.tratarListaRegistros = /**
     * @private
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, contador, dataSet, fecha, hora, minutos, segundos, registroSiguiente, fechaSiguiente, horaSiguiente, minutosSiguiente, segundosSiguiente, fechaActual, hoy, manyana, horaActual, minutosActual, segundosActual, diaActual, mesActual, anyoActual, contadorDias, fechaFinSemanaFormatted, textoRegistroActual, _b, _c, registro, difDays, dia, fechaManyana, difDays, dia, fechaManyana, difDays, dia, fechaManyana, difDays, dia, fechaManyana;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        contador = 0;
                        dataSet = [];
                        hoy = new Date();
                        fechaActual = formatDate(hoy, 'dd/MM/yyyy', this.locale);
                        horaActual = formatDate(hoy, 'HH', this.locale);
                        minutosActual = formatDate(hoy, 'mm', this.locale);
                        segundosActual = formatDate(hoy, 'ss', this.locale);
                        diaActual = formatDate(hoy, 'dd', this.locale);
                        mesActual = formatDate(hoy, 'MM', this.locale);
                        anyoActual = formatDate(hoy, 'yyyy', this.locale);
                        return [4 /*yield*/, this.translateService.get('app.registro.actual').toPromise()];
                    case 1:
                        textoRegistroActual = _d.sent();
                        fechaFinSemanaFormatted = formatDate(this.fechaFinSemana, 'dd/MM/yyyy', this.locale);
                        try {
                            for (_b = __values(this.listaRegistros), _c = _b.next(); !_c.done; _c = _b.next()) {
                                registro = _c.value;
                                fecha = formatDate(registro.fecha, 'dd/MM/yyyy', this.locale);
                                hora = formatDate(registro.fecha, 'HH', this.locale);
                                minutos = formatDate(registro.fecha, 'mm', this.locale);
                                segundos = formatDate(registro.fecha, 'ss', this.locale);
                                if (contador <= this.listaRegistros.length - 1) {
                                    if (registro.tipo == TipoRegistro.Entrada) {
                                        //si es el ultimo registro de la semana y es de entrada, no hay registro siguiente
                                        if (contador == this.listaRegistros.length - 1) {
                                            //Si es la semana actual el registro es el registro actual.Se añaden
                                            //tantos registros de entrada y salida como diferencia de dias hata la fecha actual
                                            if (this.semanaActual) {
                                                difDays = this.daysBetween(registro.fecha, hoy.getTime());
                                                contadorDias = 0;
                                                manyana = new Date();
                                                if (difDays == 0) {
                                                    dataSet.push(fecha);
                                                    dataSet.push(textoRegistroActual);
                                                    dataSet.push(new Date(0, 0, 0, hora, minutos, segundos));
                                                    this.dataTable.push(dataSet);
                                                    dataSet = [];
                                                    this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, horaActual, minutosActual, segundosActual));
                                                }
                                                else {
                                                    dataSet.push(fecha);
                                                    dataSet.push('');
                                                    dataSet.push(new Date(0, 0, 0, hora, minutos, segundos));
                                                    this.dataTable.push(dataSet);
                                                    dataSet = [];
                                                    this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                    for (dia = 1; dia <= difDays; dia++) {
                                                        contadorDias = (1000 * 60 * 60 * 24) * dia;
                                                        manyana.setTime(new Date(registro.fecha + contadorDias));
                                                        fechaManyana = formatDate(manyana, 'dd/MM/yyyy', this.locale);
                                                        dataSet.push(fechaManyana);
                                                        if (dia == difDays) {
                                                            dataSet.push(textoRegistroActual);
                                                        }
                                                        else {
                                                            dataSet.push('');
                                                        }
                                                        dataSet.push(new Date(0, 0, 0, 0, 0, 1));
                                                        this.dataTable.push(dataSet);
                                                        dataSet = [];
                                                        if (dia == difDays) {
                                                            //Si ya es el dia del registro siguiente se añade el registro actual
                                                            this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, horaActual, minutosActual, segundosActual));
                                                        }
                                                        else {
                                                            //Si no es el dia del registro siguente se añade un registro de todo el día
                                                            this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                //Si no es la semana actual se añaden
                                                dataSet.push(fecha);
                                                dataSet.push('');
                                                dataSet.push(new Date(0, 0, 0, hora, minutos, segundos));
                                                this.dataTable.push(dataSet);
                                                dataSet = [];
                                                this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                if (fecha != fechaFinSemanaFormatted) {
                                                    //Si es el registro es del último día de la semana se añade uno de salida a las 24:00
                                                    difDays = this.daysBetween(registro.fecha, this.fechaFinSemana.getTime());
                                                    contadorDias = 0;
                                                    for (dia = 1; dia <= difDays; dia++) {
                                                        contadorDias = (1000 * 60 * 60 * 24) * dia;
                                                        manyana.setTime(new Date(registro.fecha + contadorDias));
                                                        fechaManyana = formatDate(manyana, 'dd/MM/yyyy', this.locale);
                                                        dataSet.push(fechaManyana);
                                                        dataSet.push('');
                                                        dataSet.push("");
                                                        dataSet.push(new Date(0, 0, 0, 0, 0, 1));
                                                        this.dataTable.push(dataSet);
                                                        dataSet = [];
                                                        this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            registroSiguiente = this.listaRegistros[contador + 1];
                                            fechaSiguiente = formatDate(registroSiguiente.fecha, 'dd/MM/yyyy', this.locale);
                                            horaSiguiente = formatDate(registroSiguiente.fecha, 'HH', this.locale);
                                            minutosSiguiente = formatDate(registroSiguiente.fecha, 'mm', this.locale);
                                            segundosSiguiente = formatDate(registroSiguiente.fecha, 'ss', this.locale);
                                            if (registroSiguiente.tipo == TipoRegistro.Salida) {
                                                dataSet.push(fecha);
                                                dataSet.push('');
                                                dataSet.push(new Date(0, 0, 0, hora, minutos, segundos));
                                                this.dataTable.push(dataSet);
                                                dataSet = [];
                                                //Se comprueba si el registro siguente es del mismo día
                                                if (fecha != fechaSiguiente) {
                                                    //Entrada y salida en distintos días
                                                    //Nuevo registro de salida a las 23:59:59
                                                    this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                    //var diff = Math.abs(registroSiguiente.fecha - registro.fecha);
                                                    //var difDays = Math.ceil(diff / (1000 * 3600 * 24));
                                                    difDays = this.daysBetween(registro.fecha, registroSiguiente.fecha);
                                                    manyana = new Date();
                                                    contadorDias = 0;
                                                    for (dia = 1; dia <= difDays; dia++) {
                                                        contadorDias = (1000 * 60 * 60 * 24) * dia;
                                                        manyana.setTime(new Date(registro.fecha + contadorDias));
                                                        fechaManyana = formatDate(manyana, 'dd/MM/yyyy', this.locale);
                                                        dataSet.push(fechaManyana);
                                                        dataSet.push("");
                                                        dataSet.push(new Date(0, 0, 0, 0, 0, 1));
                                                        this.dataTable.push(dataSet);
                                                        dataSet = [];
                                                        if (dia == difDays) {
                                                            //Si ya es el dia del registro siguiente se añade el registro actual
                                                            this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, horaSiguiente, minutosSiguiente, segundosSiguiente));
                                                        }
                                                        else {
                                                            //Si no es el dia del registro siguente se añade un registro de todo el día
                                                            this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                        }
                                                    }
                                                }
                                                else {
                                                    this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, horaSiguiente, minutosSiguiente, segundosSiguiente));
                                                }
                                            }
                                            else {
                                                //Si hay dos registros de entrada seguidos, se coge el ultimo
                                                this.dataTable = this.dataTable.slice(0, this.dataTable.length - 1);
                                            }
                                        }
                                    }
                                    else {
                                        if (contador == 0) {
                                            // Si es el primer registro de la semana y es de salida
                                            fechaSiguiente = formatDate(this.fechaInicioSemana, 'dd/MM/yyyy', this.locale);
                                            dataSet.push(fechaSiguiente);
                                            dataSet.push("");
                                            dataSet.push(new Date(0, 0, 0, 0, 0, 1));
                                            this.dataTable.push(dataSet);
                                            dataSet = [];
                                            //Si el registro de salida es del mismo dia del inicio de semana se añade el registro de salida
                                            if (fecha == fechaSiguiente) {
                                                this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, hora, minutos, segundos));
                                            }
                                            else {
                                                this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                difDays = this.daysBetween(this.fechaInicioSemana.getTime(), registro.fecha);
                                                manyana = new Date();
                                                contadorDias = 0;
                                                for (dia = 1; dia <= difDays; dia++) {
                                                    contadorDias = (1000 * 60 * 60 * 24) * dia;
                                                    manyana.setTime(new Date(this.fechaInicioSemana.getTime() + contadorDias));
                                                    fechaManyana = formatDate(manyana, 'dd/MM/yyyy', this.locale);
                                                    dataSet.push(fechaManyana);
                                                    dataSet.push("");
                                                    dataSet.push(new Date(0, 0, 0, 0, 0, 1));
                                                    this.dataTable.push(dataSet);
                                                    dataSet = [];
                                                    if (dia == difDays) {
                                                        //Si ya es el dia del registro siguiente se añade el registro actual
                                                        this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, hora, minutos, segundos));
                                                    }
                                                    else {
                                                        //Si no es el dia del registro siguente se añade un registro de todo el día
                                                        this.dataTable[this.dataTable.length - 1].push(new Date(0, 0, 0, 23, 59, 59));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                contador++;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.timelineChartData.dataTable = this.dataTable;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @private
     * @param {?} fechaFiltroParam
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.getWeekArray = /**
     * @private
     * @param {?} fechaFiltroParam
     * @return {?}
     */
    function (fechaFiltroParam) {
        /** @type {?} */
        var fechaSem = new Date(fechaFiltroParam);
        /** @type {?} */
        var day = fechaFiltroParam.getDay();
        /** @type {?} */
        var fecha;
        /** @type {?} */
        var fechaFormat;
        /** @type {?} */
        var diff;
        /** @type {?} */
        var dataSet = [];
        /** @type {?} */
        var columnas = [];
        columnas.push('Fecha');
        columnas.push('Registro');
        columnas.push('Inicio');
        columnas.push('Fin');
        this.dataTable = [];
        this.dataTable.push(columnas);
        for (var i = 0; i < 7; i++) {
            fechaSem = new Date(fechaFiltroParam);
            diff = fechaSem.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
            fecha = new Date(fechaSem.setDate(diff + i));
            if (i == 0) {
                this.fechaInicioSemana = fecha;
                this.fechaInicioSemana.setHours(0, 0, 0);
            }
            if (i == 6) {
                this.fechaFinSemana = fecha;
                this.fechaFinSemana.setHours(23, 59, 59);
            }
            fechaFormat = formatDate(fecha, 'dd/MM/yyyy', this.locale);
            dataSet.push(fechaFormat);
            dataSet.push('');
            dataSet.push(new Date(0, 0, 0, 0, 0, 1));
            dataSet.push(new Date(0, 0, 0, 0, 0, 1));
            this.dataTable.push(dataSet);
            dataSet = [];
            dataSet.push(fechaFormat);
            dataSet.push('');
            dataSet.push(new Date(0, 0, 0, 23, 59, 59));
            dataSet.push(new Date(0, 0, 0, 23, 59, 59));
            this.dataTable.push(dataSet);
            dataSet = [];
        }
    };
    /**
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.eliminarRegistros = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var listaRects = this.grafico.nativeElement.getElementsByTagName("rect");
        //set a large initial value to width
        /** @type {?} */
        var elToRem = [];
        /** @type {?} */
        var xMax = 0;
        for (var i = 0; i < listaRects.length; i++) { //looping over all the rect element of container
            //looping over all the rect element of container
            /** @type {?} */
            var coordX = parseInt(listaRects[i].getAttribute("x"));
            //getting the width of ith element
            /** @type {?} */
            var width = parseInt(listaRects[i].getAttribute("width"));
            //Eliminamos los primeros registros de la semana
            if (coordX < 97 && coordX > 0 && width == 3) { //if current element width is less than previous width then this is min. width and ith element should be removed
                elToRem.push(listaRects[i]);
            }
            if (coordX > xMax) {
                xMax = coordX;
            }
        }
        for (var i = 0; i < listaRects.length; i++) { //looping over all the rect element of container
            //looping over all the rect element of container
            /** @type {?} */
            var coordX = parseInt(listaRects[i].getAttribute("x"));
            //getting the width of ith element
            /** @type {?} */
            var width = parseInt(listaRects[i].getAttribute("width"));
            //Eliminamos los ultimos registros de la semana
            if (coordX == xMax && width == 3) { //if current element width is less than previous width then this is min. width and ith element should be removed
                elToRem.push(listaRects[i]);
            }
        }
        for (var i = 0; i < elToRem.length; i++) { // now iterate JUST the elements to remove
            elToRem[i].setAttribute("fill", "none"); //make invisible all the rect element which has minimum width
        }
    };
    /**
     * @private
     * @param {?} d1
     * @param {?} d2
     * @return {?}
     */
    GraficoRegistrosComponent.prototype.daysBetween = /**
     * @private
     * @param {?} d1
     * @param {?} d2
     * @return {?}
     */
    function (d1, d2) {
        /** @type {?} */
        var dias;
        /** @type {?} */
        var fechaD1 = new Date();
        fechaD1.setTime(d1);
        /** @type {?} */
        var fechaD2 = new Date();
        fechaD2.setTime(d2);
        /** @type {?} */
        var diaD1 = fechaD1.getDate();
        /** @type {?} */
        var diaD2 = fechaD2.getDate();
        dias = diaD2 - diaD1;
        if (diaD2 < diaD1) {
            return diaD2;
        }
        else {
            return dias;
        }
    };
    GraficoRegistrosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-grafico-registros',
                    template: "\n<div id=\"contenido\">\n  <p-panel class=\"filtro_busqueda\" header=\"{{ 'app.filtro' | translate }}\">\n    <div class=\"ui-g\">\n      <div class=\"ui-g-12 ui-md-4 ui-lg-2\">\n        <label [translate]=\"'app.filtro.desde'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n        <p-calendar [(ngModel)]=\"filtro_fecha_reporte\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\" \n          [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n      </div>\n      <div class=\"ui-g-4 searchButtonReg\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"recargarSemanaBusqueda()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n      </div>\n    </div>\n  </p-panel>\n  <google-chart #grafico [data]=\"timelineChartData\" (chartReady)=\"eliminarRegistros()\" *ngIf=\"mostrar_chart\"></google-chart>\n  <div class=\"ui-g-12 divButtonCenter\">\n    <button type=\"button\" pButton icon=\"pi pi-angle-double-left\" (click)=\"recargarSemanaAnterior()\" ></button>\n    <button type=\"button\" pButton icon=\"pi pi-replay\" (click)=\"recargarSemanaActual()\" class=\"buttonMarginLeft\"></button>\n    <button type=\"button\" pButton icon=\"pi pi-angle-double-right\" (click)=\"recargarSemanaSiguiente()\" class=\"buttonMarginLeft\"></button>\n  </div>\n</div>\n",
                    styles: [".divButtonCenter{padding-left:45%}.buttonMarginLeft{margin-left:1em}.searchButtonReg{padding-top:1.8em}"]
                }] }
    ];
    /** @nocollapse */
    GraficoRegistrosComponent.ctorParameters = function () { return [
        { type: RegistroService },
        { type: EventEmiterService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: TranslateService },
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
        { type: Renderer2 },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    GraficoRegistrosComponent.propDecorators = {
        grafico: [{ type: ViewChild, args: ["grafico", { read: ElementRef },] }]
    };
    return GraficoRegistrosComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/form.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormService = /** @class */ (function () {
    function FormService(translateService, messageService) {
        this.translateService = translateService;
        this.messageService = messageService;
    }
    /**
     * @param {?} form
     * @param {?} property_prepend
     * @param {?=} successCallback
     * @param {?=} errorCallback
     * @return {?}
     */
    FormService.prototype.onSubmitFormValidation = /**
     * @param {?} form
     * @param {?} property_prepend
     * @param {?=} successCallback
     * @param {?=} errorCallback
     * @return {?}
     */
    function (form, property_prepend, successCallback, errorCallback) {
        this.messageService.clear();
        if (form.valid) {
            if (successCallback != null) {
                successCallback();
            }
        }
        else {
            this.showFormValidationErrors(form, property_prepend);
            if (errorCallback != null) {
                errorCallback();
            }
        }
    };
    /**
     * @param {?} form
     * @param {?} property_prepend
     * @return {?}
     */
    FormService.prototype.showFormValidationErrors = /**
     * @param {?} form
     * @param {?} property_prepend
     * @return {?}
     */
    function (form, property_prepend) {
        var _this = this;
        Object.keys(form.controls).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            /** @type {?} */
            var controlErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach((/**
                 * @param {?} keyError
                 * @return {?}
                 */
                function (keyError) {
                    if (controlErrors[keyError]) {
                        console.log('Key control: ' + property_prepend + key + ', keyError: ' + keyError);
                        console.log(controlErrors[keyError]);
                        _this.translateService.get(property_prepend + key).subscribe((/**
                         * @param {?} resProperty
                         * @return {?}
                         */
                        function (resProperty) {
                            /** @type {?} */
                            var resArguments = {
                                nombre: resProperty,
                                validacion: controlErrors[keyError]
                            };
                            _this.translateService.get('app.error.' + keyError, resArguments).subscribe((/**
                             * @param {?} resMessage
                             * @return {?}
                             */
                            function (resMessage) {
                                _this.messageService.add({
                                    severity: 'error',
                                    summary: resMessage
                                });
                            }));
                        }));
                    }
                }));
            }
        }));
        if (form.errors != null) {
            Object.keys(form.errors).forEach((/**
             * @param {?} keyError
             * @return {?}
             */
            function (keyError) {
                if (form.errors[keyError]) {
                    console.log('keyError: ' + keyError);
                    console.log(form.errors[keyError]);
                    /** @type {?} */
                    var resArguments = {
                        validacion: form.errors[keyError]
                    };
                    _this.translateService.get('app.error.' + keyError, resArguments).subscribe((/**
                     * @param {?} resMessage
                     * @return {?}
                     */
                    function (resMessage) {
                        _this.messageService.add({
                            severity: 'error',
                            summary: resMessage
                        });
                    }));
                }
            }));
        }
    };
    /**
     * @return {?}
     */
    FormService.prototype.decimalValidator = /**
     * @return {?}
     */
    function () {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (control.value == null) {
                return null;
            }
            /** @type {?} */
            var numberValue = Number(control.value);
            return !Number.isNaN(numberValue) ? null : { 'numero': { actualValue: control.value } };
        });
    };
    FormService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FormService.ctorParameters = function () { return [
        { type: TranslateService },
        { type: MessageService }
    ]; };
    /** @nocollapse */ FormService.ngInjectableDef = defineInjectable({ factory: function FormService_Factory() { return new FormService(inject(TranslateService), inject(MessageService$1)); }, token: FormService, providedIn: "root" });
    return FormService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/incidencia/nueva-incidencia/nueva-incidencia.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevaIncidenciaComponent = /** @class */ (function () {
    function NuevaIncidenciaComponent(formBuilder, blockUiService, formService, incidenciaService, translateService, authenticationService, empleadoService, primeLocaleService) {
        this.formBuilder = formBuilder;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.incidenciaService = incidenciaService;
        this.translateService = translateService;
        this.authenticationService = authenticationService;
        this.empleadoService = empleadoService;
        this.primeLocaleService = primeLocaleService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.empleado_select_items = [];
    }
    /**
     * @return {?}
     */
    NuevaIncidenciaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.auth_empresa = false;
        this.edicion = false;
        this.incidencia_resuelta = false;
        if (this.incidenciaEdicion != null) {
            this.auth_empresa = true;
            this.edicion = true;
            /*  if(this.incidenciaEdicion.estado != EstadoIncidencia.Pendiente){
                this.incidencia_resuelta = true;
              }*/
        }
        this.incidencia_form = this.formBuilder.group({
            id: new FormControl(null),
            texto: new FormControl({ value: '', disabled: this.auth_empresa }, [
                Validators.required,
                Validators.maxLength(1024)
            ]),
            comentario: new FormControl(null, [
                Validators.maxLength(1024)
            ]),
            estado: new FormControl({ value: null, disabled: this.incidencia_resuelta }),
            fecha_resolucion: new FormControl(null),
            empleado: new FormControl(null)
        });
        if (this.incidenciaEdicion != null) {
            this.incidencia_form.controls['texto'].setValue(this.incidenciaEdicion.texto);
            this.incidencia_form.controls['estado'].setValue(this.incidenciaEdicion.estado);
            /** @type {?} */
            var fechaResolucion = null;
            if (this.incidenciaEdicion.fechaResolucion != null) {
                fechaResolucion = new Date(this.incidenciaEdicion.fechaResolucion);
            }
            this.incidencia_form.controls['fecha_resolucion'].setValue(fechaResolucion);
            this.incidencia_form.controls['comentario'].setValue(this.incidenciaEdicion.comentario);
            this.auth_empresa = true;
            this.estado_select_items = [
                { label: '', value: EstadoIncidencia.Pendiente },
                { label: '', value: EstadoIncidencia.Aceptada },
                { label: '', value: EstadoIncidencia.Rechazada }
            ];
            var _loop_1 = function (index) {
                /** @type {?} */
                var select_item = this_1.estado_select_items[index];
                if (select_item.value != null) {
                    this_1.translateService.get('app.incidencia.estado.id_' + select_item.value).subscribe((/**
                     * @param {?} texto
                     * @return {?}
                     */
                    function (texto) {
                        _this.estado_select_items[index].label = texto;
                    }));
                }
            };
            var this_1 = this;
            for (var index in this.estado_select_items) {
                _loop_1(index);
            }
        }
        else {
            if (this.authenticationService.authentication.tipo == this.authenticationService.authUsuario) {
                this.auth_empresa = true;
                this.edicion = false;
                this.cargarEmpleados();
            }
        }
    };
    /**
     * @return {?}
     */
    NuevaIncidenciaComponent.prototype.crearIncidencia = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.formService.onSubmitFormValidation(_this.incidencia_form, 'app.incidencia.', (/**
             * @return {?}
             */
            function () {
                if (_this.incidenciaEdicion != null) {
                    /** @type {?} */
                    var incidencia = (/** @type {?} */ ({
                        fechaResolucion: _this.incidencia_form.controls['fecha_resolucion'].value,
                        estado: _this.incidencia_form.controls['estado'].value,
                        comentario: _this.incidencia_form.controls['comentario'].value,
                        texto: _this.incidencia_form.controls['texto'].value,
                        id: _this.incidenciaEdicion.id,
                        empleado: _this.incidenciaEdicion.empleado
                    }));
                    _this.incidenciaService.actualizarIncidencia(incidencia).toPromise().then((/**
                     * @return {?}
                     */
                    function () {
                        _this.successCallback.emit(null);
                        resolve();
                    })).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject();
                    }));
                }
                else {
                    /** @type {?} */
                    var incidencia = (/** @type {?} */ ({
                        texto: _this.incidencia_form.controls['texto'].value,
                        empleado: _this.empleado
                    }));
                    _this.incidenciaService.anyadirIncidencia(_this.incidencia_form.value).toPromise().then((/**
                     * @return {?}
                     */
                    function () {
                        _this.successCallback.emit(null);
                        resolve();
                    })).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject();
                    }));
                }
            }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
    };
    /**
     * @return {?}
     */
    NuevaIncidenciaComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    /**
     * @private
     * @return {?}
     */
    NuevaIncidenciaComponent.prototype.cargarEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.empleado_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() }
        };
        this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            var e_1, _a;
            try {
                for (var listaEmpleados_1 = __values(listaEmpleados), listaEmpleados_1_1 = listaEmpleados_1.next(); !listaEmpleados_1_1.done; listaEmpleados_1_1 = listaEmpleados_1.next()) {
                    var empleado = listaEmpleados_1_1.value;
                    _this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (listaEmpleados_1_1 && !listaEmpleados_1_1.done && (_a = listaEmpleados_1.return)) _a.call(listaEmpleados_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }));
    };
    NuevaIncidenciaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-nueva-incidencia',
                    template: "<form [formGroup]=\"incidencia_form\" (ngSubmit)=\"crearIncidencia()\">\n  <div class=\"ui-g\">\n    <div class=\"ui-g-12\" *ngIf=\"auth_empresa && !edicion\">\n      <label>{{ 'app.incidencia.empleado' | translate }} *</label>\n      <p-dropdown [options]=\"empleado_select_items\" formControlName=\"empleado\"></p-dropdown>\n    </div>\n    <div class=\"ui-g-12\" *ngIf=\"auth_empresa && edicion\">\n      <label>{{ 'app.incidencia.estado' | translate }} *</label>\n      <p-dropdown [options]=\"estado_select_items\" formControlName=\"estado\"></p-dropdown>\n    </div>\n    <!-- <div class=\"ui-g-12\" *ngIf=\"auth_empresa && edicion && !incidencia_resuelta\"> -->\n    <div class=\"ui-g-12\" *ngIf=\"auth_empresa && edicion\">\n      <label>{{ 'app.incidencia.fecha_resolucion' | translate }} *</label>\n      <p-calendar formControlName=\"fecha_resolucion\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n      [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n  </div>\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.incidencia.texto' | translate }} *</label>\n      <textarea [rows]=\"8\" formControlName=\"texto\" pInputTextarea ></textarea>\n    </div>\n    <div class=\"ui-g-12\" *ngIf=\"auth_empresa && edicion\">\n      <label>{{ 'app.incidencia.comentario' | translate }} *</label>\n      <textarea [rows]=\"8\" formControlName=\"comentario\" pInputTextarea ></textarea>\n    </div>\n  </div>\n\n  <p-footer class=\"botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\"></button>\n  </p-footer>\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NuevaIncidenciaComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: BlockUiService },
        { type: FormService },
        { type: IncidenciaService },
        { type: TranslateService },
        { type: AuthenticationService },
        { type: EmpleadoService },
        { type: PrimeLocaleService }
    ]; };
    NuevaIncidenciaComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }],
        incidenciaEdicion: [{ type: Input }]
    };
    return NuevaIncidenciaComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/icono.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconoService = /** @class */ (function () {
    function IconoService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/iconos';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    IconoService.prototype.getIconos = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} iconosRest
         * @return {?}
         */
        function (iconosRest) {
            /** @type {?} */
            var iconos = iconosRest.map((/**
             * @param {?} iconoRest
             * @return {?}
             */
            function (iconoRest) {
                return (/** @type {?} */ (iconoRest));
            }));
            return iconos;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    IconoService.prototype.getIconosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @param {?} id
     * @param {?=} eliminado
     * @return {?}
     */
    IconoService.prototype.getIcono = /**
     * @param {?} id
     * @param {?=} eliminado
     * @return {?}
     */
    function (id, eliminado) {
        if (eliminado === void 0) { eliminado = null; }
        /** @type {?} */
        var url_params = '';
        if (eliminado != null) {
            url_params += '?eliminado=' + eliminado;
        }
        return this.http.get(this.base_url + '/' + id + url_params)
            .pipe(map((/**
         * @param {?} iconoRest
         * @return {?}
         */
        function (iconoRest) {
            return (/** @type {?} */ (iconoRest));
        })));
    };
    IconoService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    IconoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ IconoService.ngInjectableDef = defineInjectable({ factory: function IconoService_Factory() { return new IconoService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: IconoService, providedIn: "root" });
    return IconoService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/subtipo_registro.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SubtipoRegistroService = /** @class */ (function () {
    function SubtipoRegistroService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/tipos_registro';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    SubtipoRegistroService.prototype.getTiposRegistro = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} subtiposRegistroRest
         * @return {?}
         */
        function (subtiposRegistroRest) {
            /** @type {?} */
            var subtiposRegistro = subtiposRegistroRest.map((/**
             * @param {?} subtipoRegistroRest
             * @return {?}
             */
            function (subtipoRegistroRest) {
                return (/** @type {?} */ (subtipoRegistroRest));
            }));
            return subtiposRegistro;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    SubtipoRegistroService.prototype.getTiposRegistroCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @param {?} subtipoRegistro
     * @return {?}
     */
    SubtipoRegistroService.prototype.guardarTipoRegistro = /**
     * @param {?} subtipoRegistro
     * @return {?}
     */
    function (subtipoRegistro) {
        if (subtipoRegistro.id == null || subtipoRegistro.id <= 0) {
            return this.anyadirTipoRegistro(subtipoRegistro);
        }
        else {
            return this.actualizarTipoRegistro(subtipoRegistro);
        }
    };
    /**
     * @private
     * @param {?} subtipoRegistro
     * @return {?}
     */
    SubtipoRegistroService.prototype.anyadirTipoRegistro = /**
     * @private
     * @param {?} subtipoRegistro
     * @return {?}
     */
    function (subtipoRegistro) {
        /** @type {?} */
        var subtipo_registro_post = (/** @type {?} */ ({
            empresa: subtipoRegistro.empresa,
            icono: subtipoRegistro.icono,
            nombre: subtipoRegistro.nombre
        }));
        return this.http.post(this.base_url, subtipo_registro_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @private
     * @param {?} subtipoRegistro
     * @return {?}
     */
    SubtipoRegistroService.prototype.actualizarTipoRegistro = /**
     * @private
     * @param {?} subtipoRegistro
     * @return {?}
     */
    function (subtipoRegistro) {
        /** @type {?} */
        var subtipo_registro_put = (/** @type {?} */ ({
            id: subtipoRegistro.id,
            empresa: subtipoRegistro.empresa,
            icono: subtipoRegistro.icono,
            nombre: subtipoRegistro.nombre,
            activo: subtipoRegistro.activo,
            fecha_modificado: subtipoRegistro.fecha_modificado
        }));
        return this.http.put(this.base_url + '/' + subtipoRegistro.id, subtipo_registro_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idSubtipoRegistro
     * @return {?}
     */
    SubtipoRegistroService.prototype.eliminarTipoRegistro = /**
     * @param {?} idSubtipoRegistro
     * @return {?}
     */
    function (idSubtipoRegistro) {
        return this.http.delete(this.base_url + '/' + idSubtipoRegistro).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} id
     * @param {?=} eliminado
     * @return {?}
     */
    SubtipoRegistroService.prototype.getSubtipoRegistro = /**
     * @param {?} id
     * @param {?=} eliminado
     * @return {?}
     */
    function (id, eliminado) {
        if (eliminado === void 0) { eliminado = null; }
        /** @type {?} */
        var url_params = '';
        if (eliminado != null) {
            url_params += '?eliminado=' + eliminado;
        }
        return this.http.get(this.base_url + '/' + id + url_params)
            .pipe(map((/**
         * @param {?} subtipoRegistroRest
         * @return {?}
         */
        function (subtipoRegistroRest) {
            return (/** @type {?} */ (subtipoRegistroRest));
        })));
    };
    SubtipoRegistroService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SubtipoRegistroService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ SubtipoRegistroService.ngInjectableDef = defineInjectable({ factory: function SubtipoRegistroService_Factory() { return new SubtipoRegistroService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: SubtipoRegistroService, providedIn: "root" });
    return SubtipoRegistroService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/centro.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CentroService = /** @class */ (function () {
    function CentroService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/centros';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    CentroService.prototype.getCentros = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} centrosRest
         * @return {?}
         */
        function (centrosRest) {
            /** @type {?} */
            var centros = centrosRest.map((/**
             * @param {?} centroRest
             * @return {?}
             */
            function (centroRest) {
                return (/** @type {?} */ (centroRest));
            }));
            return centros;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    CentroService.prototype.getCentrosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    CentroService.prototype.getOneCentro = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getCentros(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} centros
         * @return {?}
         */
        function (centros) {
            if (centros == null || centros.length == 0) {
                return null;
            }
            else {
                return centros[0];
            }
        })));
    };
    /**
     * @param {?} centro
     * @return {?}
     */
    CentroService.prototype.anyadirCentro = /**
     * @param {?} centro
     * @return {?}
     */
    function (centro) {
        /** @type {?} */
        var centro_post = (/** @type {?} */ ({
            nombre: centro.nombre,
            empresa: centro.empresa
        }));
        return this.http.post(this.base_url, centro_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} centro
     * @return {?}
     */
    CentroService.prototype.actualizarCentro = /**
     * @param {?} centro
     * @return {?}
     */
    function (centro) {
        /** @type {?} */
        var centro_put = (/** @type {?} */ ({
            id: centro.id,
            nombre: centro.nombre,
            empresa: centro.empresa,
            activo: centro.activo
        }));
        return this.http.put(this.base_url + '/' + centro_put.id, centro_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idCentro
     * @return {?}
     */
    CentroService.prototype.eliminarCentro = /**
     * @param {?} idCentro
     * @return {?}
     */
    function (idCentro) {
        return this.http.delete(this.base_url + '/' + idCentro).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    CentroService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    CentroService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ CentroService.ngInjectableDef = defineInjectable({ factory: function CentroService_Factory() { return new CentroService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: CentroService, providedIn: "root" });
    return CentroService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/registro/lista-registros/lista-registros.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaRegistrosComponent = /** @class */ (function () {
    function ListaRegistrosComponent(registroService, empleadoService, iconoService, subtipoRegistroService, authenticationService, primeLocaleService, confirmationService, translateService, blockUiService, eventEmiterService, datePipe, centroService) {
        this.registroService = registroService;
        this.empleadoService = empleadoService;
        this.iconoService = iconoService;
        this.subtipoRegistroService = subtipoRegistroService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.datePipe = datePipe;
        this.centroService = centroService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.subscription = [];
        this.empleado_select_items = [];
        this.empleados_numero = 10;
    }
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.registros_mostrar_columna_tipo = false;
        this.mapa_layers = [];
        this.mapa_zoom = 17;
        this.mapa_center = latLng(39.9848969, -0.0321465);
        this.translateService.get('app.mapa.leyenda').subscribe((/**
         * @param {?} texto_leyenda
         * @return {?}
         */
        function (texto_leyenda) {
            _this.mapa_options = {
                layers: [
                    tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: texto_leyenda })
                ],
                zoom: _this.mapa_zoom,
                center: _this.mapa_center
            };
        }));
        this.estado_select_items = [
            { label: '', value: 1 },
            { label: '', value: 0 }
        ];
        var _loop_1 = function (index) {
            /** @type {?} */
            var select_item = this_1.estado_select_items[index];
            if (select_item.value != null) {
                this_1.translateService.get('app.empleado.estado.id_' + select_item.value).subscribe((/**
                 * @param {?} texto
                 * @return {?}
                 */
                function (texto) {
                    _this.estado_select_items[index].label = texto;
                }));
            }
        };
        var this_1 = this;
        for (var index in this.estado_select_items) {
            _loop_1(index);
        }
        this.eventEmiterService.empresaActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargaOnInit();
        }));
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.empleados_count = 0;
        this.lazyLoadEvent = null;
        this.registros_loading = false;
        this.conectado_loading = false;
        this.limpiarBusqueda();
        this.cargarSubtiposRegistro();
        this.loadCentros();
        this.translateService.get('app.mensaje.confirmacion').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.mensajeConfirmacion = texto;
        }));
        this.disable_nuevo_registro = true;
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.onSort = /**
     * @return {?}
     */
    function () {
        this.updateRowGroupMetaData();
    };
    /**
     * @private
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarSubtiposRegistro = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.subtipos_registro_map = {};
        this.subtipos_select_items = [];
        this.iconos_map = {};
        this.subtipoRegistroService.getTiposRegistro().subscribe((/**
         * @param {?} subtipos_registro
         * @return {?}
         */
        function (subtipos_registro) {
            var e_1, _a;
            try {
                for (var subtipos_registro_1 = __values(subtipos_registro), subtipos_registro_1_1 = subtipos_registro_1.next(); !subtipos_registro_1_1.done; subtipos_registro_1_1 = subtipos_registro_1.next()) {
                    var subtipo_registro = subtipos_registro_1_1.value;
                    _this.cargarSubtipoRegistro(subtipo_registro);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (subtipos_registro_1_1 && !subtipos_registro_1_1.done && (_a = subtipos_registro_1.return)) _a.call(subtipos_registro_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }));
    };
    /**
     * @private
     * @param {?} subtipo_registro_id
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarSubtipoRegistroId = /**
     * @private
     * @param {?} subtipo_registro_id
     * @return {?}
     */
    function (subtipo_registro_id) {
        var _this = this;
        if (this.subtipos_registro_map[subtipo_registro_id] == null) {
            this.subtipoRegistroService.getSubtipoRegistro(subtipo_registro_id, true).subscribe((/**
             * @param {?} subtipo_registro
             * @return {?}
             */
            function (subtipo_registro) {
                _this.cargarSubtipoRegistro(subtipo_registro);
            }));
        }
    };
    /**
     * @private
     * @param {?} subtipo_registro
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarSubtipoRegistro = /**
     * @private
     * @param {?} subtipo_registro
     * @return {?}
     */
    function (subtipo_registro) {
        var _this = this;
        if (this.subtipos_registro_map[subtipo_registro.id] == null) {
            this.subtipos_registro_map[subtipo_registro.id] = subtipo_registro;
            if (subtipo_registro.activo) {
                this.subtipos_select_items.push({
                    label: subtipo_registro.nombre,
                    value: subtipo_registro.id
                });
            }
        }
        if (this.iconos_map[subtipo_registro.icono] == null) {
            this.iconoService.getIcono(subtipo_registro.icono, true).subscribe((/**
             * @param {?} icono
             * @return {?}
             */
            function (icono) {
                _this.iconos_map[subtipo_registro.icono] = icono;
            }));
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarEmpleadosLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var empresaId, filters, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.lazyLoadEvent = event;
                        this.empleado_select_items = [];
                        empresaId = new String(this.authenticationService.authentication.empresa.id);
                        filters = {
                            'empresa': { value: empresaId.toString() },
                        };
                        if (this.filtroCentros != null) {
                            filters['centro:in'] = { value: this.filtroCentros.join(',') };
                        }
                        if (this.filtroEstados != null) {
                            filters['estado:in'] = { value: this.filtroEstados.join(',') };
                        }
                        _a = this;
                        return [4 /*yield*/, this.empleadoService.getEmpleadosCount(filters).toPromise()];
                    case 1:
                        _a.empleados_count = _b.sent();
                        if (this.empleados_count == 0) {
                            this.empleados = [];
                        }
                        if (this.empleados_count > this.empleados_numero) {
                            this.btnConectado = true;
                        }
                        else {
                            filters['conectado'] = { value: true.toString() };
                            this.btnConectado = false;
                        }
                        this.empleadoService.getEmpleados(filters, null).subscribe((/**
                         * @param {?} listaEmpleados
                         * @return {?}
                         */
                        function (listaEmpleados) {
                            var e_2, _a;
                            _this.empleados = listaEmpleados;
                            try {
                                for (var listaEmpleados_1 = __values(listaEmpleados), listaEmpleados_1_1 = listaEmpleados_1.next(); !listaEmpleados_1_1.done; listaEmpleados_1_1 = listaEmpleados_1.next()) {
                                    var empleado = listaEmpleados_1_1.value;
                                    _this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado.id });
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (listaEmpleados_1_1 && !listaEmpleados_1_1.done && (_a = listaEmpleados_1.return)) _a.call(listaEmpleados_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarEmpleados = /**
     * @return {?}
     */
    function () {
        this.cargarEmpleadosLazy(this.lazyLoadEvent);
    };
    /**
     * @private
     * @return {?}
     */
    ListaRegistrosComponent.prototype.loadCentros = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.centro_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() }
        };
        this.centroService.getCentros(filters, null).subscribe((/**
         * @param {?} listaCentros
         * @return {?}
         */
        function (listaCentros) {
            var e_3, _a;
            _this.centros = listaCentros;
            if (listaCentros != null && listaCentros.length > 0) {
                try {
                    for (var listaCentros_1 = __values(listaCentros), listaCentros_1_1 = listaCentros_1.next(); !listaCentros_1_1.done; listaCentros_1_1 = listaCentros_1.next()) {
                        var centro = listaCentros_1_1.value;
                        _this.centro_select_items.push({ label: centro.nombre, value: centro.id });
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (listaCentros_1_1 && !listaCentros_1_1.done && (_a = listaCentros_1.return)) _a.call(listaCentros_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                _this.mostrarCentros = true;
            }
            else {
                _this.mostrarCentros = false;
            }
        }));
    };
    /**
     * @private
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarTablaEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription.forEach((/**
         * @param {?} empleado
         * @return {?}
         */
        function (empleado) { return empleado.unsubscribe(); }));
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() },
        };
        if (this.filtro_empleados != null) {
            if (this.filtro_empleados.length != 0) {
                if (this.filtro_empleados.length > this.empleados_numero) {
                    filters['empleado:in'] = { value: this.filtro_empleados.join(',') };
                    this.conectado_loading = false;
                    this.btnConectado = true;
                }
                else {
                    filters['empleado:in'] = { value: this.filtro_empleados.join(',') };
                    filters['conectado'] = { value: true.toString() };
                    this.conectado_loading = true;
                    this.btnConectado = false;
                }
            }
        }
        if (this.filtroEstados != null) {
            filters['estado:in'] = { value: this.filtroEstados.join(',') };
        }
        this.subscription.push(this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            _this.empleados = listaEmpleados;
            _this.conectado_loading = false;
        })));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.onRowSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.empleadoSeleccionado = event.data;
        this.cargaRegistrosInforme(event.data);
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargarConectado_empleado = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() },
            'empleado:in': { value: this.empleadoSeleccionado.id.toString() },
            'conectado': { value: true.toString() },
        };
        this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            _this.empleadoSeleccionado.conectado = listaEmpleados[0].conectado;
        }));
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargar_conectado = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.conectado_loading = true;
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        this.btnConectado = false;
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() },
            'conectado': { value: true.toString() }
        };
        this.subscription.push(this.empleadoService.getEmpleados(filters, null)
            .subscribe((/**
         * @param {?} empleados
         * @return {?}
         */
        function (empleados) {
            _this.empleados = empleados;
            _this.conectado_loading = false;
        })));
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargaRegistros = /**
     * @return {?}
     */
    function () {
        this.subscription.forEach((/**
         * @param {?} empleado
         * @return {?}
         */
        function (empleado) { return empleado.unsubscribe(); }));
        if (this.empleados_count > this.empleados_numero) {
            this.btnConectado = true;
            this.conectado_loading = false;
        }
        this.cargaRegistrosInforme(this.empleadoSeleccionado);
        if (this.empleadoSeleccionado != null) {
            this.cargarConectado_empleado();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.seleccionarEmpleado = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.cargarTablaEmpleados();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.seleccionarCentro = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.cargarEmpleados();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.seleccionarEstado = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.cargarEmpleados();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    ListaRegistrosComponent.prototype.seleccionarSubtipoRegistro = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.cargaRegistrosInforme(this.empleadoSeleccionado);
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cargaRegistrosInforme = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        var _this = this;
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        if (this.filtro_fecha_reporte_desde != null) {
            filters['fecha:ge'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
        }
        else {
            /** @type {?} */
            var fechaActual = new Date();
            /** @type {?} */
            var dias = (1000 * 60 * 60 * 24) * 30;
            filters['fecha:ge'] = { value: String(fechaActual.getTime() - dias) };
        }
        if (this.filtro_fecha_reporte_hasta != null) {
            /** @type {?} */
            var fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
            filters['fecha:lt'] = { value: String(fecha_reporte_hasta.getTime()) };
        }
        if (empleado != null) {
            filters['empleado:eq'] = { value: String(empleado.id) };
        }
        //let timeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
        /** @type {?} */
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        filters['timeZone'] = { value: timeZone };
        /** @type {?} */
        var sort = (/** @type {?} */ ({}));
        /** @type {?} */
        var sortId = (/** @type {?} */ ({}));
        sort.field = 'fecha';
        sort.order = Order.ASC;
        /** @type {?} */
        var listaSort = [];
        sortId.field = 'id';
        sortId.order = Order.ASC;
        listaSort.push(sort);
        listaSort.push(sortId);
        this.registroService.getRegistrosInforme(filters, listaSort).subscribe((/**
         * @param {?} listaRegistros
         * @return {?}
         */
        function (listaRegistros) {
            _this.registros_loading = true;
            try {
                _this.registros_mostrar_columna_tipo = false;
                if (_this.filtro_subtipos_registro == null || _this.filtro_subtipos_registro.length == 0) {
                    _this.registros = listaRegistros;
                }
                else {
                    _this.registros = listaRegistros.filter((/**
                     * @param {?} registro
                     * @return {?}
                     */
                    function (registro) { return registro.subtipo_entrada != null && _this.filtro_subtipos_registro.indexOf(registro.subtipo_entrada) >= 0; }));
                }
                _this.updateMapaOptions();
                _this.updateRowGroupMetaData();
            }
            finally {
                _this.registros_loading = false;
            }
        }));
        this.disable_nuevo_registro = false;
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.updateRowGroupMetaData = /**
     * @return {?}
     */
    function () {
        this.registros_mostrar_columna_tipo = false;
        this.rowGroupMetadata = {};
        /** @type {?} */
        var year;
        /** @type {?} */
        var month;
        /** @type {?} */
        var date;
        /** @type {?} */
        var from;
        if (this.registros) {
            for (var i = 0; i < this.registros.length; i++) {
                /** @type {?} */
                var registroInforme = this.registros[i];
                if (registroInforme.subtipo_entrada != null) {
                    this.registros_mostrar_columna_tipo = true;
                    this.cargarSubtipoRegistroId(registroInforme.subtipo_entrada);
                }
                /** @type {?} */
                var fechaString = registroInforme.fecha;
                from = fechaString.split("/");
                year = Number(from[2]);
                month = Number(from[1]) - 1;
                date = Number(from[0]);
                /** @type {?} */
                var fecha = new Date(year, month, date);
                registroInforme.fechaNum = fecha.getTime();
                if (i == 0) {
                    this.rowGroupMetadata[registroInforme.fechaNum] = { index: 0, size: 1, sumHoras: registroInforme.horas };
                }
                else {
                    /** @type {?} */
                    var previousRowData = this.registros[i - 1];
                    /** @type {?} */
                    var previousRowGroup = previousRowData.fecha;
                    from = previousRowGroup.split("/");
                    year = Number(from[2]);
                    month = Number(from[1]) - 1;
                    date = Number(from[0]);
                    /** @type {?} */
                    var fechaPrev = new Date(year, month, date);
                    /** @type {?} */
                    var fechaNumPrev = fechaPrev.getTime();
                    if (registroInforme.fechaNum == fechaNumPrev) {
                        this.rowGroupMetadata[registroInforme.fechaNum].size++;
                        this.rowGroupMetadata[registroInforme.fechaNum].sumHoras = this.rowGroupMetadata[registroInforme.fechaNum].sumHoras + registroInforme.horas;
                    }
                    else {
                        this.rowGroupMetadata[registroInforme.fechaNum] = { index: i, size: 1, sumHoras: registroInforme.horas };
                    }
                }
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    ListaRegistrosComponent.prototype.updateMapaOptions = /**
     * @private
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_4, _a, e_5, _b, layers, _c, _d, registroInforme, _e, _f, _g, _h, e_4_1, puntos_alejados_latitud_1, puntos_alejados_latitud_2, puntos_alejados_longitud_1, puntos_alejados_longitud_2, puntos_alejados_latitud_distancia, puntos_alejados_longitud_distancia, index_1, index_2, distancia_latitud, distancia_longitud, centro_latitud, centro_longitud, distancia_maxima_latitud, distancia_maxima_longitud, layers_1, layers_1_1, marker_1, distancia_latitud, distancia_longitud, zoom_latitud, zoom_longitud;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        layers = [];
                        if (!this.registros) return [3 /*break*/, 10];
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 8, 9, 10]);
                        _c = __values(this.registros), _d = _c.next();
                        _j.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 7];
                        registroInforme = _d.value;
                        if (!(registroInforme.registro_entrada != null && registroInforme.registro_entrada.localizacion != null)) return [3 /*break*/, 4];
                        _f = (_e = layers).push;
                        return [4 /*yield*/, this.createMarker(registroInforme.registro_entrada)];
                    case 3:
                        _f.apply(_e, [_j.sent()]);
                        _j.label = 4;
                    case 4:
                        if (!(registroInforme.registro_salida != null && registroInforme.registro_salida.localizacion != null)) return [3 /*break*/, 6];
                        _h = (_g = layers).push;
                        return [4 /*yield*/, this.createMarker(registroInforme.registro_salida)];
                    case 5:
                        _h.apply(_g, [_j.sent()]);
                        _j.label = 6;
                    case 6:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_4_1 = _j.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        this.mapa_layers = layers;
                        if (layers.length > 0) {
                            puntos_alejados_latitud_1 = layers[0]._latlng;
                            puntos_alejados_latitud_2 = void 0;
                            puntos_alejados_longitud_1 = layers[0]._latlng;
                            puntos_alejados_longitud_2 = void 0;
                            if (layers.length == 1) {
                                puntos_alejados_latitud_2 = layers[0]._latlng;
                                puntos_alejados_longitud_2 = layers[0]._latlng;
                            }
                            else {
                                //Calculamos los puntos mas alejados
                                puntos_alejados_latitud_2 = layers[1]._latlng;
                                puntos_alejados_longitud_2 = layers[1]._latlng;
                                puntos_alejados_latitud_distancia = this.calcularDistanciaLatitud(layers[0]._latlng, layers[1]._latlng);
                                puntos_alejados_longitud_distancia = this.calcularDistanciaLongitud(layers[0]._latlng, layers[1]._latlng);
                                for (index_1 = 0; index_1 < layers.length; index_1++) {
                                    for (index_2 = 0; index_2 < layers.length; index_2++) {
                                        if (index_1 != index_2) {
                                            distancia_latitud = this.calcularDistanciaLatitud(layers[index_1]._latlng, layers[index_2]._latlng);
                                            distancia_longitud = this.calcularDistanciaLongitud(layers[index_1]._latlng, layers[index_2]._latlng);
                                            if (distancia_latitud > puntos_alejados_latitud_distancia) {
                                                puntos_alejados_latitud_1 = layers[index_1]._latlng;
                                                puntos_alejados_latitud_2 = layers[index_2]._latlng;
                                                puntos_alejados_latitud_distancia = distancia_latitud;
                                            }
                                            if (distancia_longitud > puntos_alejados_longitud_distancia) {
                                                puntos_alejados_longitud_1 = layers[index_1]._latlng;
                                                puntos_alejados_longitud_2 = layers[index_2]._latlng;
                                                puntos_alejados_longitud_distancia = distancia_longitud;
                                            }
                                        }
                                    }
                                }
                            }
                            //Calculamos el punto medio entre los puntos mas alejados
                            centro_latitud = (puntos_alejados_latitud_1.lat + puntos_alejados_latitud_2.lat) / 2;
                            centro_longitud = (puntos_alejados_longitud_1.lng + puntos_alejados_longitud_2.lng) / 2;
                            this.mapa_center = latLng(centro_latitud, centro_longitud);
                            //Calculamos el zoom para que se vean todos los puntos
                            distancia_maxima_latitud = 0;
                            distancia_maxima_longitud = 0;
                            try {
                                for (layers_1 = __values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                    marker_1 = layers_1_1.value;
                                    distancia_latitud = this.calcularDistanciaLatitud(puntos_alejados_latitud_1, puntos_alejados_latitud_2);
                                    distancia_longitud = this.calcularDistanciaLongitud(puntos_alejados_latitud_1, puntos_alejados_latitud_2);
                                    distancia_maxima_latitud = Math.max(distancia_maxima_latitud, distancia_latitud);
                                    distancia_maxima_longitud = Math.max(distancia_maxima_longitud, distancia_longitud);
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (layers_1_1 && !layers_1_1.done && (_b = layers_1.return)) _b.call(layers_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            zoom_latitud = Math.min(this.calcularZoom(distancia_maxima_latitud), 19);
                            zoom_longitud = Math.min(this.calcularZoom(distancia_maxima_longitud), 19);
                            this.mapa_zoom = Math.min(zoom_latitud, zoom_longitud);
                        }
                        if (this.mapa != null) {
                            setTimeout((/**
                             * @return {?}
                             */
                            function () {
                                _this.mapa.invalidateSize();
                            }), 0);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @private
     * @param {?} distancia
     * @return {?}
     */
    ListaRegistrosComponent.prototype.calcularZoom = /**
     * @private
     * @param {?} distancia
     * @return {?}
     */
    function (distancia) {
        return Math.floor(Math.log2(360 / distancia));
    };
    /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    ListaRegistrosComponent.prototype.calcularDistancia = /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    function (punto1, punto2) {
        return Math.sqrt(Math.pow(punto1.lat - punto2.lat, 2) + Math.pow(punto1.lng - punto2.lng, 2));
    };
    /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    ListaRegistrosComponent.prototype.calcularDistanciaLatitud = /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    function (punto1, punto2) {
        return Math.abs(punto1.lat - punto2.lat);
    };
    /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    ListaRegistrosComponent.prototype.calcularDistanciaLongitud = /**
     * @private
     * @param {?} punto1
     * @param {?} punto2
     * @return {?}
     */
    function (punto1, punto2) {
        return Math.abs(punto1.lng - punto2.lng);
    };
    /**
     * @private
     * @param {?} registro
     * @return {?}
     */
    ListaRegistrosComponent.prototype.createMarker = /**
     * @private
     * @param {?} registro
     * @return {?}
     */
    function (registro) {
        return __awaiter(this, void 0, void 0, function () {
            var strTextoTipo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.translateService.get('app.registro.' + (registro.tipo == TipoRegistro.Entrada ? 'entrada' : 'salida')).toPromise()];
                    case 1:
                        strTextoTipo = _a.sent();
                        return [2 /*return*/, marker([registro.localizacion.latitud, registro.localizacion.longitud], {
                                title: this.datePipe.transform(registro.fecha, 'dd/MM/yyyy HH:mm') + ' - ' + strTextoTipo,
                                icon: icon({
                                    iconSize: [25, 41],
                                    iconAnchor: [13, 41],
                                    iconUrl: 'assets/marker-icon.png',
                                    shadowUrl: 'assets/marker-shadow.png'
                                })
                            })];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.subscription.forEach((/**
         * @param {?} empleado
         * @return {?}
         */
        function (empleado) { return empleado.unsubscribe(); }));
        this.filtro_fecha_reporte_desde = null;
        this.filtro_fecha_reporte_hasta = null;
        this.filtro_empleados = null;
        this.disable_nuevo_registro = true;
        this.registros = null;
        this.mapa_layers = [];
        this.empleadoSeleccionado = null;
        this.filtroCentros = [];
        this.conectado_loading = false;
        this.cargarEmpleados();
    };
    /**
     * @param {?} registro
     * @return {?}
     */
    ListaRegistrosComponent.prototype.mostarDialogoNuevoRegistro = /**
     * @param {?} registro
     * @return {?}
     */
    function (registro) {
        this.registroSeleccionado = registro;
        this.mostrar_dialogo_nuevo_registro = true;
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.cerrarDialogoNuevoRegistro = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nuevo_registro = false;
    };
    /**
     * @param {?} registro
     * @return {?}
     */
    ListaRegistrosComponent.prototype.confirmarEliminar = /**
     * @param {?} registro
     * @return {?}
     */
    function (registro) {
        var _this = this;
        this.registroSeleccionado = registro;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.construirEliminar();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.nuevoRegistroCreado = /**
     * @return {?}
     */
    function () {
        this.cerrarDialogoNuevoRegistro();
        this.cargaRegistrosInforme(this.empleadoSeleccionado);
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.construirEliminar = /**
     * @return {?}
     */
    function () {
        if (this.registroSeleccionado.registro_entrada == null) {
            //Se busca la entrada original para poner la fecha y modificarla
            /** @type {?} */
            var index = this.registros.indexOf(this.registroSeleccionado);
            /** @type {?} */
            var registroEntrada;
            for (var i = index - 1; i >= 0; i--) {
                registroEntrada = this.registros[i];
                if (registroEntrada.registro_entrada != null) {
                    this.registroSeleccionado.registro_entrada = registroEntrada.registro_entrada;
                    break;
                }
            }
        }
        if (this.registroSeleccionado.registro_salida == null) {
            //Se deshabilita el registro de salida(es un registro fake)
            /** @type {?} */
            var index = this.registros.indexOf(this.registroSeleccionado);
            /** @type {?} */
            var registroSalida;
            for (var i = index; i < this.registros.length; i++) {
                registroSalida = this.registros[i];
                if (registroSalida.registro_salida != null) {
                    this.registroSeleccionado.registro_salida = registroSalida.registro_salida;
                    break;
                }
            }
        }
        this.eliminarRegistros();
    };
    /**
     * @return {?}
     */
    ListaRegistrosComponent.prototype.eliminarRegistros = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.registroSeleccionado != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var filters, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, 6, 7]);
                            filters = (/** @type {?} */ ({}));
                            if (!(this.registroSeleccionado.registro_entrada != null)) return [3 /*break*/, 2];
                            filters['fecha_modificado'] = { value: String(this.registroSeleccionado.registro_entrada.fecha_modificado) };
                            return [4 /*yield*/, this.registroService.eliminarRegistro(this.registroSeleccionado.registro_entrada.id, filters).toPromise()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(this.registroSeleccionado.registro_salida != null)) return [3 /*break*/, 4];
                            filters['fecha_modificado'] = { value: String(this.registroSeleccionado.registro_salida.fecha_modificado) };
                            return [4 /*yield*/, this.registroService.eliminarRegistro(this.registroSeleccionado.registro_salida.id, filters).toPromise()];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 7];
                        case 5:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 7];
                        case 6:
                            this.cargaRegistrosInforme(this.empleadoSeleccionado);
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    /**
     * @param {?} diferenciaHoras
     * @return {?}
     */
    ListaRegistrosComponent.prototype.generarInforme = /**
     * @param {?} diferenciaHoras
     * @return {?}
     */
    function (diferenciaHoras) {
        var _this = this;
        var e_6, _a;
        /** @type {?} */
        var idsEmpleado;
        idsEmpleado = [];
        try {
            for (var _b = __values(this.empleados), _c = _b.next(); !_c.done; _c = _b.next()) {
                var empl = _c.value;
                idsEmpleado.push(empl.id);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        filters['diferenciaHoras'] = { value: String(diferenciaHoras) };
        if (this.filtro_fecha_reporte_desde != null) {
            filters['fechaInicio'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
        }
        else {
            /** @type {?} */
            var fechaActual = new Date();
            /** @type {?} */
            var dias = (1000 * 60 * 60 * 24) * 30;
            filters['fechaInicio'] = { value: String(fechaActual.getTime() - dias) };
        }
        if (this.filtro_fecha_reporte_hasta != null) {
            /** @type {?} */
            var fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
            filters['fechaFin'] = { value: String(fecha_reporte_hasta.getTime()) };
        }
        if (this.empleados != null) {
            filters['empleado:in'] = { value: idsEmpleado.join(',') };
        }
        //let timeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
        /** @type {?} */
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        filters['timeZone'] = { value: timeZone };
        /** @type {?} */
        var sort = (/** @type {?} */ ({}));
        sort.field = 'fecha';
        sort.order = Order.ASC;
        /** @type {?} */
        var listaSort = [];
        listaSort.push(sort);
        this.registroService.generarInforme(filters, listaSort).subscribe((/**
         * @param {?} informe
         * @return {?}
         */
        function (informe) {
            _this.informe = informe;
            /** @type {?} */
            var byteCharacters = atob(_this.informe.datos);
            /** @type {?} */
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            /** @type {?} */
            var byteArray = new Uint8Array(byteNumbers);
            /** @type {?} */
            var blob = new Blob([byteArray], { type: "application/pdf" });
            /** @type {?} */
            var url = window.URL.createObjectURL(blob);
            window.open(url);
            return blob;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
        }));
    };
    /**
     * @param {?} diferenciaHoras
     * @return {?}
     */
    ListaRegistrosComponent.prototype.generarInformeTotales = /**
     * @param {?} diferenciaHoras
     * @return {?}
     */
    function (diferenciaHoras) {
        var _this = this;
        var e_7, _a;
        /** @type {?} */
        var idsEmpleado;
        idsEmpleado = [];
        try {
            for (var _b = __values(this.empleados), _c = _b.next(); !_c.done; _c = _b.next()) {
                var empl = _c.value;
                idsEmpleado.push(empl.id);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        filters['diferenciaHoras'] = { value: String(diferenciaHoras) };
        if (this.filtro_fecha_reporte_desde != null) {
            filters['fechaInicio'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
        }
        else {
            /** @type {?} */
            var fechaActual = new Date();
            /** @type {?} */
            var dias = (1000 * 60 * 60 * 24) * 30;
            filters['fechaInicio'] = { value: String(fechaActual.getTime() - dias) };
        }
        if (this.filtro_fecha_reporte_hasta != null) {
            /** @type {?} */
            var fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
            filters['fechaFin'] = { value: String(fecha_reporte_hasta.getTime()) };
        }
        if (this.empleados != null) {
            filters['empleado:in'] = { value: idsEmpleado.join(',') };
        }
        //let timeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
        /** @type {?} */
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        filters['timeZone'] = { value: timeZone };
        /** @type {?} */
        var sort = (/** @type {?} */ ({}));
        sort.field = 'fecha';
        sort.order = Order.ASC;
        /** @type {?} */
        var listaSort = [];
        listaSort.push(sort);
        this.registroService.generarInformeTotales(filters, listaSort).subscribe((/**
         * @param {?} informe
         * @return {?}
         */
        function (informe) {
            _this.informe = informe;
            /** @type {?} */
            var byteCharacters = atob(_this.informe.datos);
            /** @type {?} */
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            /** @type {?} */
            var byteArray = new Uint8Array(byteNumbers);
            /** @type {?} */
            var blob = new Blob([byteArray], { type: "application/pdf" });
            /** @type {?} */
            var url = window.URL.createObjectURL(blob);
            window.open(url);
            return blob;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
        }));
    };
    /**
     * @param {?} map
     * @return {?}
     */
    ListaRegistrosComponent.prototype.onMapReady = /**
     * @param {?} map
     * @return {?}
     */
    function (map$$1) {
        var _this = this;
        this.mapa = map$$1;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.mapa.invalidateSize();
        }), 0);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ListaRegistrosComponent.prototype.getSubtipoRegistro = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        if (id == null) {
            return null;
        }
        return this.subtipos_registro_map[id];
    };
    /**
     * @param {?} id
     * @return {?}
     */
    ListaRegistrosComponent.prototype.getIconoSubtipoRegistro = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var subtipo_registro = this.getSubtipoRegistro(id);
        if (subtipo_registro == null) {
            return null;
        }
        return this.iconos_map[subtipo_registro.icono];
    };
    ListaRegistrosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-lista-registros',
                    template: "<div class=\"ui-g\">\n  <div class=\"ui-g-12 ui-md-12 ui-lg-12\">\n    <p-panel class=\"filtro_busqueda con_botones\" header=\"{{ 'app.filtro' | translate }}\">\n      <div class=\"ui-g\">\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\">\n          <label [translate]=\"'app.filtro.desde'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n          <p-calendar [(ngModel)]=\"filtro_fecha_reporte_desde\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n            [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\">\n          <label [translate]=\"'app.filtro.hasta'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n          <p-calendar [(ngModel)]=\"filtro_fecha_reporte_hasta\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n            [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\" *ngIf=\"subtipos_select_items != null && subtipos_select_items.length > 0\">\n          <label>{{ 'app.registro.subtipo' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtro_subtipos_registro\" [options]=\"subtipos_select_items\" (onChange)=\"seleccionarSubtipoRegistro($event)\" defaultLabel=\"\"></p-multiSelect>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\" *ngIf=\"mostrarCentros\">\n          <label>{{ 'app.empleado.centro' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtroCentros\" [options]=\"centro_select_items\" (onChange)=\"seleccionarCentro($event)\" defaultLabel=\"\"></p-multiSelect>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-1\" >\n          <label>{{ 'app.empleado.estado' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtroEstados\" [options]=\"estado_select_items\" (onChange)=\"seleccionarEstado($event)\"\n          defaultLabel=\"Activo\"></p-multiSelect>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-3\">\n          <label>{{ 'app.filtro.empleado' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtro_empleados\" [options]=\"empleado_select_items\" defaultLabel=\"\" (onChange)=\"seleccionarEmpleado($event)\"></p-multiSelect>\n        </div>\n      </div>\n\n      <p-footer class=\"botones\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"cargaRegistros()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-file\" (click)=\"generarInforme(false)\" label=\"{{ 'app.registro.generar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-file\" (click)=\"generarInforme(true)\" label=\"{{ 'app.registro.generar_diferencia' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-file\" (click)=\"generarInformeTotales(false)\" label=\"{{ 'app.registro.generar_totales' | translate }}\"></button>\n      </p-footer>\n    </p-panel>\n  </div>\n\n  <div class=\"ui-g-12 ui-md-12 ui-lg-3\">\n    <p-table [value]=\"empleados\" dataKey=\"id\" selectionMode=\"single\" [(selection)]=\"empleadoSeleccionado\"\n    (onRowSelect)=\"onRowSelect($event)\" [scrollable]=\"true\" scrollHeight=\"30em\">\n      <ng-template pTemplate=\"header\">\n        <tr>\n            <th>{{ 'app.filtro.empleado' | translate }}</th>\n            <th (click)=\"cargar_conectado()\" style=\"width:20%; background-color: #116fbf; cursor: pointer;\" *ngIf=\"btnConectado == true\">\n              <i class=\"pi pi-sign-in\" *ngIf=\"btnConectado == true\"></i>\n            </th>\n            <th style=\"width:20%;\" *ngIf=\"conectado_loading == true\">\n              <i class=\"pi pi-spin pi-spinner\" *ngIf=\"conectado_loading == true\"></i>\n            </th>\n        </tr>\n      </ng-template>\n      <ng-template pTemplate=\"body\" let-empleado let-columns=\"columns\">\n        <tr [pSelectableRow]=\"empleado\">\n          <td>{{empleado.nombre}} {{empleado.apellidos}}</td>\n          <td style=\"width:20%; text-align: center;\"><i class=\"pi pi-check\" *ngIf=\"empleado.conectado == true\"></i> <i class=\"pi pi-times\" *ngIf=\"empleado.conectado == false\"></i></td>\n        </tr>\n      </ng-template>\n    </p-table>\n  </div>\n\n  <div class=\"ui-g-12 ui-md-12 ui-lg-9\" *ngIf=\"!registros_loading\">\n    <p-table [value]=\"registros\" dataKey=\"fecha\">\n      <ng-template pTemplate=\"header\">\n          <tr>\n              <th *ngIf=\"registros_mostrar_columna_tipo\">{{ 'app.registro.subtipo.entrada' | translate }}</th>\n              <th>{{ 'app.registro.entrada' | translate }}</th>\n              <th>{{ 'app.registro.salida' | translate }}</th>\n              <th>{{ 'app.registro.horas' | translate }}</th>\n              <th class=\"w7\"></th>\n          </tr>\n      </ng-template>\n      <ng-template pTemplate=\"body\" let-registro let-rowIndex=\"rowIndex\" let-expanded=\"expanded\" let-columns=\"columns\">\n          <tr class=\"ui-widget-header\" *ngIf=\"rowGroupMetadata[registro.fechaNum].index === rowIndex\">\n              <td [attr.colspan]=\"registros_mostrar_columna_tipo ? 3 : 2\">\n                  <a href=\"#\" [pRowToggler]=\"registro\">\n                      <i [ngClass]=\"expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"></i>\n                      <span>{{registro.fecha}}</span>\n                  </a>\n              </td>\n              <td colspan=\"2\">\n                  {{rowGroupMetadata[registro.fechaNum].sumHoras | number:'1.1-2'}}\n              </td>\n          </tr>\n      </ng-template>\n      <ng-template pTemplate=\"rowexpansion\" let-registro let-rowIndex=\"rowIndex\" let-columns=\"columns\">\n          <tr>\n              <td *ngIf=\"registros_mostrar_columna_tipo\">\n                <div class=\"subtipo_registro\" *ngIf=\"getSubtipoRegistro(registro.subtipo_entrada) != null\">\n                  <mat-icon *ngIf=\"getIconoSubtipoRegistro(registro.subtipo_entrada) != null\">{{ getIconoSubtipoRegistro(registro.subtipo_entrada).nombre }}</mat-icon>\n                  <span>{{ getSubtipoRegistro(registro.subtipo_entrada).nombre }}</span>\n                </div>\n              </td>\n              <td>{{registro.entrada}}</td>\n              <td>{{registro.salida}}</td>\n              <td>{{registro.horas | number:'1.1-2'}}</td>\n              <td class=\"botones\" *ngIf=\"registro.registro_entrada != null || registro.registro_salida != null || registro.salida == '--:--'\">\n                <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevoRegistro(registro)\" ></button>\n                <button type=\"button\" pButton icon=\"pi pi-trash\" (click)=\"confirmarEliminar(registro)\"></button>\n\n              </td>\n          </tr>\n      </ng-template>\n\n      <ng-template pTemplate=\"footer\" let-columns>\n        <div class=\"botones\">\n          <button type=\"button\" pButton icon=\"pi pi-plus\" (click)=\"mostarDialogoNuevoRegistro(null)\" label=\"{{ 'app.registro.nuevo' | translate }}\" [disabled]=\"disable_nuevo_registro\"></button>\n        </div>\n      </ng-template>\n    </p-table>\n\n    <div\n      leaflet\n      (leafletMapReady)=\"onMapReady($event)\"\n      [leafletOptions]=\"mapa_options\"\n      [leafletZoom]=\"mapa_zoom\"\n      [leafletCenter]=\"mapa_center\"\n      [leafletLayers]=\"mapa_layers\"\n      [ngClass]=\"{'display_none': mapa_layers.length == 0}\"\n      *ngIf=\"mapa_options != null && mapa_layers != null\">\n    </div>\n  </div>\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ 'app.registro.registro' | translate }}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [(visible)]=\"mostrar_dialogo_nuevo_registro\">\n  <core-nuevo-registro\n    *ngIf=\"mostrar_dialogo_nuevo_registro\"\n    [empleado]=\"empleadoSeleccionado\"\n    [registroSeleccionado]=\"registroSeleccionado\"\n    [listaRegistros]=\"registros\"\n    [subtipos_registro_map]=\"subtipos_registro_map\"\n    [subtipos_select_items]=\"subtipos_select_items\"\n    [iconos_map]=\"iconos_map\"\n    (successCallback)=\"nuevoRegistroCreado()\"\n    (cancelCallback)=\"cerrarDialogoNuevoRegistro()\"></core-nuevo-registro>\n</p-dialog>\n\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [".leaflet-container{height:40em}.subtipo_registro .mat-icon{margin-right:.5em}.subtipo_registro span{position:relative;top:-.35em}.pi-sign-in{color:#fff}"]
                }] }
    ];
    /** @nocollapse */
    ListaRegistrosComponent.ctorParameters = function () { return [
        { type: RegistroService },
        { type: EmpleadoService },
        { type: IconoService },
        { type: SubtipoRegistroService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: DatePipe },
        { type: CentroService }
    ]; };
    ListaRegistrosComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaRegistrosComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/registro/nuevo-registro/nuevo-registro.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevoRegistroComponent = /** @class */ (function () {
    function NuevoRegistroComponent(formBuilder, registroService, authenticationService, primeLocaleService, translateService, blockUiService, formService, messageService) {
        this.formBuilder = formBuilder;
        this.registroService = registroService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NuevoRegistroComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.registro_form = this.formBuilder.group({
            id: new FormControl(null),
            subtipo_entrada: new FormControl(null),
            entrada: new FormControl(null, [
                Validators.required
            ]),
            salida: new FormControl(null, [
                Validators.required
            ])
        });
        this.disableRegEntrada = false;
        this.disableRegSalida = false;
        this.subtipos_select_items_actual = [{
                label: '',
                value: null
            }];
        if (this.subtipos_select_items != null) {
            this.subtipos_select_items_actual.push.apply(this.subtipos_select_items_actual, this.subtipos_select_items);
        }
        if (this.registroSeleccionado != null) {
            //Fecha de entrada
            /** @type {?} */
            var fechaFormulario = this.formatDate(this.registroSeleccionado.fecha, this.registroSeleccionado.entrada);
            this.registro_form.controls['subtipo_entrada'].setValue(this.registroSeleccionado.subtipo_entrada);
            this.registro_form.controls['entrada'].setValue(fechaFormulario);
            if (this.registroSeleccionado.subtipo_entrada != null) {
                /** @type {?} */
                var subtipo_registro = this.subtipos_registro_map[this.registroSeleccionado.subtipo_entrada];
                if (subtipo_registro != null && !subtipo_registro.activo) {
                    this.subtipos_select_items_actual.push({
                        label: subtipo_registro.nombre,
                        value: subtipo_registro.id,
                        disabled: true
                    });
                }
            }
            //Fecha de salida
            fechaFormulario = this.formatDate(this.registroSeleccionado.fecha, this.registroSeleccionado.salida);
            this.registro_form.controls['salida'].setValue(fechaFormulario);
            if (this.registroSeleccionado.registro_entrada == null) {
                //Se busca la entrada original para poner la fecha y modificarla
                /** @type {?} */
                var index = this.listaRegistros.indexOf(this.registroSeleccionado);
                /** @type {?} */
                var registroEntrada;
                for (var i = index - 1; i >= 0; i--) {
                    registroEntrada = this.listaRegistros[i];
                    if (registroEntrada.registro_entrada != null) {
                        this.registroSeleccionado.registro_entrada = registroEntrada.registro_entrada;
                        /** @type {?} */
                        var fechaSplit = registroEntrada.fecha.split("/");
                        /** @type {?} */
                        var horaSplit = registroEntrada.entrada.split(":");
                        /** @type {?} */
                        var mes = +fechaSplit[1] - 1;
                        /** @type {?} */
                        var fechaEntrada = new Date(+fechaSplit[2], mes, +fechaSplit[0], +horaSplit[0], +horaSplit[1], 0);
                        this.registro_form.controls['entrada'].setValue(fechaEntrada);
                        break;
                    }
                }
            }
            else {
                if (this.registroSeleccionado.entrada == "00:00") {
                    this.registro_form.controls['entrada'].setValue(new Date(this.registroSeleccionado.registro_entrada.fecha));
                }
            }
            if (this.registroSeleccionado.registro_salida == null) {
                // Se deshabilita el registro de salida (es un registro fake)
                // Si aún no se ha cerrado el fichaje el de entrada que sea el original
                if (this.registroSeleccionado.salida == "--:--") {
                    /** @type {?} */
                    var fechaFormulario_1 = this.formatDate(this.registroSeleccionado.fecha, this.registroSeleccionado.entrada);
                    this.registro_form.controls['subtipo_entrada'].setValue(this.registroSeleccionado.subtipo_entrada);
                    this.registro_form.controls['entrada'].setValue(fechaFormulario_1);
                }
                /** @type {?} */
                var index = this.listaRegistros.indexOf(this.registroSeleccionado);
                /** @type {?} */
                var registroSalida;
                for (var i = index; i < this.listaRegistros.length; i++) {
                    registroSalida = this.listaRegistros[i];
                    if (registroSalida.registro_salida != null) {
                        this.registroSeleccionado.registro_salida = registroSalida.registro_salida;
                        /** @type {?} */
                        var fechaSplit = registroSalida.fecha.split("/");
                        /** @type {?} */
                        var horaSplit = registroSalida.salida.split(":");
                        /** @type {?} */
                        var mes = +fechaSplit[1] - 1;
                        /** @type {?} */
                        var fechaSalida = new Date(+fechaSplit[2], mes, +fechaSplit[0], +horaSplit[0], +horaSplit[1], 0);
                        this.registro_form.controls['salida'].setValue(fechaSalida);
                        break;
                    }
                    else {
                        //No existe cierre de registro
                        if (this.registroSeleccionado.salida == "--:--") {
                            /** @type {?} */
                            var fechaSalida = new Date();
                            this.registro_form.controls['salida'].setValue(fechaSalida);
                            this.registroSeleccionado.registro_salida = (/** @type {?} */ ({
                                idEmpresa: this.authenticationService.authentication.empresa.id,
                                idEmpleado: this.empleado.id,
                                fecha: this.registro_form.controls['salida'].value,
                                tipo: TipoRegistro.Salida
                            }));
                        }
                    }
                }
            }
            else {
                if (this.registroSeleccionado.salida == "--:--") {
                    this.registroSeleccionado.registro_salida.fecha = new Date();
                    this.registro_form.controls['salida'].setValue(new Date(this.registroSeleccionado.registro_salida.fecha));
                }
                if (this.registroSeleccionado.salida == "00:00") {
                    this.registro_form.controls['salida'].setValue(new Date(this.registroSeleccionado.registro_salida.fecha));
                }
            }
        }
    };
    /**
     * @return {?}
     */
    NuevoRegistroComponent.prototype.crearRegistro = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.empleado != null) {
            /** @type {?} */
            var fechaEntr = this.registro_form.controls['entrada'].value;
            /** @type {?} */
            var fechaSal = this.registro_form.controls['salida'].value;
            if (fechaSal > fechaEntr) {
                this.blockUiService.ejecutarConBloqueo(new Promise((/**
                 * @param {?} resolve
                 * @param {?} reject
                 * @return {?}
                 */
                function (resolve, reject) {
                    _this.formService.onSubmitFormValidation(_this.registro_form, 'app.registro.', (/**
                     * @return {?}
                     */
                    function () { return __awaiter(_this, void 0, void 0, function () {
                        var registroEntrada, registroSalida, error_1, registroEntrada, registroSalida, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.registroSeleccionado != null)) return [3 /*break*/, 6];
                                    registroEntrada = this.registroSeleccionado.registro_entrada;
                                    registroEntrada.fecha = this.registro_form.controls['entrada'].value;
                                    registroEntrada.subtipo = this.registro_form.controls['subtipo_entrada'].value;
                                    registroEntrada.tipo = TipoRegistro.Entrada;
                                    registroSalida = this.registroSeleccionado.registro_salida;
                                    registroSalida.fecha = this.registro_form.controls['salida'].value;
                                    registroSalida.tipo = TipoRegistro.Salida;
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 4, , 5]);
                                    return [4 /*yield*/, this.registroService.actualizarRegistro(registroEntrada).toPromise()];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, this.registroService.actualizarRegistro(registroSalida).toPromise()];
                                case 3:
                                    _a.sent();
                                    this.successCallback.emit(null);
                                    resolve();
                                    return [3 /*break*/, 5];
                                case 4:
                                    error_1 = _a.sent();
                                    reject();
                                    return [3 /*break*/, 5];
                                case 5: return [3 /*break*/, 11];
                                case 6:
                                    registroEntrada = (/** @type {?} */ ({
                                        idEmpresa: this.authenticationService.authentication.empresa.id,
                                        idEmpleado: this.empleado.id,
                                        fecha: this.registro_form.controls['entrada'].value,
                                        subtipo: this.registro_form.controls['subtipo_entrada'].value,
                                        tipo: TipoRegistro.Entrada
                                    }));
                                    registroSalida = (/** @type {?} */ ({
                                        idEmpresa: this.authenticationService.authentication.empresa.id,
                                        idEmpleado: this.empleado.id,
                                        fecha: this.registro_form.controls['salida'].value,
                                        tipo: TipoRegistro.Salida
                                    }));
                                    _a.label = 7;
                                case 7:
                                    _a.trys.push([7, 10, , 11]);
                                    return [4 /*yield*/, this.registroService.anyadirRegistro(registroEntrada).toPromise()];
                                case 8:
                                    _a.sent();
                                    return [4 /*yield*/, this.registroService.anyadirRegistro(registroSalida).toPromise()];
                                case 9:
                                    _a.sent();
                                    this.successCallback.emit(null);
                                    resolve();
                                    return [3 /*break*/, 11];
                                case 10:
                                    error_2 = _a.sent();
                                    reject();
                                    return [3 /*break*/, 11];
                                case 11: return [2 /*return*/];
                            }
                        });
                    }); }), (/**
                     * @return {?}
                     */
                    function () {
                        reject();
                    }));
                })));
            }
            else {
                //Error. la fecha de entrada es mayor q la de salida
                this.translateService.get('app.registro.errorFecha').subscribe((/**
                 * @param {?} message
                 * @return {?}
                 */
                function (message) {
                    _this.messageService.add({
                        severity: 'error',
                        summary: message
                    });
                }));
            }
        }
        return;
    };
    /**
     * @return {?}
     */
    NuevoRegistroComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    /**
     * @param {?} fecha_reg
     * @param {?} hora_reg
     * @return {?}
     */
    NuevoRegistroComponent.prototype.formatDate = /**
     * @param {?} fecha_reg
     * @param {?} hora_reg
     * @return {?}
     */
    function (fecha_reg, hora_reg) {
        /** @type {?} */
        var from = fecha_reg.split("/");
        /** @type {?} */
        var year = Number(from[2]);
        /** @type {?} */
        var month = Number(from[1]) - 1;
        /** @type {?} */
        var day = Number(from[0]);
        /** @type {?} */
        var horas = hora_reg.split(":");
        /** @type {?} */
        var hora = Number(horas[0]);
        /** @type {?} */
        var minutos = Number(horas[1]);
        return new Date(year, month, day, hora, minutos);
    };
    NuevoRegistroComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-nuevo-registro',
                    template: "<form [formGroup]=\"registro_form\" (ngSubmit)=\"crearRegistro()\">\n  <div class=\"ui-g\">\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.registro.subtipo.entrada' | translate }}</label>\n      <p-dropdown styleClass=\"subtipo_registro\" [options]=\"subtipos_select_items_actual\" formControlName=\"subtipo_entrada\" appendTo=\"body\">\n        <ng-template let-item pTemplate=\"selectedItem\">\n          <mat-icon *ngIf=\"item.value != null && subtipos_registro_map[item.value] != null && subtipos_registro_map[item.value].icono != null && iconos_map[subtipos_registro_map[item.value].icono] != null\">{{ iconos_map[subtipos_registro_map[item.value].icono].nombre }}</mat-icon>\n          <span [ngClass]=\"{'empty' : item.value == null}\">{{ item.label }}</span>\n        </ng-template>\n        <ng-template let-item pTemplate=\"item\">\n          <mat-icon *ngIf=\"item.value != null && subtipos_registro_map[item.value] != null && subtipos_registro_map[item.value].icono != null && iconos_map[subtipos_registro_map[item.value].icono] != null\">{{ iconos_map[subtipos_registro_map[item.value].icono].nombre }}</mat-icon>\n          <span [ngClass]=\"{'empty' : item.value == null}\">{{ item.label }}</span>\n        </ng-template>\n      </p-dropdown>\n    </div>\n\n    <div class=\"ui-g-12 ui-md-4 ui-lg-4\">\n      <label [translate]=\"'app.registro.entrada'\" [translateParams]=\"{ campo: ('app.registro.entrada' | translate)}\"></label>\n      <p-calendar [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n       formControlName=\"entrada\" [showTime]=\"true\" [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n    </div>\n\n    <div class=\"ui-g-12 ui-md-4 ui-lg-4\">\n      <label [translate]=\"'app.registro.salida'\" [translateParams]=\"{ campo: ('app.registro.salida' | translate)}\"></label>\n      <p-calendar [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n       formControlName=\"salida\" [showTime]=\"true\" [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n    </div>\n  </div>\n\n  <p-footer class=\"botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\"></button>\n  </p-footer>\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NuevoRegistroComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: RegistroService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: FormService },
        { type: MessageService }
    ]; };
    NuevoRegistroComponent.propDecorators = {
        empleado: [{ type: Input }],
        registroSeleccionado: [{ type: Input }],
        listaRegistros: [{ type: Input }],
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }],
        subtipos_registro_map: [{ type: Input }],
        subtipos_select_items: [{ type: Input }],
        iconos_map: [{ type: Input }]
    };
    return NuevoRegistroComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/empresa.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EmpresaService = /** @class */ (function () {
    function EmpresaService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/empresas';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    EmpresaService.prototype.getEmpresas = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} empresasRest
         * @return {?}
         */
        function (empresasRest) {
            /** @type {?} */
            var empresas = empresasRest.map((/**
             * @param {?} empresaRest
             * @return {?}
             */
            function (empresaRest) {
                return (/** @type {?} */ (empresaRest));
            }));
            return empresas;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    EmpresaService.prototype.getEmpresasCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    EmpresaService.prototype.getOneEmpresa = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getEmpresas(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} empresas
         * @return {?}
         */
        function (empresas) {
            if (empresas == null || empresas.length == 0) {
                return null;
            }
            else {
                return empresas[0];
            }
        })));
    };
    /**
     * @param {?} empresa
     * @return {?}
     */
    EmpresaService.prototype.editarEmpresa = /**
     * @param {?} empresa
     * @return {?}
     */
    function (empresa) {
        console.log(empresa);
        if (empresa.id == null || empresa.id <= 0) {
            console.log('anyadir');
            return this.anyadirEmpresa(empresa);
        }
        else {
            return this.actualizarEmpresa(empresa);
        }
    };
    /**
     * @private
     * @param {?} empresa
     * @return {?}
     */
    EmpresaService.prototype.anyadirEmpresa = /**
     * @private
     * @param {?} empresa
     * @return {?}
     */
    function (empresa) {
        /** @type {?} */
        var empresa_post = (/** @type {?} */ ({
            cif: empresa.cif,
            codigo: empresa.codigo,
            nombre: empresa.nombre,
            direccion: empresa.direccion,
            maxEmpleados: empresa.maxEmpleados,
            ccc: empresa.ccc
        }));
        console.log(empresa_post);
        return this.http.post(this.base_url, empresa_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @private
     * @param {?} empresa
     * @return {?}
     */
    EmpresaService.prototype.actualizarEmpresa = /**
     * @private
     * @param {?} empresa
     * @return {?}
     */
    function (empresa) {
        /** @type {?} */
        var empresa_put = (/** @type {?} */ ({
            id: empresa.id,
            cif: empresa.cif,
            codigo: empresa.codigo,
            nombre: empresa.nombre,
            direccion: empresa.direccion,
            maxEmpleados: empresa.maxEmpleados,
            ccc: empresa.ccc,
            alerta_fichaje_24h: empresa.alerta_fichaje_24h
        }));
        return this.http.put(this.base_url + '/' + empresa_put.id, empresa_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idEmpresa
     * @return {?}
     */
    EmpresaService.prototype.eliminarEmpresa = /**
     * @param {?} idEmpresa
     * @return {?}
     */
    function (idEmpresa) {
        return this.http.delete(this.base_url + '/' + idEmpresa).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    EmpresaService.prototype.generarCodigo = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/codigo' + url_params)
            .pipe(map((/**
         * @param {?} codigoRest
         * @return {?}
         */
        function (codigoRest) {
            return codigoRest.codigo;
        })));
    };
    /**
     * @param {?} id
     * @return {?}
     */
    EmpresaService.prototype.getEmpresa = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get(this.base_url + '/' + id)
            .pipe(map((/**
         * @param {?} empresaRest
         * @return {?}
         */
        function (empresaRest) {
            return (/** @type {?} */ (empresaRest));
        })));
    };
    EmpresaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EmpresaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ EmpresaService.ngInjectableDef = defineInjectable({ factory: function EmpresaService_Factory() { return new EmpresaService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: EmpresaService, providedIn: "root" });
    return EmpresaService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/empresa/lista-empresas/lista-empresas.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaEmpresasComponent = /** @class */ (function () {
    function ListaEmpresasComponent(empresaService, authenticationService, confirmationService, translateService, blockUiService, eventEmiterService, messageService) {
        this.empresaService = empresaService;
        this.authenticationService = authenticationService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.motivo_select_items = [];
        this.rows_per_page = 10;
        this.first_page = 0;
        this.empleado_select_items = [];
    }
    /**
     * @return {?}
     */
    ListaEmpresasComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaEmpresasComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.get('app.mensaje.confirmacion').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.mensajeConfirmacion = texto;
        }));
        this.submenu_items = [
            {
                label: '',
                command: (/**
                 * @param {?} event
                 * @return {?}
                 */
                function (event) {
                    _this.mostarDialogoNuevaEmpresa(null);
                })
            }
        ];
        this.translateService.get('app.empresa.submenu.nueva').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.submenu_items[0].label = texto;
        }));
        this.mostrar_dialogo_nueva_empresa = false;
        this.lazyLoadEvent = null;
        this.empresas = [];
        this.empresas_count = 0;
        this.empresas_loading = true;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaEmpresasComponent.prototype.loadEmpresasLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, _a, first, rows, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.empresas_loading = true;
                        this.lazyLoadEvent = event;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 6, 7]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtroNombre != null) {
                            filters['nombre:ct'] = { value: this.filtroNombre };
                        }
                        if (this.filtroNif != null) {
                            filters['nif:ct'] = { value: this.filtroNif };
                        }
                        _a = this;
                        return [4 /*yield*/, this.empresaService.getEmpresasCount(filters).toPromise()];
                    case 2:
                        _a.empresas_count = _c.sent();
                        if (!(this.empresas_count === 0)) return [3 /*break*/, 3];
                        this.empresas = [];
                        return [3 /*break*/, 5];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _b = this;
                        return [4 /*yield*/, this.empresaService.getEmpresas(filters, null, first, rows)
                                .toPromise()];
                    case 4:
                        _b.empresas = _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.empresas_loading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaEmpresasComponent.prototype.loadEmpresas = /**
     * @return {?}
     */
    function () {
        this.loadEmpresasLazy(this.lazyLoadEvent);
    };
    /**
     * @param {?} empresa
     * @return {?}
     */
    ListaEmpresasComponent.prototype.mostarDialogoNuevaEmpresa = /**
     * @param {?} empresa
     * @return {?}
     */
    function (empresa) {
        var _this = this;
        if (empresa == null) {
            this.translateService.get('app.empresa.nuevo').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        else {
            this.translateService.get('app.empresa.edicion').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        this.empresaEdicion = empresa;
        this.mostrar_dialogo_nueva_empresa = true;
    };
    /**
     * @return {?}
     */
    ListaEmpresasComponent.prototype.cerrarDialogoNuevaEmpresa = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nueva_empresa = false;
    };
    /**
     * @return {?}
     */
    ListaEmpresasComponent.prototype.nuevaEmpresaCreada = /**
     * @return {?}
     */
    function () {
        this.loadEmpresas();
        this.cerrarDialogoNuevaEmpresa();
    };
    /**
     * @param {?} empresa
     * @return {?}
     */
    ListaEmpresasComponent.prototype.confirmarEliminar = /**
     * @param {?} empresa
     * @return {?}
     */
    function (empresa) {
        var _this = this;
        this.empresaEdicion = empresa;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.eliminarEmpresa();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaEmpresasComponent.prototype.eliminarEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.empresaEdicion != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.empresaService.eliminarEmpresa(this.empresaEdicion.id).toPromise()];
                        case 1:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 3:
                            this.loadEmpresas();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    ListaEmpresasComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-lista-empresas',
                    template: "<p-menubar [model]=\"submenu_items\"></p-menubar>\n\n<div id=\"contenido\">\n  <p-panel class=\"filtro_busqueda\" header=\"{{ 'app.filtro' | translate }}\">\n    <div class=\"ui-g\">\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\" >\n        <label>{{ 'app.filtro.nombre' | translate }}</label>\n        <input type=\"text\" pInputText [(ngModel)]=\"filtroNombre\"/>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\" >\n        <label>{{ 'app.filtro.nif' | translate }}</label>\n        <input type=\"text\" pInputText [(ngModel)]=\"filtroNif\"/>\n      </div>\n\n      <div class=\"ui-g-12\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadEmpresas()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n      </div>\n    </div>\n  </p-panel>\n\n  <p-card class=\"texto_centrado\" *ngIf=\"empresas_loading || empresas_count == 0\">\n    <i class=\"pi pi-spin pi-spinner\" *ngIf=\"empresas_loading\"></i>\n    <span *ngIf=\"!empresas_loading && empresas_count == 0\">{{ 'app.sin_registros' | translate }}</span>\n  </p-card>\n\n    <p-table [value]=\"empresas\" dataKey=\"empresa\" [lazy]=\"true\"\n    (onLazyLoad)=\"loadEmpresasLazy($event)\" [paginator]=\"true\" [rows]=\"rows_per_page\"\n    [totalRecords]=\"empresas_count\" [loading]=\"empresas_loading\">\n      <ng-template pTemplate=\"header\">\n          <tr>\n              <th>{{ 'app.empresa.nombre' | translate }}</th>\n              <th>{{ 'app.empresa.nif' | translate }}</th>\n              <th>{{ 'app.empresa.direccion' | translate }}</th>\n              <th class=\"w10\"></th>\n          </tr>\n      </ng-template>\n      <ng-template pTemplate=\"body\" let-empresa>\n          <tr>\n              <td>{{empresa.nombre}}</td>\n              <td>{{empresa.cif}}</td>\n              <td>{{empresa.direccion}}</td>\n              <td class=\"botones\">\n                <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevaEmpresa(empresa)\"></button>\n                <button type=\"button\" pButton icon=\"pi pi-trash\" (click)=\"confirmarEliminar(empresa)\"></button>\n              </td>\n            </tr>\n      </ng-template>\n    </p-table>\n\n\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ tituloDialogo }}\" [contentStyle]=\"{'overflow':'visible'}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [(visible)]=\"mostrar_dialogo_nueva_empresa\">\n  <app-nueva-empresa\n    *ngIf=\"mostrar_dialogo_nueva_empresa\"\n    [empresaEdicion]=\"empresaEdicion\"\n    (successCallback)=\"nuevaEmpresaCreada()\"\n    (cancelCallback)=\"cerrarDialogoNuevaEmpresa()\"></app-nueva-empresa>\n</p-dialog>\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ListaEmpresasComponent.ctorParameters = function () { return [
        { type: EmpresaService },
        { type: AuthenticationService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: MessageService }
    ]; };
    ListaEmpresasComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaEmpresasComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/empresa/nueva-empresa/nueva-empresa.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevaEmpresaComponent = /** @class */ (function () {
    function NuevaEmpresaComponent(formBuilder, blockUiService, formService, empresaService, translateService, authenticationService, primeLocaleService, messageService) {
        this.formBuilder = formBuilder;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.empresaService = empresaService;
        this.translateService = translateService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.mostrarBotonCancelar = true;
    }
    /**
     * @return {?}
     */
    NuevaEmpresaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.edicion = (this.empresaEdicion != null);
        this.empresa_form = this.formBuilder.group({
            id: new FormControl(this.edicion ? this.empresaEdicion.id : null),
            codigo: new FormControl({
                value: this.edicion ? this.empresaEdicion.codigo : null,
                disabled: true
            }, [
                Validators.required
            ]),
            nombre: new FormControl(this.edicion ? this.empresaEdicion.nombre : null, [
                Validators.required
            ]),
            cif: new FormControl({
                value: this.edicion ? this.empresaEdicion.cif : null,
                disabled: !this.es_usuario_administrador
            }, [
                Validators.required
            ]),
            direccion: new FormControl(this.edicion ? this.empresaEdicion.direccion : null, [
                Validators.required
            ]),
            maxEmpleados: new FormControl({
                value: this.edicion ? this.empresaEdicion.maxEmpleados : null,
                disabled: !this.es_usuario_administrador
            }, [
                Validators.required
            ]),
            ccc: new FormControl(this.edicion ? this.empresaEdicion.ccc : null),
            alerta_fichaje_24h: new FormControl({
                value: this.edicion ? this.empresaEdicion.alerta_fichaje_24h : null,
                disabled: this.es_usuario_administrador
            })
        });
        if (!this.edicion) {
            this.generarCodigo();
        }
    };
    /**
     * @return {?}
     */
    NuevaEmpresaComponent.prototype.crearEmpresa = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            console.log('crearEmpresa 1');
            _this.formService.onSubmitFormValidation(_this.empresa_form, 'app.empresa.', (/**
             * @return {?}
             */
            function () {
                console.log('crearEmpresa 2');
                console.log(_this.empresa_form.getRawValue());
                _this.empresaService.editarEmpresa(_this.empresa_form.getRawValue()).toPromise().then((/**
                 * @return {?}
                 */
                function () {
                    _this.successCallback.emit(null);
                    resolve();
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    reject();
                }));
            }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
    };
    /**
     * @return {?}
     */
    NuevaEmpresaComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    /**
     * @return {?}
     */
    NuevaEmpresaComponent.prototype.generarCodigo = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.empresaService.generarCodigo().subscribe((/**
         * @param {?} codigo
         * @return {?}
         */
        function (codigo) {
            _this.empresa_form.patchValue({ codigo: codigo });
        }));
    };
    Object.defineProperty(NuevaEmpresaComponent.prototype, "es_usuario_administrador", {
        get: /**
         * @return {?}
         */
        function () {
            return this.authenticationService.userHasAllRoles(['ROLE_USUARIO_ADMIN']);
        },
        enumerable: true,
        configurable: true
    });
    NuevaEmpresaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-nueva-empresa',
                    template: "<form [formGroup]=\"empresa_form\" (ngSubmit)=\"crearEmpresa()\">\n  <div class=\"ui-g\">\n    <div class=\"ui-g-3\">\n      <label>{{ 'app.empresa.codigo' | translate }} *</label>\n\n      <div class=\"ui-inputgroup\">\n        <input type=\"text\" formControlName=\"codigo\" pInputText class=\"w4\" />\n        <button type=\"button\" pButton icon=\"pi pi-replay\" (click)=\"generarCodigo()\" class=\"botonLado\" *ngIf=\"es_usuario_administrador\"></button>\n      </div>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empresa.cif' | translate }} *</label>\n      <input type=\"text\" formControlName=\"cif\" pInputText class=\"w7\"/>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empresa.nombre' | translate }} *</label>\n      <input type=\"text\" formControlName=\"nombre\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empresa.direccion' | translate }} *</label>\n      <input type=\"text\" formControlName=\"direccion\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-5\">\n      <label>{{ 'app.empresa.maxEmpleados' | translate }} *</label>\n      <input type=\"text\" formControlName=\"maxEmpleados\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-5\">\n      <label>{{ 'app.empresa.ccc' | translate }} *</label>\n      <input type=\"text\" formControlName=\"ccc\" pInputText/>\n    </div>\n  </div>\n\n  <p-panel styleClass=\"espaciado_superior\" header=\"{{ 'app.empresa.alertas' | translate }}\" *ngIf=\"edicion\">\n    <div class=\"ui-g\">\n      <div class=\"ui-g-12\">\n        <p-checkbox formControlName=\"alerta_fichaje_24h\" binary=\"true\"></p-checkbox>\n        <label class=\"inline\">{{ 'app.empresa.alertas.fichaje_24h' | translate }}</label>\n      </div>\n    </div>\n  </p-panel>\n\n  <p-footer class=\"espaciado_superior botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\" *ngIf=\"mostrarBotonCancelar\"></button>\n  </p-footer>\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NuevaEmpresaComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: BlockUiService },
        { type: FormService },
        { type: EmpresaService },
        { type: TranslateService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: MessageService }
    ]; };
    NuevaEmpresaComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }],
        empresaEdicion: [{ type: Input }],
        mostrarBotonCancelar: [{ type: Input }]
    };
    return NuevaEmpresaComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/empleado/lista-empleados/lista-empleados.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaEmpleadosComponent = /** @class */ (function () {
    function ListaEmpleadosComponent(empleadoService, authenticationService, primeLocaleService, confirmationService, translateService, blockUiService, eventEmiterService, messageService, centroService) {
        this.empleadoService = empleadoService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.messageService = messageService;
        this.centroService = centroService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.rows_per_page = 10;
        this.first_page = 0;
    }
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.eventEmiterService.empresaActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargaOnInit();
            _this.limpiarBusqueda();
        }));
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.get('app.mensaje.confirmacion').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.mensajeConfirmacion = texto;
        }));
        this.estado_select_items = [
            { label: '', value: 1 },
            { label: '', value: 0 }
        ];
        var _loop_1 = function (index) {
            /** @type {?} */
            var select_item = this_1.estado_select_items[index];
            if (select_item.value != null) {
                this_1.translateService.get('app.empleado.estado.id_' + select_item.value).subscribe((/**
                 * @param {?} texto
                 * @return {?}
                 */
                function (texto) {
                    _this.estado_select_items[index].label = texto;
                }));
            }
        };
        var this_1 = this;
        for (var index in this.estado_select_items) {
            _loop_1(index);
        }
        this.filtroEstados = [];
        this.filtroEstados.push(1);
        this.mostrar_dialogo_nuevo_empleado = false;
        this.lazyLoadEvent = null;
        this.empleados_loading = true;
        this.empleados = [];
        this.empleados_count = 0;
        this.idEmpresa = this.authenticationService.authentication.empresa.id;
        this.loadCentros();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.loadEmpleadosLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, _a, first, rows, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.empleados_loading = true;
                        this.lazyLoadEvent = event;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 6, 7]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtroNombre != null) {
                            filters['nombre:ct'] = { value: this.filtroNombre };
                        }
                        if (this.filtroNif != null) {
                            filters['nif'] = { value: this.filtroNif };
                        }
                        if (this.filtroEstados != null) {
                            filters['estado:in'] = { value: this.filtroEstados.join(',') };
                        }
                        if (this.filtroCentros != null) {
                            filters['centro:in'] = { value: this.filtroCentros.join(',') };
                        }
                        filters['empresa'] = { value: String(this.idEmpresa) };
                        _a = this;
                        return [4 /*yield*/, this.empleadoService.getEmpleadosCount(filters).toPromise()];
                    case 2:
                        _a.empleados_count = _c.sent();
                        if (!(this.empleados_count == 0)) return [3 /*break*/, 3];
                        this.empleados = [];
                        return [3 /*break*/, 5];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _b = this;
                        return [4 /*yield*/, this.empleadoService.getEmpleados(filters, null, first, rows)
                                .toPromise()];
                    case 4:
                        _b.empleados = _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.empleados_loading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.loadEmpleados = /**
     * @return {?}
     */
    function () {
        this.loadEmpleadosLazy(this.lazyLoadEvent);
    };
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.filtroNombre = null;
        this.filtroNif = null;
        this.filtroEstados = [];
        this.filtroEstados.push(1);
        this.filtroCentros = [];
        this.loadEmpleados();
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.mostarDialogoNuevoEmpleado = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        var _this = this;
        if (empleado == null) {
            this.translateService.get('app.empleado.nuevoCab').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        else {
            this.translateService.get('app.empleado.edicion').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        this.empleadoSeleccionado = empleado;
        this.mostrar_dialogo_nuevo_empleado = true;
    };
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.cerrarDialogoNuevoEmpleado = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nuevo_empleado = false;
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.confirmarEliminar = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        var _this = this;
        this.empleadoSeleccionado = empleado;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.eliminarEmpleados();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.nuevoEmpleadoCreado = /**
     * @return {?}
     */
    function () {
        this.cerrarDialogoNuevoEmpleado();
        this.loadEmpleados();
    };
    /**
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.eliminarEmpleados = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.empleadoSeleccionado != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.empleadoService.eliminarEmpleado(this.empleadoSeleccionado.id).toPromise()];
                        case 1:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 3:
                            this.loadEmpleados();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.enviarInfoEmpleado = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        var _this = this;
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        filters['empleado'] = { value: String(empleado.id) };
        this.empleadoService.enviarInfoEmpleado(filters).toPromise()
            .then((/**
         * @return {?}
         */
        function () {
            _this.translateService.get('app.empleado.correoEnviado').subscribe((/**
             * @param {?} message
             * @return {?}
             */
            function (message) {
                _this.messageService.add({
                    severity: 'warning',
                    summary: message
                });
            }));
        }));
    };
    /**
     * @private
     * @return {?}
     */
    ListaEmpleadosComponent.prototype.loadCentros = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.centro_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: this.idEmpresa.toString() }
        };
        this.centroService.getCentros(filters, null).subscribe((/**
         * @param {?} listaCentros
         * @return {?}
         */
        function (listaCentros) {
            var e_1, _a;
            _this.centros = listaCentros;
            if (listaCentros != null && listaCentros.length > 0) {
                try {
                    for (var listaCentros_1 = __values(listaCentros), listaCentros_1_1 = listaCentros_1.next(); !listaCentros_1_1.done; listaCentros_1_1 = listaCentros_1.next()) {
                        var centro = listaCentros_1_1.value;
                        _this.centro_select_items.push({ label: centro.nombre, value: centro.id });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (listaCentros_1_1 && !listaCentros_1_1.done && (_a = listaCentros_1.return)) _a.call(listaCentros_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.mostrarCentros = true;
            }
            else {
                _this.mostrarCentros = false;
            }
        }));
    };
    ListaEmpleadosComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-lista-empleados',
                    template: "<div class=\"ui-g\">\n  <div class=\"ui-g-12 ui-md-12 ui-lg-12\">\n    <p-panel class=\"filtro_busqueda con_botones\" header=\"{{ 'app.filtro' | translate }}\">\n      <div class=\"ui-g\">\n        <div class=\"ui-g-12 ui-md-4 ui-lg-4\">\n          <label [translate]=\"'app.empleado.nombre'\" [translateParams]=\"{ campo: ('app.empleado.nombre' | translate)}\"></label>\n          <input type=\"text\" pInputText [(ngModel)]=\"filtroNombre\"/>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\">\n          <label [translate]=\"'app.empleado.nif'\" [translateParams]=\"{ campo: ('app.empleado.nif' | translate)}\"></label>\n          <input type=\"text\" pInputText [(ngModel)]=\"filtroNif\"/>\n        </div>\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\" >\n          <label>{{ 'app.empleado.estado' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtroEstados\" [options]=\"estado_select_items\"\n          defaultLabel=\"Activo\"></p-multiSelect>\n        </div>\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\" *ngIf=\"mostrarCentros\">\n          <label>{{ 'app.empleado.centro' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtroCentros\" [options]=\"centro_select_items\" defaultLabel=\"\"></p-multiSelect>\n        </div>\n      </div>\n\n      <p-footer class=\"botones\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadEmpleados()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n          <button type=\"button\" pButton icon=\"pi pi-plus\" (click)=\"mostarDialogoNuevoEmpleado(null)\" label=\"{{ 'app.empleado.nuevo' | translate }}\"></button>\n      </p-footer>\n    </p-panel>\n  </div>\n\n  <div class=\"ui-g-12 ui-md-12 ui-lg-12\">\n    <p-card class=\"texto_centrado\" *ngIf=\"empleados_loading || empleados_count == 0\">\n      <i class=\"pi pi-spin pi-spinner\" *ngIf=\"empleados_loading\"></i>\n      <span *ngIf=\"!empleados_loading && empleados_count == 0\">{{ 'app.sin_registros' | translate }}</span>\n    </p-card>\n\n      <p-table [value]=\"empleados\" dataKey=\"fecha\" [lazy]=\"true\"\n    (onLazyLoad)=\"loadEmpleadosLazy($event)\" [paginator]=\"true\" [rows]=\"rows_per_page\"\n    [totalRecords]=\"empleados_count\" [loading]=\"empleados_loading\">\n        <ng-template pTemplate=\"header\">\n            <tr>\n                <th>{{ 'app.empleado.nombre' | translate }}</th>\n                <th>{{ 'app.empleado.apellidos' | translate }}</th>\n                <th>{{ 'app.empleado.nif' | translate }}</th>\n                <th>{{ 'app.empleado.email' | translate }}</th>\n                <th class=\"w10\"></th>\n            </tr>\n        </ng-template>\n        <ng-template pTemplate=\"body\" let-empleado>\n            <tr>\n                <td>{{empleado.nombre}}</td>\n                <td>{{empleado.apellidos}}</td>\n                <td>{{empleado.nif}}</td>\n                <td>{{empleado.email}}</td>\n                <td class=\"botones\">\n                  <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevoEmpleado(empleado)\"></button>\n                  <button type=\"button\" pButton icon=\"{{ empleado.notificado ? 'pi pi-replay':'pi pi-envelope' }}\" (click)=\"enviarInfoEmpleado(empleado)\" [disabled]=\"empleado.email == null\"></button>\n                  <button type=\"button\" pButton icon=\"pi pi-trash\" (click)=\"confirmarEliminar(empleado)\"></button>\n                </td>\n              </tr>\n        </ng-template>\n      </p-table>\n\n  </div>\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ tituloDialogo }}\" [contentStyle]=\"{'overflow':'visible'}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [focusOnShow]=\"false\" [(visible)]=\"mostrar_dialogo_nuevo_empleado\">\n  <core-nuevo-empleado\n    *ngIf=\"mostrar_dialogo_nuevo_empleado\"\n    [empleadoSeleccionado]=\"empleadoSeleccionado\"\n    [centros]=\"centros\"\n    (successCallback)=\"nuevoEmpleadoCreado()\"\n    (cancelCallback)=\"cerrarDialogoNuevoEmpleado()\"></core-nuevo-empleado>\n</p-dialog>\n\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ListaEmpleadosComponent.ctorParameters = function () { return [
        { type: EmpleadoService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: MessageService },
        { type: CentroService }
    ]; };
    ListaEmpleadosComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaEmpleadosComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/periodo.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PeriodoService = /** @class */ (function () {
    function PeriodoService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/periodos';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    PeriodoService.prototype.getPeriodos = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} periodosRest
         * @return {?}
         */
        function (periodosRest) {
            /** @type {?} */
            var periodos = periodosRest.map((/**
             * @param {?} periodoRest
             * @return {?}
             */
            function (periodoRest) {
                return (/** @type {?} */ (periodoRest));
            }));
            return periodos;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    PeriodoService.prototype.getPeriodosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    PeriodoService.prototype.getOnePeriodo = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getPeriodos(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} periodos
         * @return {?}
         */
        function (periodos) {
            if (periodos == null || periodos.length == 0) {
                return null;
            }
            else {
                return periodos[0];
            }
        })));
    };
    PeriodoService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    PeriodoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ PeriodoService.ngInjectableDef = defineInjectable({ factory: function PeriodoService_Factory() { return new PeriodoService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: PeriodoService, providedIn: "root" });
    return PeriodoService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/empleado/nuevo-empleado/nuevo-empleado.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevoEmpleadoComponent = /** @class */ (function () {
    function NuevoEmpleadoComponent(formBuilder, empleadoService, authenticationService, primeLocaleService, translateService, blockUiService, formService, messageService, periodoService) {
        this.formBuilder = formBuilder;
        this.empleadoService = empleadoService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.messageService = messageService;
        this.periodoService = periodoService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, _c, centro;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.empleado_form = this.formBuilder.group({
                            id: new FormControl(null),
                            fecha_modificado: new FormControl(null),
                            activo: new FormControl(null),
                            verRegistros: new FormControl(null),
                            localizar_registros: new FormControl(null),
                            ficharWeb: new FormControl(null),
                            ficharMovil: new FormControl(null),
                            ficharTablet: new FormControl(null),
                            ficharHuella: new FormControl(null),
                            email: new FormControl(null),
                            centro: new FormControl(null),
                            periodo: new FormControl(null, [Validators.required]),
                            horas: new FormControl(this.empleadoSeleccionado == null ? null : this.empleadoSeleccionado.dedicacionHoras, [
                                this.formService.decimalValidator(), Validators.required
                            ]),
                            observaciones: new FormControl(null, [
                                Validators.maxLength(2000)
                            ]),
                            nombre: new FormControl(null, [
                                Validators.required
                            ]),
                            apellidos: new FormControl(null, [
                                Validators.required
                            ]),
                            nif: new FormControl(null, [
                                Validators.required
                            ]),
                            codigo: new FormControl({ value: '', disabled: true }, [
                                Validators.required
                            ]),
                            idTarjeta: new FormControl(null),
                            diasLaboralesEnSemana: new FormControl(null, [Validators.required])
                        });
                        this.mostrarInputDiasLaborales = false;
                        this.centro_select_items = [];
                        this.centro_select_items.push({ label: '', value: null });
                        if (this.centros != null && this.centros.length > 0) {
                            try {
                                for (_b = __values(this.centros), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    centro = _c.value;
                                    this.centro_select_items.push({ label: centro.nombre, value: centro.id });
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            this.mostrarCentros = true;
                        }
                        else {
                            this.mostrarCentros = false;
                        }
                        return [4 /*yield*/, this.loadPeriodos()];
                    case 1:
                        _d.sent();
                        this.idEmpresa = this.authenticationService.authentication.empresa.id;
                        if (this.empleadoSeleccionado != null) {
                            this.empleado_form.controls['idTarjeta'].setValue(this.empleadoSeleccionado.idTarjeta);
                            this.empleado_form.controls['nombre'].setValue(this.empleadoSeleccionado.nombre);
                            this.empleado_form.controls['apellidos'].setValue(this.empleadoSeleccionado.apellidos);
                            this.empleado_form.controls['nif'].setValue(this.empleadoSeleccionado.nif);
                            this.empleado_form.controls['codigo'].setValue(this.empleadoSeleccionado.codigo);
                            this.empleado_form.controls['activo'].setValue(this.empleadoSeleccionado.activo);
                            this.empleado_form.controls['verRegistros'].setValue(this.empleadoSeleccionado.verRegistros);
                            this.empleado_form.controls['localizar_registros'].setValue(this.empleadoSeleccionado.localizar_registros);
                            this.empleado_form.controls['ficharWeb'].setValue(this.empleadoSeleccionado.ficharWeb);
                            this.empleado_form.controls['ficharMovil'].setValue(this.empleadoSeleccionado.ficharMovil);
                            this.empleado_form.controls['ficharTablet'].setValue(this.empleadoSeleccionado.ficharTablet);
                            this.empleado_form.controls['ficharHuella'].setValue(this.empleadoSeleccionado.ficharHuella);
                            this.empleado_form.controls['email'].setValue(this.empleadoSeleccionado.email);
                            this.empleado_form.controls['observaciones'].setValue(this.empleadoSeleccionado.observaciones);
                            if (this.empleadoSeleccionado.idCentro != null) {
                                this.empleado_form.controls['centro'].setValue(this.empleadoSeleccionado.idCentro);
                            }
                            if (this.empleadoSeleccionado.idPeriodo != null) {
                                this.empleado_form.controls['periodo'].setValue(this.empleadoSeleccionado.idPeriodo);
                                if (this.empleado_form.controls['periodo'].value == 2) {
                                    this.mostrarInputDiasLaborales = true;
                                }
                            }
                            if (this.empleadoSeleccionado.diasPorSemana != null) {
                                this.empleado_form.controls['diasLaboralesEnSemana'].setValue(this.empleadoSeleccionado.diasPorSemana);
                            }
                            this.empleado_form.controls['horas'].setValue(this.empleadoSeleccionado.dedicacionHoras);
                        }
                        else {
                            this.empleado_form.controls['activo'].setValue(true);
                            this.empleado_form.controls['verRegistros'].setValue(true);
                            this.empleado_form.controls['localizar_registros'].setValue(false);
                            this.empleado_form.controls['ficharWeb'].setValue(true);
                            this.empleado_form.controls['ficharMovil'].setValue(true);
                            this.empleado_form.controls['ficharTablet'].setValue(true);
                            this.empleado_form.controls['ficharHuella'].setValue(true);
                            this.generarCodigo();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.agregarValidacionCampoDiasLaboralesEnSemana = /**
     * @return {?}
     */
    function () {
        this.empleado_form.controls['diasLaboralesEnSemana'].setValidators([Validators.required]);
        this.empleado_form.controls['diasLaboralesEnSemana'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.quitaValidacionCampoDiasLaboralesEnSemana = /**
     * @return {?}
     */
    function () {
        this.empleado_form.controls['diasLaboralesEnSemana'].clearValidators();
        this.empleado_form.controls['diasLaboralesEnSemana'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.crearEmpleado = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var dropDownPeriodo = this.empleado_form.controls['periodo'];
        /** @type {?} */
        var PERIODO_DIARIO = 1;
        /*dropDownPeriodo.value==null es para que en caso de que el usuario no elija
        ninguna opción pues que no le salga el popup de que el campo Dias por semana
        es obligatorio ya que este está escondido*/
        if (dropDownPeriodo.value == PERIODO_DIARIO || dropDownPeriodo.value == null) {
            this.quitaValidacionCampoDiasLaboralesEnSemana();
        }
        else {
            this.agregarValidacionCampoDiasLaboralesEnSemana();
        }
        /** @type {?} */
        var empleado = (/** @type {?} */ ({
            idEmpresa: this.idEmpresa,
            idTarjeta: this.empleado_form.controls['idTarjeta'].value,
            nombre: this.empleado_form.controls['nombre'].value,
            apellidos: this.empleado_form.controls['apellidos'].value,
            nif: this.empleado_form.controls['nif'].value,
            codigo: this.empleado_form.controls['codigo'].value,
            activo: this.empleado_form.controls['activo'].value,
            verRegistros: this.empleado_form.controls['verRegistros'].value,
            localizar_registros: this.empleado_form.controls['localizar_registros'].value,
            ficharWeb: this.empleado_form.controls['ficharWeb'].value,
            ficharMovil: this.empleado_form.controls['ficharMovil'].value,
            ficharTablet: this.empleado_form.controls['ficharTablet'].value,
            ficharHuella: this.empleado_form.controls['ficharHuella'].value,
            email: this.empleado_form.controls['email'].value,
            idCentro: this.empleado_form.controls['centro'].value,
            idPeriodo: this.empleado_form.controls['periodo'].value,
            dedicacionHoras: this.empleado_form.controls['horas'].value,
            observaciones: this.empleado_form.controls['observaciones'].value,
            diasPorSemana: this.empleado_form.controls['diasLaboralesEnSemana'].value
        }));
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.formService.onSubmitFormValidation(_this.empleado_form, 'app.empleado.', (/**
             * @return {?}
             */
            function () { return __awaiter(_this, void 0, void 0, function () {
                var error_1, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.empleadoSeleccionado != null)) return [3 /*break*/, 5];
                            //Actualizar
                            empleado.id = this.empleadoSeleccionado.id;
                            empleado.fecha_modificado = this.empleadoSeleccionado.fecha_modificado;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.empleadoService.actualizarEmpleado(empleado).toPromise()];
                        case 2:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 8];
                        case 5:
                            _a.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.empleadoService.anyadirEmpleado(empleado).toPromise()];
                        case 6:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 8];
                        case 7:
                            error_2 = _a.sent();
                            reject();
                            return [3 /*break*/, 8];
                        case 8: return [2 /*return*/];
                    }
                });
            }); }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
        return;
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.generarCodigo = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        filters['empresa'] = { value: String(this.idEmpresa) };
        this.empleadoService.generarCodigo(filters).subscribe((/**
         * @param {?} codigo
         * @return {?}
         */
        function (codigo) {
            _this.codigo = codigo;
            _this.empleado_form.controls['codigo'].setValue(_this.codigo);
        }));
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.enviarInfoEmpleado = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var filters = (/** @type {?} */ ({}));
        filters['empleado'] = { value: String(this.empleadoSeleccionado.id) };
        this.empleadoService.enviarInfoEmpleado(filters).toPromise()
            .then((/**
         * @return {?}
         */
        function () {
            _this.translateService.get('app.empleado.correoEnviado').subscribe((/**
             * @param {?} message
             * @return {?}
             */
            function (message) {
                _this.messageService.add({
                    severity: 'warning',
                    summary: message
                });
            }));
        }));
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    /**
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.onChangePeriodo = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var dropDownPeriodo = this.empleado_form.controls['periodo'];
        /** @type {?} */
        var containerFieldHoras = document.getElementById('containerhoras');
        if (dropDownPeriodo.value == 2) {
            containerFieldHoras.classList.replace("ui-g-3", "ui-g-2");
            this.mostrarInputDiasLaborales = true;
        }
        else {
            containerFieldHoras.classList.replace("ui-g-2", "ui-g-3");
            this.mostrarInputDiasLaborales = false;
        }
    };
    /**
     * @private
     * @return {?}
     */
    NuevoEmpleadoComponent.prototype.loadPeriodos = /**
     * @private
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, _a, listaPeriodos, listaPeriodos_1, listaPeriodos_1_1, periodo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.periodo_select_items = [];
                        return [4 /*yield*/, this.periodoService.getPeriodos(null, null).toPromise()];
                    case 1:
                        listaPeriodos = _b.sent();
                        this.periodos = listaPeriodos;
                        this.periodo_select_items.push({ label: '', value: null });
                        try {
                            for (listaPeriodos_1 = __values(listaPeriodos), listaPeriodos_1_1 = listaPeriodos_1.next(); !listaPeriodos_1_1.done; listaPeriodos_1_1 = listaPeriodos_1.next()) {
                                periodo = listaPeriodos_1_1.value;
                                this.periodo_select_items.push({ label: periodo.nombre, value: periodo.id });
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (listaPeriodos_1_1 && !listaPeriodos_1_1.done && (_a = listaPeriodos_1.return)) _a.call(listaPeriodos_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NuevoEmpleadoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-nuevo-empleado',
                    template: "<form [formGroup]=\"empleado_form\" (ngSubmit)=\"crearEmpleado()\">\n\n  <div class=\"ui-g\">\n    <div class=\"ui-g-3\">\n      <label>{{ 'app.empleado.codigo' | translate }} *</label>\n\n      <div class=\"ui-inputgroup\">\n        <input type=\"text\" formControlName=\"codigo\" pInputText class=\"w4\"/>\n        <button type=\"button\" pButton icon=\"pi pi-replay\" (click)=\"generarCodigo()\" class=\"botonLado\"></button>\n      </div>\n    </div>\n\n    <div class=\"ui-g-9\">\n      <label>{{ 'app.empleado.nif' | translate }} *</label>\n      <input type=\"text\" formControlName=\"nif\" pInputText class=\"w7\"/>\n    </div>\n    \n    <div class=\"ui-g-12\">\n    <label>{{ 'app.empleado.idTarjeta' | translate }} </label>\n    <input type=\"text\" formControlName=\"idTarjeta\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empleado.nombre' | translate }} *</label>\n      <input type=\"text\" formControlName=\"nombre\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empleado.apellidos' | translate }} *</label>\n      <input type=\"text\" formControlName=\"apellidos\" pInputText/>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empleado.email' | translate }}</label>\n      <input type=\"text\" formControlName=\"email\" pInputText />\n    </div>\n    <div class=\"ui-g-12\" *ngIf=\"mostrarCentros\" >\n      <label>{{ 'app.empleado.centro' | translate }} </label>\n      <p-dropdown [options]=\"centro_select_items\" formControlName=\"centro\"></p-dropdown>\n    </div>\n\n    <div class=\"ui-g\">\n      <div class=\"ui-g-6\">\n        <label>{{ 'app.empleado.periodo' | translate }} *</label>\n        <p-dropdown [options]=\"periodo_select_items\" formControlName=\"periodo\" (onChange)=\"onChangePeriodo()\"></p-dropdown>\n      </div>\n      <div class=\"ui-g-3\" id=\"containerhoras\">\n        <label>{{ 'app.empleado.horas' | translate }} *</label>\n        <input type=\"text\" formControlName=\"horas\" pInputText/>\n      </div>\n      <div class=\"ui-g-4\" *ngIf=\"mostrarInputDiasLaborales\">\n    \t<label>{{ 'app.empleado.diasLaboralesEnSemana' | translate }} *</label>\n    \t<input type=\"number\" formControlName=\"diasLaboralesEnSemana\" pInputText min=\"1\" max=\"7\"/>\n    </div>\n    </div>\n    \n    <div class=\"ui-g-12\">\n      <label>{{ 'app.empleado.observaciones' | translate }} </label>\n      <textarea [rows]=\"6\" formControlName=\"observaciones\" pInputTextarea></textarea>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <p-checkbox formControlName=\"activo\" binary=\"true\"></p-checkbox>\n      <label class=\"inline\">{{ 'app.empleado.activo' | translate }}</label>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <p-checkbox formControlName=\"verRegistros\" binary=\"true\"></p-checkbox>\n      <label class=\"inline\">{{ 'app.empleado.verRegistros' | translate }}</label>\n    </div>\n\n    <div class=\"ui-g-12\">\n      <p-checkbox formControlName=\"localizar_registros\" binary=\"true\"></p-checkbox>\n      <label class=\"inline\">{{ 'app.empleado.localizar_registros' | translate }}</label>\n    </div>\n\n\n    <div class=\"ui-g-12\">\n      <fieldset>\n        <legend >{{ 'app.empleado.permisos' | translate }}</legend>\n\n        <div class=\"ui-g-6\">\n          <p-checkbox formControlName=\"ficharWeb\" binary=\"true\"></p-checkbox>\n          <label class=\"inline\">{{ 'app.empleado.permisoWeb' | translate }}</label>\n        </div>\n\n        <div class=\"ui-g-6\">\n          <p-checkbox formControlName=\"ficharMovil\" binary=\"true\"></p-checkbox>\n          <label class=\"inline\">{{ 'app.empleado.permisoMovil' | translate }}</label>\n        </div>\n\n        <div class=\"ui-g-6\">\n          <p-checkbox formControlName=\"ficharTablet\" binary=\"true\"></p-checkbox>\n          <label class=\"inline\">{{ 'app.empleado.permisoTablet' | translate }}</label>\n        </div>\n\n        <div class=\"ui-g-6\">\n          <p-checkbox formControlName=\"ficharHuella\" binary=\"true\"></p-checkbox>\n          <label class=\"inline\">{{ 'app.empleado.permisoHuella' | translate }}</label>\n        </div>\n      </fieldset>\n    </div>\n  </div>\n\n  <p-footer class=\"botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-envelope\" (click)=\"enviarInfoEmpleado()\" *ngIf=\"empleadoSeleccionado != null\"\n      [disabled]=\"empleadoSeleccionado.email == null\" label=\"{{ 'app.empleado.enviarInfo' | translate }}\"></button>\n  </p-footer>\n</form>\n",
                    styles: [".margenIzq{margin-left:1em}.botonLado{float:right}"]
                }] }
    ];
    /** @nocollapse */
    NuevoEmpleadoComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: EmpleadoService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: FormService },
        { type: MessageService },
        { type: PeriodoService }
    ]; };
    NuevoEmpleadoComponent.propDecorators = {
        empleadoSeleccionado: [{ type: Input }],
        centros: [{ type: Input }],
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return NuevoEmpleadoComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tipo_registro/lista-tipos_registro/lista-tipos_registro.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaTiposRegistroComponent = /** @class */ (function () {
    function ListaTiposRegistroComponent(tipoRegistroService, authenticationService, primeLocaleService, confirmationService, translateService, blockUiService, eventEmiterService, messageService, iconoService) {
        this.tipoRegistroService = tipoRegistroService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.messageService = messageService;
        this.iconoService = iconoService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.rows_per_page = 10;
        this.first_page = 0;
        this.mostrar_dialogo_nuevo_tipo_registro = false;
        this.lazyLoadEvent = null;
        this.tipos_registro_loading = true;
        this.tipos_registro = [];
        this.tipos_registro_count = 0;
        this.empresa = this.authenticationService.authentication.empresa.id;
    }
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.eventEmiterService.empresaActualOnChange.subscribe((/**
                         * @return {?}
                         */
                        function () {
                            _this.loadTiposRegistro();
                        }));
                        _a = this;
                        return [4 /*yield*/, this.translateService.get('app.mensaje.confirmacion').toPromise()];
                    case 1:
                        _a.mensajeConfirmacion = _f.sent();
                        _b = this;
                        _c = {};
                        return [4 /*yield*/, this.translateService.get('app.activo').toPromise()];
                    case 2:
                        _d = [(_c.label = _f.sent(),
                                _c.value = true,
                                _c)];
                        _e = {};
                        return [4 /*yield*/, this.translateService.get('app.inactivo').toPromise()];
                    case 3:
                        _b.activo_select_items = _d.concat([(_e.label = _f.sent(),
                                _e.value = false,
                                _e)]);
                        this.filtro_activo = [this.activo_select_items[0].value];
                        this.iconos_map = {};
                        return [4 /*yield*/, this.iconoService.getIconos().toPromise().then((/**
                             * @param {?} iconos
                             * @return {?}
                             */
                            function (iconos) {
                                var e_1, _a;
                                try {
                                    for (var iconos_1 = __values(iconos), iconos_1_1 = iconos_1.next(); !iconos_1_1.done; iconos_1_1 = iconos_1.next()) {
                                        var icono = iconos_1_1.value;
                                        _this.iconos_map[icono.id] = icono;
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (iconos_1_1 && !iconos_1_1.done && (_a = iconos_1.return)) _a.call(iconos_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                            }))];
                    case 4:
                        _f.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.loadTiposRegistroLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, _a, filters, _b, first, rows, _c, _d, _e, tipos_registro, _f, _g, e_2_1;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.tipos_registro_loading = true;
                        this.lazyLoadEvent = event;
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, , 13, 14]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtro_nombre != null) {
                            filters['nombre:ct'] = { value: this.filtro_nombre };
                        }
                        if (this.filtro_activo != null) {
                            filters['activo:in'] = { value: this.filtro_activo.join(',') };
                        }
                        filters['empresa'] = { value: String(this.empresa) };
                        _b = this;
                        return [4 /*yield*/, this.tipoRegistroService.getTiposRegistroCount(filters).toPromise()];
                    case 2:
                        _b.tipos_registro_count = _h.sent();
                        if (!(this.tipos_registro_count == 0)) return [3 /*break*/, 3];
                        this.tipos_registro = [];
                        return [3 /*break*/, 12];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _c = this;
                        return [4 /*yield*/, this.tipoRegistroService.getTiposRegistro(filters, null, first, rows).toPromise()];
                    case 4:
                        _c.tipos_registro = _h.sent();
                        _h.label = 5;
                    case 5:
                        _h.trys.push([5, 10, 11, 12]);
                        _d = __values(this.tipos_registro), _e = _d.next();
                        _h.label = 6;
                    case 6:
                        if (!!_e.done) return [3 /*break*/, 9];
                        tipos_registro = _e.value;
                        if (!(tipos_registro.icono != null && this.iconos_map[tipos_registro.icono] == null)) return [3 /*break*/, 8];
                        _f = this.iconos_map;
                        _g = tipos_registro.icono;
                        return [4 /*yield*/, this.iconoService.getIcono(tipos_registro.icono, true).toPromise()];
                    case 7:
                        _f[_g] = _h.sent();
                        _h.label = 8;
                    case 8:
                        _e = _d.next();
                        return [3 /*break*/, 6];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_2_1 = _h.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        this.tipos_registro_loading = false;
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.loadTiposRegistro = /**
     * @return {?}
     */
    function () {
        this.loadTiposRegistroLazy(this.lazyLoadEvent);
    };
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.filtro_nombre = null;
        this.filtro_activo = [this.activo_select_items[0].value];
        this.loadTiposRegistro();
    };
    /**
     * @param {?} tipo_registro
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.mostarDialogoNuevoTipoRegistro = /**
     * @param {?} tipo_registro
     * @return {?}
     */
    function (tipo_registro) {
        var _this = this;
        if (tipo_registro == null) {
            this.translateService.get('app.tipo_registro.nuevo').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        else {
            this.translateService.get('app.tipo_registro.edicion').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        this.tipo_registro_seleccionado = tipo_registro;
        this.mostrar_dialogo_nuevo_tipo_registro = true;
    };
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.cerrarDialogoNuevoTipoRegistro = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nuevo_tipo_registro = false;
    };
    /**
     * @param {?} tipo_registro
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.confirmarEliminar = /**
     * @param {?} tipo_registro
     * @return {?}
     */
    function (tipo_registro) {
        var _this = this;
        this.tipo_registro_seleccionado = tipo_registro;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.eliminarTiposRegistro();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.nuevoTipoRegistroCreado = /**
     * @return {?}
     */
    function () {
        this.cerrarDialogoNuevoTipoRegistro();
        this.loadTiposRegistro();
    };
    /**
     * @return {?}
     */
    ListaTiposRegistroComponent.prototype.eliminarTiposRegistro = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.tipo_registro_seleccionado != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.tipoRegistroService.eliminarTipoRegistro(this.tipo_registro_seleccionado.id).toPromise()];
                        case 1:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 3:
                            this.loadTiposRegistro();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    ListaTiposRegistroComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-lista-tipos_registro',
                    template: "<div class=\"ui-g\">\n  <div class=\"ui-g-12 ui-md-12 ui-lg-12\">\n    <p-panel class=\"filtro_busqueda con_botones\" header=\"{{ 'app.filtro' | translate }}\">\n      <div class=\"ui-g\">\n        <div class=\"ui-g-12 ui-md-4 ui-lg-4\">\n          <label [translate]=\"'app.tipo_registro.nombre'\" [translateParams]=\"{ campo: ('app.tipo_registro.nombre' | translate)}\"></label>\n          <input type=\"text\" pInputText [(ngModel)]=\"filtro_nombre\"/>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-4 ui-lg-2\" >\n          <label>{{ 'app.tipo_registro.activo' | translate }}</label>\n          <p-multiSelect [(ngModel)]=\"filtro_activo\" [options]=\"activo_select_items\" defaultLabel=\"\"></p-multiSelect>\n        </div>\n      </div>\n\n      <p-footer class=\"botones\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadTiposRegistro()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n        <button type=\"button\" pButton icon=\"pi pi-plus\" (click)=\"mostarDialogoNuevoTipoRegistro(null)\" label=\"{{ 'app.tipo_registro.nuevo' | translate }}\"></button>\n      </p-footer>\n    </p-panel>\n  </div>\n\n  <div class=\"ui-g-12 ui-md-12 ui-lg-12\">\n      <p-table [value]=\"tipos_registro\" dataKey=\"id\" [lazy]=\"true\"\n        (onLazyLoad)=\"loadTiposRegistroLazy($event)\" [paginator]=\"true\" [rows]=\"rows_per_page\"\n        [totalRecords]=\"tipos_registro_count\" [loading]=\"tipos_registro_loading\">\n        <ng-template pTemplate=\"header\">\n            <tr>\n                <th class=\"w5 centro\">{{ 'app.tipo_registro.icono' | translate }}</th>\n                <th>{{ 'app.tipo_registro.nombre' | translate }}</th>\n                <th class=\"w7\"></th>\n            </tr>\n        </ng-template>\n        <ng-template pTemplate=\"body\" let-tipo_registro>\n            <tr>\n                <td class=\"centro\"><mat-icon *ngIf=\"tipo_registro.icono != null\">{{ iconos_map[tipo_registro.icono].nombre }}</mat-icon></td>\n                <td>{{ tipo_registro.nombre }}</td>\n                <td class=\"botones\">\n                  <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevoTipoRegistro(tipo_registro)\"></button>\n                  <button type=\"button\" pButton icon=\"pi pi-trash\" (click)=\"confirmarEliminar(tipo_registro)\"></button>\n                </td>\n              </tr>\n        </ng-template>\n        <ng-template pTemplate=\"emptymessage\">\n          <tr class=\"no_data\">\n              <td colspan=\"3\">{{ 'app.sin_registros' | translate }}</td>\n          </tr>\n      </ng-template>\n      </p-table>\n  </div>\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ tituloDialogo }}\" [contentStyle]=\"{'overflow':'visible'}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [focusOnShow]=\"false\" [(visible)]=\"mostrar_dialogo_nuevo_tipo_registro\">\n  <core-nuevo-tipo_registro\n    *ngIf=\"mostrar_dialogo_nuevo_tipo_registro\"\n    [tipo_registro_seleccionado]=\"tipo_registro_seleccionado\"\n    [iconos_map]=\"iconos_map\"\n    (successCallback)=\"nuevoTipoRegistroCreado()\"\n    (cancelCallback)=\"cerrarDialogoNuevoTipoRegistro()\"></core-nuevo-tipo_registro>\n</p-dialog>\n\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ListaTiposRegistroComponent.ctorParameters = function () { return [
        { type: SubtipoRegistroService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: MessageService },
        { type: IconoService }
    ]; };
    ListaTiposRegistroComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaTiposRegistroComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tipo_registro/nuevo-tipo_registro/nuevo-tipo_registro.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevoTipoRegistroComponent = /** @class */ (function () {
    function NuevoTipoRegistroComponent(formBuilder, tipoRegistroService, authenticationService, primeLocaleService, translateService, blockUiService, formService, messageService) {
        this.formBuilder = formBuilder;
        this.tipoRegistroService = tipoRegistroService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NuevoTipoRegistroComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tipo_registro_form = this.formBuilder.group({
            id: new FormControl(this.tipo_registro_seleccionado == null ? null : this.tipo_registro_seleccionado.id),
            empresa: new FormControl(this.tipo_registro_seleccionado == null ? this.authenticationService.authentication.empresa.id : this.tipo_registro_seleccionado.empresa),
            nombre: new FormControl(this.tipo_registro_seleccionado == null ? null : this.tipo_registro_seleccionado.nombre, [
                Validators.required
            ]),
            icono: new FormControl(this.tipo_registro_seleccionado == null ? null : this.tipo_registro_seleccionado.icono, [
                Validators.required
            ]),
            activo: new FormControl(this.tipo_registro_seleccionado == null ? null : this.tipo_registro_seleccionado.activo),
            fecha_modificado: new FormControl(this.tipo_registro_seleccionado == null ? null : this.tipo_registro_seleccionado.fecha_modificado)
        });
    };
    Object.defineProperty(NuevoTipoRegistroComponent.prototype, "iconos_map", {
        get: /**
         * @return {?}
         */
        function () {
            return this._iconos_map;
        },
        set: /**
         * @param {?} iconos_map
         * @return {?}
         */
        function (iconos_map) {
            var _this = this;
            this._iconos_map = iconos_map;
            this.iconos_select_items = [{
                    label: '',
                    value: null
                }];
            Object.keys(iconos_map).forEach((/**
             * @param {?} id
             * @return {?}
             */
            function (id) {
                /** @type {?} */
                var icono = _this._iconos_map[id];
                _this.iconos_select_items.push({
                    label: icono.nombre,
                    value: icono.id,
                    disabled: !icono.activo
                });
            }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NuevoTipoRegistroComponent.prototype.crearTipoRegistro = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.tipo_registro_form.value.icono == null) {
            this.tipo_registro_form.value.icono = 0;
        }
        if (this.tipo_registro_form.value.activo == null) {
            this.tipo_registro_form.value.activo = false;
        }
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.formService.onSubmitFormValidation(_this.tipo_registro_form, 'app.tipo_registro.', (/**
             * @return {?}
             */
            function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.tipoRegistroService.guardarTipoRegistro(this.tipo_registro_form.value).toPromise().then((/**
                     * @return {?}
                     */
                    function () {
                        _this.successCallback.emit(null);
                        resolve();
                    })).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject();
                    }));
                    return [2 /*return*/];
                });
            }); }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
        return;
    };
    /**
     * @return {?}
     */
    NuevoTipoRegistroComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    NuevoTipoRegistroComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-nuevo-tipo_registro',
                    template: "<form [formGroup]=\"tipo_registro_form\" (ngSubmit)=\"crearTipoRegistro()\">\n  <div class=\"ui-g\">\n    <div class=\"ui-g-2\">\n      <label>{{ 'app.tipo_registro.icono' | translate }} *</label>\n      <p-dropdown styleClass=\"icono\" [options]=\"iconos_select_items\" formControlName=\"icono\" appendTo=\"body\">\n        <ng-template let-item pTemplate=\"selectedItem\">\n          <mat-icon *ngIf=\"item.value != null && iconos_map[item.value] != null\">{{ iconos_map[item.value].nombre }}</mat-icon>\n        </ng-template>\n        <ng-template let-item pTemplate=\"item\">\n          <mat-icon *ngIf=\"item.value != null && iconos_map[item.value] != null\">{{ iconos_map[item.value].nombre }}</mat-icon>\n        </ng-template>\n      </p-dropdown>\n    </div>\n\n    <div class=\"ui-g-10\">\n      <label>{{ 'app.tipo_registro.nombre' | translate }} *</label>\n      <input type=\"text\" formControlName=\"nombre\" pInputText/>\n    </div>\n  </div>\n\n  <p-footer class=\"botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\"></button>\n  </p-footer>\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NuevoTipoRegistroComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: SubtipoRegistroService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: FormService },
        { type: MessageService }
    ]; };
    NuevoTipoRegistroComponent.propDecorators = {
        tipo_registro_seleccionado: [{ type: Input }],
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }],
        iconos_map: [{ type: Input }]
    };
    return NuevoTipoRegistroComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/motivo-ausencia.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MotivoAusenciaService = /** @class */ (function () {
    function MotivoAusenciaService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/motivosAusencia';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    MotivoAusenciaService.prototype.getMotivosAusencias = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} motivosAusenciaRest
         * @return {?}
         */
        function (motivosAusenciaRest) {
            /** @type {?} */
            var motivosAusencia = motivosAusenciaRest.map((/**
             * @param {?} motivoAusenciaRest
             * @return {?}
             */
            function (motivoAusenciaRest) {
                return (/** @type {?} */ (motivoAusenciaRest));
            }));
            return motivosAusencia;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    MotivoAusenciaService.prototype.getMotivosAusenciasCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    MotivoAusenciaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    MotivoAusenciaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ MotivoAusenciaService.ngInjectableDef = defineInjectable({ factory: function MotivoAusenciaService_Factory() { return new MotivoAusenciaService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: MotivoAusenciaService, providedIn: "root" });
    return MotivoAusenciaService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/ausencia.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AusenciaService = /** @class */ (function () {
    function AusenciaService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/ausencias';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    AusenciaService.prototype.getAusencias = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} ausenciasRest
         * @return {?}
         */
        function (ausenciasRest) {
            /** @type {?} */
            var ausencias = ausenciasRest.map((/**
             * @param {?} ausenciaRest
             * @return {?}
             */
            function (ausenciaRest) {
                return (/** @type {?} */ (ausenciaRest));
            }));
            return ausencias;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    AusenciaService.prototype.getAusenciasCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    AusenciaService.prototype.getOneAusencia = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getAusencias(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} ausencias
         * @return {?}
         */
        function (ausencias) {
            if (ausencias == null || ausencias.length == 0) {
                return null;
            }
            else {
                return ausencias[0];
            }
        })));
    };
    /**
     * @param {?} ausencia
     * @return {?}
     */
    AusenciaService.prototype.anyadirAusencia = /**
     * @param {?} ausencia
     * @return {?}
     */
    function (ausencia) {
        /** @type {?} */
        var ausencia_post = (/** @type {?} */ ({
            comentario: ausencia.comentario,
            fechaInicio: ausencia.fechaInicio,
            fechaFin: ausencia.fechaFin,
            motivo: ausencia.motivo,
            empleado: ausencia.empleado,
            medioDia: ausencia.medioDia,
            horas: ausencia.horas,
            diasEnteros: ausencia.diasEnteros
        }));
        return this.http.post(this.base_url, ausencia_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idAusencia
     * @return {?}
     */
    AusenciaService.prototype.eliminarAusencia = /**
     * @param {?} idAusencia
     * @return {?}
     */
    function (idAusencia) {
        return this.http.delete(this.base_url + '/' + idAusencia).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} ausencia
     * @return {?}
     */
    AusenciaService.prototype.actualizarAusencia = /**
     * @param {?} ausencia
     * @return {?}
     */
    function (ausencia) {
        /** @type {?} */
        var ausencia_put = (/** @type {?} */ ({
            id: ausencia.id,
            comentario: ausencia.comentario,
            fechaInicio: ausencia.fechaInicio,
            fechaFin: ausencia.fechaFin,
            motivo: ausencia.motivo,
            empleado: ausencia.empleado,
            medioDia: ausencia.medioDia,
            horas: ausencia.horas,
            diasEnteros: ausencia.diasEnteros
        }));
        return this.http.put(this.base_url + '/' + ausencia_put.id, ausencia_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    AusenciaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AusenciaService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ AusenciaService.ngInjectableDef = defineInjectable({ factory: function AusenciaService_Factory() { return new AusenciaService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: AusenciaService, providedIn: "root" });
    return AusenciaService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/ausencia/lista-ausencias/lista-ausencias.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaAusenciasComponent = /** @class */ (function () {
    function ListaAusenciasComponent(ausenciaService, empleadoService, motivoAusenciaService, authenticationService, confirmationService, translateService, blockUiService, eventEmiterService, messageService) {
        this.ausenciaService = ausenciaService;
        this.empleadoService = empleadoService;
        this.motivoAusenciaService = motivoAusenciaService;
        this.authenticationService = authenticationService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.motivo_select_items = [];
        this.rows_per_page = 10;
        this.first_page = 0;
        this.empleado_select_items = [];
    }
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.eventEmiterService.empresaActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargaOnInit();
        }));
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaAusenciasComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.translateService.get('app.mensaje.confirmacion').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.mensajeConfirmacion = texto;
        }));
        this.submenu_items = [
            {
                label: '',
                command: (/**
                 * @param {?} event
                 * @return {?}
                 */
                function (event) {
                    _this.mostarDialogoNuevaAusencia(null);
                })
            }
        ];
        this.translateService.get('app.ausencia.submenu.nueva').subscribe((/**
         * @param {?} texto
         * @return {?}
         */
        function (texto) {
            _this.submenu_items[0].label = texto;
        }));
        this.mostrar_dialogo_nueva_ausencia = false;
        this.lazyLoadEvent = null;
        this.ausencias_loading = false;
        this.ausencias = [];
        this.ausencias_count = 0;
        this.auth_empresa = false;
        if (this.authenticationService.authentication.tipo == this.authenticationService.authUsuario) {
            this.auth_empresa = true;
            this.cargarEmpleados();
        }
        this.cargarMotivos();
        this.loadAusencias();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaAusenciasComponent.prototype.loadAusenciasLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, empresaId, _a, first, rows, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.ausencias_loading = true;
                        this.lazyLoadEvent = event;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 6, 7]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtro_motivos != null) {
                            filters['motivo:in'] = { value: this.filtro_motivos.join(',') };
                        }
                        if (this.auth_empresa) {
                            if (this.filtro_empleados != null) {
                                filters['empleado:in'] = { value: this.filtro_empleados.join(',') };
                            }
                        }
                        else {
                            filters['empleado'] = { value: String(this.authenticationService.authentication.user.id) };
                        }
                        if (this.auth_empresa) {
                            empresaId = new String(this.authenticationService.authentication.empresa.id);
                            filters['empresa'] = { value: String(empresaId) };
                        }
                        _a = this;
                        return [4 /*yield*/, this.ausenciaService.getAusenciasCount(filters).toPromise()];
                    case 2:
                        _a.ausencias_count = _c.sent();
                        if (!(this.ausencias_count === 0)) return [3 /*break*/, 3];
                        this.ausencias = [];
                        return [3 /*break*/, 5];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _b = this;
                        return [4 /*yield*/, this.ausenciaService.getAusencias(filters, null, first, rows)
                                .toPromise()];
                    case 4:
                        _b.ausencias = _c.sent();
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.ausencias_loading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.loadAusencias = /**
     * @return {?}
     */
    function () {
        this.loadAusenciasLazy(this.lazyLoadEvent);
    };
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.filtro_empleados = null;
        this.filtro_motivos = null;
        this.loadAusencias();
    };
    /**
     * @private
     * @return {?}
     */
    ListaAusenciasComponent.prototype.cargarEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.empleado_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() }
        };
        this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            var e_1, _a;
            _this.empleados = listaEmpleados;
            try {
                for (var listaEmpleados_1 = __values(listaEmpleados), listaEmpleados_1_1 = listaEmpleados_1.next(); !listaEmpleados_1_1.done; listaEmpleados_1_1 = listaEmpleados_1.next()) {
                    var empleado = listaEmpleados_1_1.value;
                    _this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado.id });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (listaEmpleados_1_1 && !listaEmpleados_1_1.done && (_a = listaEmpleados_1.return)) _a.call(listaEmpleados_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }));
    };
    /**
     * @private
     * @return {?}
     */
    ListaAusenciasComponent.prototype.cargarMotivos = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.motivo_select_items = [];
        this.motivoAusenciaService.getMotivosAusencias(null, null).subscribe((/**
         * @param {?} listaMotivos
         * @return {?}
         */
        function (listaMotivos) {
            var e_2, _a;
            _this.motivos = listaMotivos;
            try {
                for (var listaMotivos_1 = __values(listaMotivos), listaMotivos_1_1 = listaMotivos_1.next(); !listaMotivos_1_1.done; listaMotivos_1_1 = listaMotivos_1.next()) {
                    var motivo = listaMotivos_1_1.value;
                    _this.motivo_select_items.push({ label: motivo.nombre, value: motivo.id });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (listaMotivos_1_1 && !listaMotivos_1_1.done && (_a = listaMotivos_1.return)) _a.call(listaMotivos_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }));
    };
    /**
     * @param {?} ausencia
     * @return {?}
     */
    ListaAusenciasComponent.prototype.mostarDialogoNuevaAusencia = /**
     * @param {?} ausencia
     * @return {?}
     */
    function (ausencia) {
        var _this = this;
        if (ausencia == null) {
            this.translateService.get('app.ausencia.nuevo').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        else {
            this.translateService.get('app.ausencia.edicion').subscribe((/**
             * @param {?} texto
             * @return {?}
             */
            function (texto) {
                _this.tituloDialogo = texto;
            }));
        }
        this.ausenciaEdicion = ausencia;
        this.mostrar_dialogo_nueva_ausencia = true;
    };
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.cerrarDialogoNuevaAusencia = /**
     * @return {?}
     */
    function () {
        this.mostrar_dialogo_nueva_ausencia = false;
    };
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.nuevaAusenciaCreada = /**
     * @return {?}
     */
    function () {
        this.loadAusencias();
        this.cerrarDialogoNuevaAusencia();
    };
    /**
     * @param {?} ausencia
     * @return {?}
     */
    ListaAusenciasComponent.prototype.confirmarEliminar = /**
     * @param {?} ausencia
     * @return {?}
     */
    function (ausencia) {
        var _this = this;
        this.ausenciaEdicion = ausencia;
        this.confirmationService.confirm({
            message: this.mensajeConfirmacion,
            accept: (/**
             * @return {?}
             */
            function () {
                _this.eliminarAusencia();
            })
        });
    };
    /**
     * @return {?}
     */
    ListaAusenciasComponent.prototype.eliminarAusencia = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.ausenciaEdicion != null) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.ausenciaService.eliminarAusencia(String(this.ausenciaEdicion.id)).toPromise()];
                        case 1:
                            _a.sent();
                            this.successCallback.emit(null);
                            resolve();
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 3:
                            this.loadAusencias();
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })));
        }
    };
    ListaAusenciasComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-lista-ausencias',
                    template: "<p-menubar [model]=\"submenu_items\"></p-menubar>\n\n<div id=\"contenido\">\n  <p-panel class=\"filtro_busqueda\" header=\"{{ 'app.filtro' | translate }}\">\n    <div class=\"ui-g\">\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\" *ngIf=\"auth_empresa\" >\n        <label>{{ 'app.filtro.empleado' | translate }}</label>\n        <p-multiSelect [(ngModel)]=\"filtro_empleados\" [options]=\"empleado_select_items\"\n        defaultLabel=\"\" ></p-multiSelect>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\">\n        <label>{{ 'app.ausencia.motivo' | translate }}</label>\n        <p-multiSelect [(ngModel)]=\"filtro_motivos\" [options]=\"motivo_select_items\" defaultLabel=\"\"></p-multiSelect>\n      </div>\n\n      <div class=\"ui-g-12\">\n          <p-footer class=\"botones\">\n        <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadAusencias()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n          <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n            </p-footer>\n      </div>\n    </div>\n  </p-panel>\n\n  <p-card class=\"texto_centrado\" *ngIf=\"ausencias_loading || ausencias_count == 0\">\n    <i class=\"pi pi-spin pi-spinner\" *ngIf=\"ausencias_loading\"></i>\n    <span *ngIf=\"!ausencias_loading && ausencias_count == 0\">{{ 'app.sin_registros' | translate }}</span>\n  </p-card>\n\n  <div class=\"ui-g\" *ngIf=\"!ausencias_loading && ausencias_count > 0\">\n    <p-card class=\"ausencia ui-g-12\" *ngFor=\"let ausencia of ausencias\">\n      <div class=\"ui-g\">\n        <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n          <label>{{ 'app.ausencia.empleado' | translate }}</label>\n          <span>{{ ausencia.empleado.nombre }} {{ ausencia.empleado.apellidos }}</span>\n        </div>\n        <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n          <label>{{ 'app.ausencia.fecha_inicio' | translate }}</label>\n          <span>{{ ausencia.fechaInicio | date: 'dd/MM/yyyy HH:mm' }}</span>\n        </div>\n\n        <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n          <label>{{ 'app.ausencia.fecha_fin' | translate }}</label>\n          <span>{{ ausencia.fechaFin | date: 'dd/MM/yyyy HH:mm' }}</span>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-12 ui-lg-4\" >\n          <label>{{ 'app.ausencia.motivo' | translate }}</label>\n          <span>{{ ausencia.motivo.nombre }}</span>\n        </div>\n\n        <div class=\"ui-g-1 flotarIzq\" >\n            <button type=\"button\" pButton icon=\"pi pi-pencil\" (click)=\"mostarDialogoNuevaAusencia(ausencia)\"></button>\n        </div>\n        <div class=\"ui-g-1 \" >\n            <button type=\"button\" pButton icon=\"pi pi-trash\" (click)=\"confirmarEliminar(ausencia)\"></button>\n        </div>\n\n        <div class=\"ui-g-12 ui-md-12 ui-lg-12\" *ngIf=\"ausencia.comentario != null && ausencia.comentario !== ''\">\n          <label>{{ 'app.ausencia.comentario' | translate }}</label>\n          <span class=\"multiline\">{{ ausencia.comentario }}</span>\n        </div>\n\n      </div>\n    </p-card>\n  </div>\n\n  <p-paginator class=\"espaciado_superior\"\n    [rows]=\"rows_per_page\" [totalRecords]=\"ausencias_count\" [templateRight]=\"ausencias_count == 0 ? null : registros\"\n    (onPageChange)=\"loadAusenciasLazy($event)\"></p-paginator>\n\n  <ng-template #registros>\n    <div [translate]=\"'app.total_registros'\" [translateParams]=\"{ total: ausencias_count}\"></div>\n  </ng-template>\n</div>\n\n<p-dialog class=\"w40\" header=\"{{ tituloDialogo }}\" [contentStyle]=\"{'overflow':'visible'}\"\n  [modal]=\"true\" [blockScroll]=\"true\" [(visible)]=\"mostrar_dialogo_nueva_ausencia\">\n  <app-nueva-ausencia\n    *ngIf=\"mostrar_dialogo_nueva_ausencia\"\n    [ausenciaEdicion]=\"ausenciaEdicion\"\n    [motivos]=\"motivos\"\n    [empleados]=\"empleados\"\n    (successCallback)=\"nuevaAusenciaCreada()\"\n    (cancelCallback)=\"cerrarDialogoNuevaAusencia()\"></app-nueva-ausencia>\n</p-dialog>\n<p-confirmDialog header=\"{{ 'app.confirmacion' | translate }}\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n",
                    providers: [ConfirmationService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ListaAusenciasComponent.ctorParameters = function () { return [
        { type: AusenciaService },
        { type: EmpleadoService },
        { type: MotivoAusenciaService },
        { type: AuthenticationService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: MessageService }
    ]; };
    ListaAusenciasComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaAusenciasComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/ausencia/nueva-ausencia/nueva-ausencia.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NuevaAusenciaComponent = /** @class */ (function () {
    function NuevaAusenciaComponent(formBuilder, blockUiService, formService, ausenciaService, empleadoService, translateService, authenticationService, primeLocaleService, messageService) {
        this.formBuilder = formBuilder;
        this.blockUiService = blockUiService;
        this.formService = formService;
        this.ausenciaService = ausenciaService;
        this.empleadoService = empleadoService;
        this.translateService = translateService;
        this.authenticationService = authenticationService;
        this.primeLocaleService = primeLocaleService;
        this.messageService = messageService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.empleado_select_items = [];
        this.empleadosFilter = [];
    }
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.auth_empresa = false;
        this.edicion = false;
        this.modoSeleccion = 'multiple';
        this.modoSeleccionCalendarDiasEnteros = 'multiple';
        if (this.ausenciaEdicion != null) {
            this.auth_empresa = true;
            this.edicion = true;
            this.modoSeleccion = 'single';
            this.modoSeleccionCalendarDiasEnteros = 'single';
        }
        this.esMotivoVacaciones = false;
        this.esMotivoDiasEnteros = false;
        this.fechaDeshabilitado = true;
        this.ausencia_form = this.formBuilder.group({
            id: new FormControl(null),
            comentario: new FormControl(null, [
                Validators.maxLength(1024)
            ]),
            motivo: new FormControl(null, [Validators.required]),
            empleado: new FormControl({ value: '', disabled: this.edicion }),
            calendarDiasEnteros: new FormControl(null),
            fecha_inicio: new FormControl(null, [Validators.required]),
            fecha_fin: new FormControl(null, [Validators.required]),
            fechasVacaciones: new FormControl(null),
            checkMedioDia: new FormControl(null),
            checkDiasEnteros: new FormControl(null)
        });
        this.cargarMotivos();
        /** @type {?} */
        var ID_AUSENCIA_VACACIONES = 3;
        if (this.ausenciaEdicion != null) {
            /** @type {?} */
            var motivoId = this.ausenciaEdicion.motivo.id;
            /** @type {?} */
            var fechaIni = new Date(this.ausenciaEdicion.fechaInicio);
            /** @type {?} */
            var fechaFin = new Date(this.ausenciaEdicion.fechaFin);
            /** @type {?} */
            var valorCheckDiasEnteros = this.ausenciaEdicion.diasEnteros;
            this.auth_empresa = true;
            this.fechaDeshabilitado = false;
            this.ausencia_form.controls['fecha_inicio'].setValue(fechaIni);
            this.ausencia_form.controls['fecha_fin'].setValue(fechaFin);
            this.ausencia_form.controls['motivo'].setValue(this.ausenciaEdicion.motivo);
            this.ausencia_form.controls['comentario'].setValue(this.ausenciaEdicion.comentario);
            if (motivoId == ID_AUSENCIA_VACACIONES) {
                this.esMotivoVacaciones = true;
                this.ausencia_form.controls['fechasVacaciones'].setValue(fechaIni);
                if (this.ausenciaEdicion.medioDia) {
                    this.ausencia_form.controls['checkMedioDia'].setValue(true);
                }
                else {
                    this.ausencia_form.controls['checkMedioDia'].setValue(false);
                }
            }
            else {
                /** @type {?} */
                var checkDiasEnteros = this.ausencia_form.controls['checkDiasEnteros'];
                checkDiasEnteros.setValue(valorCheckDiasEnteros);
                this.muestraCheckBoxDiasEnteros = true;
                /*Al recibir de bd el valor de dias_enteros si es true -> mostrar el calendario
                y el valor que se guardó en bd*/
                if (checkDiasEnteros.value) {
                    this.esMotivoDiasEnteros = true;
                    this.muestraCalendarioDiasEnteros = true;
                    this.ausencia_form.controls['calendarDiasEnteros'].setValue(fechaIni);
                }
                else {
                    this.esMotivoDiasEnteros = false;
                    this.muestraCalendarioDiasEnteros = false;
                }
            }
            this.comprobarPeriodoDiario(this.ausenciaEdicion.empleado.idPeriodo);
            this.limitarFecha(fechaIni);
        }
        else {
            this.muestraCheckBoxDiasEnteros = false;
            this.ausencia_form.controls['checkDiasEnteros'].setValue(false);
            if (this.authenticationService.authentication.tipo == this.authenticationService.authUsuario) {
                this.auth_empresa = true;
                this.edicion = false;
                this.cargarEmpleados();
                this.anyadirRequiredEnCampoEmpleado();
            }
            else {
                /** @type {?} */
                var filters = (/** @type {?} */ ({}));
                this.empleadosFilter.push(this.authenticationService.authentication.user.id);
                filters['empleado:in'] = { value: this.empleadosFilter.join(',') };
                this.empleadoService.getEmpleados(filters, null).subscribe((/**
                 * @param {?} listaEmpleados
                 * @return {?}
                 */
                function (listaEmpleados) {
                    _this.empleadoAus = listaEmpleados[0];
                }));
            }
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.anyadirRequiredEnCampoEmpleado = /**
     * @return {?}
     */
    function () {
        this.ausencia_form.controls['empleado'].setValidators([Validators.required]);
        this.ausencia_form.controls['empleado'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onClickCheckMedioDia = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var valorCheckMedioDia = this.ausencia_form.controls['checkMedioDia'].value;
        if (!this.edicion) {
            this.ausencia_form.controls['fechasVacaciones'].setValue(null);
            if (valorCheckMedioDia) {
                this.modoSeleccion = 'single';
            }
            else {
                this.modoSeleccion = 'multiple';
            }
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onClickCheckDiasEnteros = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var valorCheckDiasEnteros = this.ausencia_form.controls['checkDiasEnteros'].value;
        if (valorCheckDiasEnteros) {
            this.muestraCalendarioDiasEnteros = true;
            this.esMotivoDiasEnteros = true;
            if (!this.edicion) {
                this.ausencia_form.controls['calendarDiasEnteros'].setValue(null);
            }
        }
        else {
            this.muestraCalendarioDiasEnteros = false;
            this.esMotivoDiasEnteros = false;
        }
    };
    /**
     * @param {?} fechaInicio
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.limitarFecha = /**
     * @param {?} fechaInicio
     * @return {?}
     */
    function (fechaInicio) {
        this.fechaMinima = new Date(fechaInicio.getTime());
        this.fechaMaxima = new Date(this.fechaMinima.getTime());
        this.fechaMaxima.setHours(23, 59);
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onSelectDiaFechaIni = /**
     * @return {?}
     */
    function () {
        this.fechaDeshabilitado = false;
        /** @type {?} */
        var fechaInicio = this.ausencia_form.controls['fecha_inicio'].value;
        this.limitarFecha(fechaInicio);
        this.ausencia_form.controls['fecha_fin'].setValue(fechaInicio);
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onChangeEmpleados = /**
     * @return {?}
     */
    function () {
        this.comprobarPeriodoDiario(this.ausencia_form.controls['empleado'].value.idPeriodo);
        this.ausencia_form.controls['fechasVacaciones'].setValue(null);
    };
    /**
     * @param {?} idPeriodoEmpleado
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.comprobarPeriodoDiario = /**
     * @param {?} idPeriodoEmpleado
     * @return {?}
     */
    function (idPeriodoEmpleado) {
        /** @type {?} */
        var ID_PERIODO_DIARIO = 1;
        if (idPeriodoEmpleado == ID_PERIODO_DIARIO) {
            this.esPeriodoDiario = true;
        }
        else {
            this.esPeriodoDiario = false;
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onChangeMotivosAusencia = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var dropDownMotivos = this.ausencia_form.controls['motivo'];
        if (dropDownMotivos.value.nombre == 'Vacaciones') {
            this.esMotivoVacaciones = true;
            this.esMotivoDiasEnteros = false;
            this.muestraCheckBoxDiasEnteros = false;
            this.ausencia_form.controls['checkDiasEnteros'].setValue(false);
            this.muestraCalendarioDiasEnteros = false;
            if (!this.edicion) {
                this.ausencia_form.controls['checkMedioDia'].setValue(false);
                this.ausencia_form.controls['fechasVacaciones'].setValue(null);
                this.modoSeleccion = 'multiple';
            }
        }
        else {
            this.esMotivoVacaciones = false;
            this.esMotivoDiasEnteros = false;
            this.muestraCheckBoxDiasEnteros = true;
            this.ausencia_form.controls['checkDiasEnteros'].setValue(false);
            this.muestraCalendarioDiasEnteros = false;
            if (!this.edicion) {
                this.ausencia_form.controls['checkMedioDia'].setValue(false);
                this.ausencia_form.controls['checkDiasEnteros'].setValue(false);
                this.ausencia_form.controls['calendarDiasEnteros'].setValue(null);
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.cargarEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var e_1, _a;
        this.empleado_select_items = [];
        this.empleado_select_items.push({ label: "", value: null });
        try {
            for (var _b = __values(this.empleados), _c = _b.next(); !_c.done; _c = _b.next()) {
                var empleado = _c.value;
                this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @private
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.cargarMotivos = /**
     * @private
     * @return {?}
     */
    function () {
        var e_2, _a;
        this.motivo_select_items = [];
        this.motivo_select_items.push({ label: "", value: null });
        try {
            for (var _b = __values(this.motivos), _c = _b.next(); !_c.done; _c = _b.next()) {
                var motivo = _c.value;
                this.motivo_select_items.push({ label: motivo.nombre, value: motivo });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.crearAusencias = /**
     * @return {?}
     */
    function () {
        if (!this.esMotivoVacaciones) {
            this.crearAusencia();
        }
        else {
            this.crearAusenciaVacaciones();
        }
    };
    /**
     * @param {?} valorCheckDiasEnteros
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.creaAusenciaConDiasEnteros = /**
     * @param {?} valorCheckDiasEnteros
     * @return {?}
     */
    function (valorCheckDiasEnteros) {
        var _this = this;
        this.quitarValidacionesFechas();
        this.agregarValidacionesCalendarDiasEnteros();
        /** @type {?} */
        var fechasDiasEnteros = this.ausencia_form.controls['calendarDiasEnteros'].value;
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.formService.onSubmitFormValidation(_this.ausencia_form, 'app.ausencia.', (/**
             * @return {?}
             */
            function () {
                var e_3, _a;
                if (_this.ausenciaEdicion != null) {
                    /** @type {?} */
                    var ausencia = (/** @type {?} */ ({
                        fechaInicio: _this.ausencia_form.controls['calendarDiasEnteros'].value,
                        fechaFin: _this.ausencia_form.controls['calendarDiasEnteros'].value,
                        motivo: _this.ausencia_form.controls['motivo'].value,
                        comentario: _this.ausencia_form.controls['comentario'].value,
                        id: _this.ausenciaEdicion.id,
                        empleado: _this.ausenciaEdicion.empleado,
                        horas: _this.calcularHorasVacaciones(_this.ausenciaEdicion.empleado),
                        diasEnteros: valorCheckDiasEnteros
                    }));
                    _this.ausenciaService.actualizarAusencia(ausencia).toPromise().then((/**
                     * @return {?}
                     */
                    function () {
                        _this.successCallback.emit(null);
                        resolve();
                    })).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject();
                    }));
                }
                else {
                    try {
                        for (var fechasDiasEnteros_1 = __values(fechasDiasEnteros), fechasDiasEnteros_1_1 = fechasDiasEnteros_1.next(); !fechasDiasEnteros_1_1.done; fechasDiasEnteros_1_1 = fechasDiasEnteros_1.next()) {
                            var fecha = fechasDiasEnteros_1_1.value;
                            /** @type {?} */
                            var ausencia = (/** @type {?} */ ({
                                fechaInicio: fecha,
                                fechaFin: fecha,
                                motivo: _this.ausencia_form.controls['motivo'].value,
                                comentario: _this.ausencia_form.controls['comentario'].value,
                                empleado: _this.empleadoAus,
                                horas: _this.calcularHorasVacaciones(_this.empleadoAus),
                                diasEnteros: valorCheckDiasEnteros
                            }));
                            _this.ausenciaService.anyadirAusencia(ausencia).toPromise().then((/**
                             * @return {?}
                             */
                            function () {
                                _this.successCallback.emit(null);
                                resolve();
                            })).catch((/**
                             * @param {?} error
                             * @return {?}
                             */
                            function (error) {
                                reject();
                            }));
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (fechasDiasEnteros_1_1 && !fechasDiasEnteros_1_1.done && (_a = fechasDiasEnteros_1.return)) _a.call(fechasDiasEnteros_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
    };
    /**
     * @param {?} valorCheckDiasEnteros
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.crearAusenciaSinDiasEnteros = /**
     * @param {?} valorCheckDiasEnteros
     * @return {?}
     */
    function (valorCheckDiasEnteros) {
        var _this = this;
        /** @type {?} */
        var fechaIni = this.ausencia_form.controls['fecha_inicio'].value;
        /** @type {?} */
        var fechaFin = this.ausencia_form.controls['fecha_fin'].value;
        if (fechaFin > fechaIni) {
            this.blockUiService.ejecutarConBloqueo(new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) {
                _this.formService.onSubmitFormValidation(_this.ausencia_form, 'app.ausencia.', (/**
                 * @return {?}
                 */
                function () {
                    if (_this.ausenciaEdicion != null) {
                        /** @type {?} */
                        var ausencia = (/** @type {?} */ ({
                            fechaInicio: _this.ausencia_form.controls['fecha_inicio'].value,
                            fechaFin: _this.ausencia_form.controls['fecha_fin'].value,
                            motivo: _this.ausencia_form.controls['motivo'].value,
                            comentario: _this.ausencia_form.controls['comentario'].value,
                            id: _this.ausenciaEdicion.id,
                            empleado: _this.ausenciaEdicion.empleado,
                            medioDia: null,
                            diasEnteros: valorCheckDiasEnteros
                        }));
                        _this.ausenciaService.actualizarAusencia(ausencia).toPromise().then((/**
                         * @return {?}
                         */
                        function () {
                            _this.successCallback.emit(null);
                            resolve();
                        })).catch((/**
                         * @param {?} error
                         * @return {?}
                         */
                        function (error) {
                            reject();
                        }));
                    }
                    else {
                        /** @type {?} */
                        var ausencia = (/** @type {?} */ ({
                            fechaInicio: _this.ausencia_form.controls['fecha_inicio'].value,
                            fechaFin: _this.ausencia_form.controls['fecha_fin'].value,
                            motivo: _this.ausencia_form.controls['motivo'].value,
                            comentario: _this.ausencia_form.controls['comentario'].value,
                            empleado: _this.empleadoAus,
                            medioDia: null,
                            diasEnteros: valorCheckDiasEnteros
                        }));
                        _this.ausenciaService.anyadirAusencia(ausencia).toPromise().then((/**
                         * @return {?}
                         */
                        function () {
                            _this.successCallback.emit(null);
                            resolve();
                        })).catch((/**
                         * @param {?} error
                         * @return {?}
                         */
                        function (error) {
                            reject();
                        }));
                    }
                }), (/**
                 * @return {?}
                 */
                function () {
                    reject();
                }));
            })));
        }
        else {
            //Error. la fecha de entrada es mayor q la de salida
            this.translateService.get('app.registro.errorFecha').subscribe((/**
             * @param {?} message
             * @return {?}
             */
            function (message) {
                _this.messageService.add({
                    severity: 'error',
                    summary: message
                });
            }));
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.crearAusencia = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var valorCheckDiasEnteros = this.ausencia_form.controls['checkDiasEnteros'].value;
        if (this.auth_empresa) {
            this.empleadoAus = this.ausencia_form.controls['empleado'].value;
        }
        if (valorCheckDiasEnteros) {
            this.creaAusenciaConDiasEnteros(valorCheckDiasEnteros);
        }
        else {
            this.crearAusenciaSinDiasEnteros(valorCheckDiasEnteros);
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.quitarValidacionesFechas = /**
     * @return {?}
     */
    function () {
        this.ausencia_form.controls['fecha_inicio'].clearValidators();
        this.ausencia_form.controls['fecha_fin'].clearValidators();
        this.ausencia_form.controls['fecha_inicio'].updateValueAndValidity();
        this.ausencia_form.controls['fecha_fin'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.agregarValidacionesFechaVacaciones = /**
     * @return {?}
     */
    function () {
        this.ausencia_form.controls['fechasVacaciones'].setValidators([Validators.required]);
        this.ausencia_form.controls['fechasVacaciones'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.agregarValidacionesCalendarDiasEnteros = /**
     * @return {?}
     */
    function () {
        this.ausencia_form.controls['calendarDiasEnteros'].setValidators([Validators.required]);
        this.ausencia_form.controls['calendarDiasEnteros'].updateValueAndValidity();
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.crearAusenciaVacaciones = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.quitarValidacionesFechas();
        this.agregarValidacionesFechaVacaciones();
        /** @type {?} */
        var fechasVacaciones = this.ausencia_form.controls['fechasVacaciones'].value;
        if (this.auth_empresa) {
            this.empleadoAus = this.ausencia_form.controls['empleado'].value;
        }
        this.blockUiService.ejecutarConBloqueo(new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            _this.formService.onSubmitFormValidation(_this.ausencia_form, 'app.ausencia.', (/**
             * @return {?}
             */
            function () {
                var e_4, _a;
                if (_this.ausenciaEdicion != null) {
                    /** @type {?} */
                    var horasActualizadas = _this.ausencia_form.controls['checkMedioDia'].value ?
                        _this.calcularHorasVacacionesMedioDia(_this.ausenciaEdicion.empleado) : _this.calcularHorasVacaciones(_this.ausenciaEdicion.empleado);
                    /** @type {?} */
                    var ausencia = (/** @type {?} */ ({
                        fechaInicio: _this.ausencia_form.controls['fechasVacaciones'].value,
                        fechaFin: _this.ausencia_form.controls['fechasVacaciones'].value,
                        motivo: _this.ausencia_form.controls['motivo'].value,
                        comentario: _this.ausencia_form.controls['comentario'].value,
                        id: _this.ausenciaEdicion.id,
                        empleado: _this.ausenciaEdicion.empleado,
                        medioDia: _this.ausencia_form.controls['checkMedioDia'].value,
                        horas: horasActualizadas,
                        diasEnteros: false
                    }));
                    _this.ausenciaService.actualizarAusencia(ausencia).toPromise().then((/**
                     * @return {?}
                     */
                    function () {
                        _this.successCallback.emit(null);
                        resolve();
                    })).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject();
                    }));
                }
                else {
                    if (_this.modoSeleccion == "multiple") {
                        try {
                            for (var fechasVacaciones_1 = __values(fechasVacaciones), fechasVacaciones_1_1 = fechasVacaciones_1.next(); !fechasVacaciones_1_1.done; fechasVacaciones_1_1 = fechasVacaciones_1.next()) {
                                var fecha = fechasVacaciones_1_1.value;
                                /** @type {?} */
                                var ausencia = (/** @type {?} */ ({
                                    fechaInicio: fecha,
                                    fechaFin: fecha,
                                    motivo: _this.ausencia_form.controls['motivo'].value,
                                    comentario: _this.ausencia_form.controls['comentario'].value,
                                    empleado: _this.empleadoAus,
                                    medioDia: _this.ausencia_form.controls['checkMedioDia'].value,
                                    horas: _this.calcularHorasVacaciones(_this.empleadoAus),
                                    diasEnteros: false
                                }));
                                _this.ausenciaService.anyadirAusencia(ausencia).toPromise().then((/**
                                 * @return {?}
                                 */
                                function () {
                                    _this.successCallback.emit(null);
                                    resolve();
                                })).catch((/**
                                 * @param {?} error
                                 * @return {?}
                                 */
                                function (error) {
                                    reject();
                                }));
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (fechasVacaciones_1_1 && !fechasVacaciones_1_1.done && (_a = fechasVacaciones_1.return)) _a.call(fechasVacaciones_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                    else {
                        _this.crearVacacionesMedioDia(resolve, reject);
                    }
                }
            }), (/**
             * @return {?}
             */
            function () {
                reject();
            }));
        })));
    };
    /**
     * @param {?} resolve
     * @param {?} reject
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.crearVacacionesMedioDia = /**
     * @param {?} resolve
     * @param {?} reject
     * @return {?}
     */
    function (resolve, reject) {
        var _this = this;
        /** @type {?} */
        var ausencia = (/** @type {?} */ ({
            fechaInicio: this.ausencia_form.controls['fechasVacaciones'].value,
            fechaFin: this.ausencia_form.controls['fechasVacaciones'].value,
            motivo: this.ausencia_form.controls['motivo'].value,
            comentario: this.ausencia_form.controls['comentario'].value,
            empleado: this.empleadoAus,
            medioDia: this.ausencia_form.controls['checkMedioDia'].value,
            horas: this.calcularHorasVacacionesMedioDia(this.empleadoAus),
            diasEnteros: false
        }));
        this.ausenciaService.anyadirAusencia(ausencia).toPromise().then((/**
         * @return {?}
         */
        function () {
            _this.successCallback.emit(null);
            resolve();
        })).catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            reject();
        }));
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.comprobarDiasPorSemana = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        return empleado.diasPorSemana == 0 || empleado.diasPorSemana == null;
    };
    //const DIAS_POR_DEFECTO = 5;
    //const DIAS_POR_DEFECTO = 5;
    /**
     * @param {?} empleado
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.calcularHorasVacaciones = 
    //const DIAS_POR_DEFECTO = 5;
    /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        /** @type {?} */
        var DIAS_POR_DEFECTO = 5;
        if (this.sonVacacionesSemanales(empleado)) {
            if (this.comprobarDiasPorSemana(empleado)) {
                return empleado.dedicacionHoras / DIAS_POR_DEFECTO;
            }
            else {
                return empleado.dedicacionHoras / empleado.diasPorSemana;
            }
        }
        else {
            return empleado.dedicacionHoras;
        }
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.calcularHorasVacacionesMedioDia = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        /** @type {?} */
        var MITAD = 2;
        /** @type {?} */
        var DIAS_POR_DEFECTO = 5;
        if (this.sonVacacionesSemanales(empleado)) {
            if (this.comprobarDiasPorSemana(empleado)) {
                return (empleado.dedicacionHoras / DIAS_POR_DEFECTO) / MITAD;
            }
            else {
                return (empleado.dedicacionHoras / empleado.diasPorSemana) / MITAD;
            }
        }
        else {
            return empleado.dedicacionHoras / MITAD;
        }
    };
    /**
     * @param {?} empleado
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.sonVacacionesSemanales = /**
     * @param {?} empleado
     * @return {?}
     */
    function (empleado) {
        console.log(empleado);
        if (empleado.idPeriodo == 2) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.onFileUpload = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var e_5, _a;
        this.adjunto = new FileReader();
        try {
            for (var _b = __values(event.files), _c = _b.next(); !_c.done; _c = _b.next()) {
                var file = _c.value;
                this.adjunto.readAsDataURL(file);
                this.adjunto;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    /**
     * @return {?}
     */
    NuevaAusenciaComponent.prototype.cancelar = /**
     * @return {?}
     */
    function () {
        this.cancelCallback.emit(null);
    };
    NuevaAusenciaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-nueva-ausencia',
                    template: "<form [formGroup]=\"ausencia_form\" (ngSubmit)=\"crearAusencias()\">\n  <div class=\"ui-g\">\n    <div class=\"ui-g-12\" *ngIf=\"auth_empresa && !edicion\">\n\t\t<label>{{ 'app.ausencia.empleado' | translate }} *</label>\n      <p-dropdown [options]=\"empleado_select_items\" formControlName=\"empleado\" appendTo=\"body\" (onChange)=\"onChangeEmpleados()\"></p-dropdown>\n    </div>\n    <div class=\"ui-g-12\" >\n      <label>{{ 'app.ausencia.motivo' | translate }} *</label>\n      <p-dropdown [options]=\"motivo_select_items\" formControlName=\"motivo\" (onChange)=\"onChangeMotivosAusencia()\"></p-dropdown>\n    </div>\n    <div class=\"ui-g-7\" *ngIf=\"muestraCheckBoxDiasEnteros\">\n    \t<p-checkbox binary='true' formControlName='checkDiasEnteros' (onChange)='onClickCheckDiasEnteros()' inputId='diasEnteros'></p-checkbox>\n    \t<label class=\"inline\" for='diasEnteros'>{{ 'app.ausencia.diasenteros' | translate }}</label>\n    </div>\n\t<div class=\"ui-g-7\" *ngIf=\"muestraCalendarioDiasEnteros\">\n\t\t<label>{{ 'app.ausencia.calendarDiasEnteros' | translate }} *</label>\n\t\t<p-calendar [showOtherMonths]=\"false\" [locale]=\"primeLocaleService.user_locale\" formControlName=\"calendarDiasEnteros\" [selectionMode]=\"modoSeleccionCalendarDiasEnteros\" \n\t\t[inline]=\"true\" [showTime]=\"false\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n\t</div>\n    <div class=\"ui-g-6\" *ngIf=\"(!esMotivoVacaciones && !esMotivoDiasEnteros)\">\n      <label>{{ 'app.ausencia.fecha_inicio' | translate }} *</label>\n      <p-calendar readonlyInput=\"true\" formControlName=\"fecha_inicio\" [showTime]=\"true\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n        [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\" selection=\"multiple\" (onSelect)=\"onSelectDiaFechaIni()\"></p-calendar>\n    </div>\n    <div class=\"ui-g-6\" *ngIf=\"(!esMotivoVacaciones && !esMotivoDiasEnteros)\">\n      <label>{{ 'app.ausencia.fecha_fin' | translate }} *</label>\n      <p-calendar readonlyInput=\"true\" formControlName=\"fecha_fin\" [showTime]=\"true\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n        [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\" selection=\"multiple\" [disabled]=\"fechaDeshabilitado\" [minDate]=\"fechaMinima\" [maxDate]=\"fechaMaxima\"></p-calendar>\n    </div>\n    <div class=\"ui-g-7\" *ngIf=\"esMotivoVacaciones\">\n    \t<p-checkbox binary='true' formControlName='checkMedioDia' (onChange)='onClickCheckMedioDia()' inputId='medioDia'></p-checkbox>\n    \t<label class=\"inline\" for='medioDia'>{{ 'app.ausencia.mediodia' | translate }}</label>\n    </div>\n    <div class=\"ui-g-6\" *ngIf=\"esMotivoVacaciones && esPeriodoDiario\">\n      <label>{{ 'app.ausencia.calendarDiasEnteros' | translate }} *</label>\n      <p-calendar [showOtherMonths]=\"false\" [locale]=\"primeLocaleService.user_locale\" formControlName=\"fechasVacaciones\" [selectionMode]=\"modoSeleccion\" [inline]=\"true\" [showTime]=\"false\" [disabledDays]=\"[0,6]\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n    </div>\n    <div class=\"ui-g-6\" *ngIf=\"esMotivoVacaciones && !esPeriodoDiario\">\n      <label>{{ 'app.ausencia.calendarDiasEnteros' | translate }} *</label>\n      <p-calendar [showOtherMonths]=\"false\" [locale]=\"primeLocaleService.user_locale\" formControlName=\"fechasVacaciones\" [selectionMode]=\"modoSeleccion\" [inline]=\"true\" [showTime]=\"false\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n    </div>\n    \n    <div class=\"ui-g-12\" >\n      <label>{{ 'app.ausencia.comentario' | translate }}</label>\n      <textarea [rows]=\"5\" formControlName=\"comentario\" pInputTextarea ></textarea>\n    </div> \n\n   \n  </div>\n\n  <p-footer class=\"botones\">\n      <button type=\"submit\" pButton icon=\"pi pi-check\" label=\"{{ 'app.guardar' | translate }}\"></button>\n      <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"cancelar()\" label=\"{{ 'app.cancelar' | translate }}\"></button>\n  </p-footer>\n</form>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NuevaAusenciaComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: BlockUiService },
        { type: FormService },
        { type: AusenciaService },
        { type: EmpleadoService },
        { type: TranslateService },
        { type: AuthenticationService },
        { type: PrimeLocaleService },
        { type: MessageService }
    ]; };
    NuevaAusenciaComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }],
        ausenciaEdicion: [{ type: Input }],
        motivos: [{ type: Input }],
        empleados: [{ type: Input }]
    };
    return NuevaAusenciaComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/estadisticas.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EstadisticasService = /** @class */ (function () {
    function EstadisticasService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/estadisticas';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    EstadisticasService.prototype.getEstadisticas = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + '/fichajes' + url_params)
            .pipe(map((/**
         * @param {?} estadisticasRest
         * @return {?}
         */
        function (estadisticasRest) {
            /** @type {?} */
            var estadisticas = estadisticasRest.map((/**
             * @param {?} estadisticasRest
             * @return {?}
             */
            function (estadisticasRest) {
                return (/** @type {?} */ (estadisticasRest));
            }));
            return estadisticas;
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    EstadisticasService.prototype.getEstadisticaEmpleado = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + '/empleados' + url_params)
            .pipe(map((/**
         * @param {?} estadisticasRest
         * @return {?}
         */
        function (estadisticasRest) {
            /** @type {?} */
            var estadisticas = estadisticasRest.map((/**
             * @param {?} estadisticasRest
             * @return {?}
             */
            function (estadisticasRest) {
                return (/** @type {?} */ (estadisticasRest));
            }));
            return estadisticas;
        })));
    };
    EstadisticasService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EstadisticasService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ EstadisticasService.ngInjectableDef = defineInjectable({ factory: function EstadisticasService_Factory() { return new EstadisticasService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: EstadisticasService, providedIn: "root" });
    return EstadisticasService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/estadisticas/lista-estadisticas.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListaEstadisticasComponent = /** @class */ (function () {
    function ListaEstadisticasComponent(estadisticasService, empleadoService, authenticationService, confirmationService, translateService, blockUiService, eventEmiterService, messageService, primeLocaleService) {
        this.estadisticasService = estadisticasService;
        this.empleadoService = empleadoService;
        this.authenticationService = authenticationService;
        this.confirmationService = confirmationService;
        this.translateService = translateService;
        this.blockUiService = blockUiService;
        this.eventEmiterService = eventEmiterService;
        this.messageService = messageService;
        this.primeLocaleService = primeLocaleService;
        this.successCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        this.rows_per_page = 10;
        this.first_page = 0;
        this.empleado_select_items = [];
    }
    /**
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.eventEmiterService.empresaActualOnChange.subscribe((/**
         * @return {?}
         */
        function () {
            _this.cargaOnInit();
            _this.limpiarBusqueda();
        }));
        this.cargaOnInit();
    };
    /**
     * @private
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.cargaOnInit = /**
     * @private
     * @return {?}
     */
    function () {
        this.lazyLoadEvent = null;
        this.estadisticas_loading = true;
        this.estadisticas = [];
        this.estadisticas_count = 0;
        this.estadisticaEmpleado = [];
        this.auth_empresa = false;
        this.filtro_empleados = null;
        this.tablaEmpleados_loading = false;
        if (this.authenticationService.authentication.tipo == this.authenticationService.authUsuario) {
            this.auth_empresa = true;
            this.cargarEmpleados();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.loadEstadisticasLazy = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, filters, fecha_reporte_hasta, empresaId, first, rows, _b, _c, _d, estadistica;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.estadisticas_loading = true;
                        this.lazyLoadEvent = event;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, , 3, 4]);
                        filters = (/** @type {?} */ ({}));
                        if (this.filtro_fecha_reporte_desde != null) {
                            filters['fechaInicial:ge'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
                        }
                        if (this.filtro_fecha_reporte_hasta != null) {
                            fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
                            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
                            filters['fechaFinal:le'] = { value: String(fecha_reporte_hasta.getTime()) };
                        }
                        if (this.auth_empresa) {
                            empresaId = new String(this.authenticationService.authentication.empresa.id);
                            filters['empresa'] = { value: String(empresaId) };
                        }
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _b = this;
                        return [4 /*yield*/, this.estadisticasService.getEstadisticas(filters, null, first, rows)
                                .toPromise()];
                    case 2:
                        _b.estadisticas = _e.sent();
                        try {
                            for (_c = __values(this.estadisticas), _d = _c.next(); !_d.done; _d = _c.next()) {
                                estadistica = _d.value;
                                estadistica.nEmpHoras = (estadistica.nEmpHoras / 1000) / 3600;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.cargarTablaEmpleados(event);
                        return [3 /*break*/, 4];
                    case 3:
                        this.estadisticas_loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.loadEstadisticas = /**
     * @return {?}
     */
    function () {
        this.loadEstadisticasLazy(this.lazyLoadEvent);
    };
    /**
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.limpiarBusqueda = /**
     * @return {?}
     */
    function () {
        this.filtro_fecha_reporte_desde = null;
        this.filtro_fecha_reporte_hasta = null;
        this.filtro_empleados = null;
        this.tablaEmpleados_loading = false;
        this.loadEstadisticas();
    };
    /**
     * @private
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.cargarEmpleados = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.empleado_select_items = [];
        /** @type {?} */
        var empresaId = new String(this.authenticationService.authentication.empresa.id);
        /** @type {?} */
        var filters = {
            'empresa': { value: empresaId.toString() }
        };
        this.empleadoService.getEmpleados(filters, null).subscribe((/**
         * @param {?} listaEmpleados
         * @return {?}
         */
        function (listaEmpleados) {
            var e_2, _a;
            _this.empleados = listaEmpleados;
            try {
                for (var listaEmpleados_1 = __values(listaEmpleados), listaEmpleados_1_1 = listaEmpleados_1.next(); !listaEmpleados_1_1.done; listaEmpleados_1_1 = listaEmpleados_1.next()) {
                    var empleado = listaEmpleados_1_1.value;
                    _this.empleado_select_items.push({ label: empleado.nombre + " " + empleado.apellidos, value: empleado.id });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (listaEmpleados_1_1 && !listaEmpleados_1_1.done && (_a = listaEmpleados_1.return)) _a.call(listaEmpleados_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListaEstadisticasComponent.prototype.cargarTablaEmpleados = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3, _a, filters, fecha_reporte_hasta, empresaId, _b, first, rows, _c, _d, _e, estadistica;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.lazyLoadEvent = event;
                        if (this.filtro_empleados != null || this.filtro_fecha_reporte_desde != null || this.filtro_fecha_reporte_hasta != null) {
                            this.tablaEmpleados_loading = true;
                        }
                        else {
                            this.tablaEmpleados_loading = false;
                        }
                        if (!this.tablaEmpleados_loading) return [3 /*break*/, 7];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, , 6, 7]);
                        filters = (/** @type {?} */ ({}));
                        if (event != null) {
                            filters['registroInicial'] = { value: String(event.first) };
                            filters['registros'] = { value: String(event.rows) };
                        }
                        else {
                            filters['registroInicial'] = { value: String(this.first_page) };
                            filters['registros'] = { value: String(this.rows_per_page) };
                        }
                        if (this.filtro_fecha_reporte_desde != null) {
                            filters['fechaInicial:ge'] = { value: String(this.filtro_fecha_reporte_desde.getTime()) };
                        }
                        if (this.filtro_fecha_reporte_hasta != null) {
                            fecha_reporte_hasta = new Date(this.filtro_fecha_reporte_hasta.getTime());
                            fecha_reporte_hasta.setDate(fecha_reporte_hasta.getDate() + 1);
                            filters['fechaFinal:le'] = { value: String(fecha_reporte_hasta.getTime()) };
                        }
                        if (this.auth_empresa) {
                            empresaId = new String(this.authenticationService.authentication.empresa.id);
                            filters['empresa'] = { value: String(empresaId) };
                            if (this.filtro_empleados != null) {
                                filters['empleado:in'] = { value: this.filtro_empleados.join(',') };
                            }
                        }
                        _b = this;
                        return [4 /*yield*/, this.empleadoService.getEmpleadosCount(filters).toPromise()];
                    case 2:
                        _b.estadisticas_count = _f.sent();
                        if (!(this.estadisticas_count == 0)) return [3 /*break*/, 3];
                        this.estadisticaEmpleado = [];
                        return [3 /*break*/, 5];
                    case 3:
                        first = 0;
                        rows = this.rows_per_page;
                        if (event != null) {
                            first = event.first;
                            rows = event.rows;
                        }
                        _c = this;
                        return [4 /*yield*/, this.estadisticasService.getEstadisticaEmpleado(filters, null, first, rows)
                                .toPromise()];
                    case 4:
                        _c.estadisticaEmpleado = _f.sent();
                        try {
                            for (_d = __values(this.estadisticaEmpleado), _e = _d.next(); !_e.done; _e = _d.next()) {
                                estadistica = _e.value;
                                estadistica.nHoras = (estadistica.nHoras / 1000) / 3600;
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        _f.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6: return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ListaEstadisticasComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-lista-estadisticas',
                    template: "<div id=\"contenido\">\n  <p-panel class=\"filtro_busqueda\" header=\"{{ 'app.filtro' | translate }}\">\n    <div class=\"ui-g\">\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n        <label [translate]=\"'app.filtro.desde'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n        <p-calendar [(ngModel)]=\"filtro_fecha_reporte_desde\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n          [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-2\">\n        <label [translate]=\"'app.filtro.hasta'\" [translateParams]=\"{ campo: ('app.incidencia.fecha_reporte' | translate)}\"></label>\n        <p-calendar [(ngModel)]=\"filtro_fecha_reporte_hasta\" [showIcon]=\"true\" [showOnFocus]=\"false\" appendTo=\"body\"\n          [locale]=\"primeLocaleService.user_locale\" [dateFormat]=\"primeLocaleService.user_locale.dateFormat\"></p-calendar>\n      </div>\n\n      <div class=\"ui-g-4 ui-md-4 ui-lg-4\" *ngIf=\"auth_empresa\" >\n        <label>{{ 'app.filtro.empleado' | translate }}</label>\n        <p-multiSelect [(ngModel)]=\"filtro_empleados\" [options]=\"empleado_select_items\"\n        defaultLabel=\"\" ></p-multiSelect>\n      </div>\n\n      <div class=\"ui-g-12\">\n        <p-footer class=\"botones\">\n          <button type=\"button\" pButton icon=\"pi pi-filter\" (click)=\"loadEstadisticas()\" label=\"{{ 'app.filtrar' | translate }}\"></button>\n          <button type=\"button\" pButton icon=\"pi pi-times-circle\" (click)=\"limpiarBusqueda()\" label=\"{{ 'app.limpiar' | translate }}\"></button>\n        </p-footer>\n        </div>\n    </div>\n  </p-panel>\n\n  <p-card class=\"texto_centrado\" *ngIf=\"estadisticas_loading || estadisticas_count == 0\">\n    <i class=\"pi pi-spin pi-spinner\" *ngIf=\"estadisticas_loading\"></i>\n  </p-card>\n\n\n  <p-table [value]=\"estadisticas\"  [lazy]=\"true\"\n(onLazyLoad)=\"loadEstadisticasLazy($event)\" [rows]=\"rows_per_page\"\n >\n    <ng-template pTemplate=\"header\">\n        <tr>\n            <th>{{ 'app.estadisticas.nombreEmpresa' | translate }}</th>\n              <th>{{ 'app.estadisticas.nEmplEmpresa' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosTotal' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosEntrada' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosSalida' | translate }}</th>\n            <th>{{ 'app.estadisticas.nEmpHoras' | translate }}</th>\n              <th>{{'app.estadisticas.incidencias' | translate }}</th>\n                  <th>{{'app.estadisticas.ausencias' | translate }}</th>\n        </tr>\n    </ng-template>\n    <ng-template pTemplate=\"body\" let-estadistica>\n        <tr>\n            <td>{{estadistica.nombreEmpresa}}</td>\n            <td>{{estadistica.nEmplEmpresa}}</td>\n            <td>{{estadistica.nRegistrosTotal}}</td>\n            <td>{{estadistica.nRegistrosEntrada}}</td>\n            <td>{{estadistica.nRegistrosSalida}}</td>\n            <td >{{estadistica.nEmpHoras | number:'1.1-2'}}</td>\n            <td >{{estadistica.nIncidencias}}</td>\n              <td >{{estadistica.nAusencias}}</td>\n\n          </tr>\n    </ng-template>\n  </p-table>\n\n  <p-card class=\"texto_centrado\" *ngIf=\"estadisticaEmpleado\">\n    <i class=\"pi pi-spin\" *ngIf=\"estadisticaEmpleado\"></i>\n  </p-card>\n\n  <p-table [value]=\"estadisticaEmpleado\"  [lazy]=\"true\" (onLazyLoad) =\"cargarTablaEmpleados($event)\" *ngIf=\"tablaEmpleados_loading\"\n  [paginator]=\"true\" [rows]=\"rows_per_page\" [totalRecords]=\"estadisticas_count\" >\n    <ng-template pTemplate=\"header\">\n        <tr>\n            <th>{{ 'app.estadisticas.nombreEmpleado' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosTotal' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosEntrada' | translate }}</th>\n            <th>{{ 'app.estadisticas.nRegistrosSalida' | translate }}</th>\n            <th>{{ 'app.estadisticas.nEmpHoras' | translate }}</th>\n            <th>{{'app.estadisticas.incidencias' | translate }}</th>\n            <th>{{'app.estadisticas.ausencias' | translate }}</th>\n        </tr>\n    </ng-template>\n    <ng-template pTemplate=\"body\" let-empleado>\n        <tr>\n            <td>{{empleado.nombreEmpleado}}</td>\n            <td>{{empleado.nRegistrosTotal}}</td>\n            <td>{{empleado.nRegistrosEntrada}}</td>\n            <td>{{empleado.nRegistrosSalida}}</td>\n            <td >{{empleado.nHoras | number:'1.1-2'}}</td>\n            <td >{{empleado.nIncidencias}}</td>\n            <td >{{empleado.nAusencias}}</td>\n\n          </tr>\n    </ng-template>\n  </p-table>\n\n  <ng-template #registros>\n    <div [translate]=\"'app.total_registros'\" [translateParams]=\"{ total: estadisticas_count}\"></div>\n  </ng-template>\n</div>\n",
                    providers: [ConfirmationService],
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ListaEstadisticasComponent.ctorParameters = function () { return [
        { type: EstadisticasService },
        { type: EmpleadoService },
        { type: AuthenticationService },
        { type: ConfirmationService },
        { type: TranslateService },
        { type: BlockUiService },
        { type: EventEmiterService },
        { type: MessageService },
        { type: PrimeLocaleService }
    ]; };
    ListaEstadisticasComponent.propDecorators = {
        successCallback: [{ type: Output }],
        cancelCallback: [{ type: Output }]
    };
    return ListaEstadisticasComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    CoreModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: CONFIGURATION, useValue: config }
            ]
        };
    };
    CoreModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ListaIncidenciasComponent,
                        GraficoRegistrosComponent,
                        NuevaIncidenciaComponent,
                        ListaRegistrosComponent,
                        NuevoRegistroComponent,
                        ListaEmpresasComponent,
                        NuevaEmpresaComponent,
                        ListaEmpleadosComponent,
                        NuevoEmpleadoComponent,
                        ListaTiposRegistroComponent,
                        NuevoTipoRegistroComponent,
                        ListaAusenciasComponent,
                        ListaEstadisticasComponent,
                        NuevaAusenciaComponent
                    ],
                    imports: [
                        BrowserModule,
                        BrowserAnimationsModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: HttpLoaderFactory,
                                deps: [HttpClient]
                            }
                        }),
                        FormsModule,
                        ReactiveFormsModule,
                        Ng2GoogleChartsModule,
                        PanelModule,
                        TableModule,
                        ButtonModule,
                        CardModule,
                        PaginatorModule,
                        MenubarModule,
                        DialogModule,
                        InputTextModule,
                        InputTextareaModule,
                        CalendarModule,
                        DropdownModule,
                        MultiSelectModule,
                        ConfirmDialogModule,
                        CheckboxModule,
                        FileUploadModule,
                        MatIconModule,
                        LeafletModule.forRoot()
                    ],
                    exports: [
                        ListaIncidenciasComponent,
                        GraficoRegistrosComponent,
                        ListaRegistrosComponent,
                        ListaEmpresasComponent,
                        NuevaEmpresaComponent,
                        ListaEmpleadosComponent,
                        ListaTiposRegistroComponent,
                        ListaEstadisticasComponent,
                        ListaAusenciasComponent
                    ],
                    providers: [
                        MessageService,
                        DatePipe
                    ],
                },] }
    ];
    return CoreModule;
}());
/**
 * @param {?} http
 * @return {?}
 */
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/filters.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/empleado.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/empresa.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/usuario.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var TipoUsuario = {
    AdminGlobal: 1,
    AdminEmpresa: 2,
};
TipoUsuario[TipoUsuario.AdminGlobal] = 'AdminGlobal';
TipoUsuario[TipoUsuario.AdminEmpresa] = 'AdminEmpresa';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/registroInforme.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/informe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/centro.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/periodo.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/ausencia.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/motivoAusencia.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/dispositivo.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/dispositivoEmpresa.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/zkteco.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/zktecoEmpresa.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/timezone.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TimeZoneList = (/** @type {?} */ ([
    // UTC+14:00
    { group: 'UTC+14:00', timezone: 'Pacific/Kiritimati', label: 'Pacific/Kiritimati (+14)' },
    // UTC+13:00
    { group: 'UTC+13:00', timezone: 'Pacific/Apia', label: 'Pacific/Apia (+13)' },
    { group: 'UTC+13:00', timezone: 'Pacific/Enderbury', label: 'Pacific/Enderbury (+13)' },
    { group: 'UTC+13:00', timezone: 'Pacific/Fakaofo', label: 'Pacific/Fakaofo (+13)' },
    { group: 'UTC+13:00', timezone: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu (+13)' },
    // UTC+12:45
    { group: 'UTC+12:45', timezone: 'Pacific/Chatham', label: 'Pacific/Chatham (+12:45)' },
    // UTC+12:00
    { group: 'UTC+12:00', timezone: 'Antarctica/McMurdo', label: 'Antarctica/McMurdo (NZST)' },
    { group: 'UTC+12:00', timezone: 'Asia/Anadyr', label: 'Asia/Anadyr (+12)' },
    { group: 'UTC+12:00', timezone: 'Asia/Kamchatka', label: 'Asia/Kamchatka (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Auckland', label: 'Pacific/Auckland (NZST)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Fiji', label: 'Pacific/Fiji (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Funafuti', label: 'Pacific/Funafuti (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Kwajalein', label: 'Pacific/Kwajalein (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Majuro', label: 'Pacific/Majuro (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Nauru', label: 'Pacific/Nauru (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Tarawa', label: 'Pacific/Tarawa (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Wake', label: 'Pacific/Wake (+12)' },
    { group: 'UTC+12:00', timezone: 'Pacific/Wallis', label: 'Pacific/Wallis (+12)' },
    // UTC+11:00
    { group: 'UTC+11:00', timezone: 'Antarctica/Casey', label: 'Antarctica/Casey (+11)' },
    { group: 'UTC+11:00', timezone: 'Antarctica/Macquarie', label: 'Antarctica/Macquarie (+11)' },
    { group: 'UTC+11:00', timezone: 'Asia/Magadan', label: 'Asia/Magadan (+11)' },
    { group: 'UTC+11:00', timezone: 'Asia/Sakhalin', label: 'Asia/Sakhalin (+11)' },
    { group: 'UTC+11:00', timezone: 'Asia/Srednekolymsk', label: 'Asia/Srednekolymsk (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Bougainville', label: 'Pacific/Bougainville (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Efate', label: 'Pacific/Efate (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Guadalcanal', label: 'Pacific/Guadalcanal (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Kosrae', label: 'Pacific/Kosrae (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Norfolk', label: 'Pacific/Norfolk (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Noumea', label: 'Pacific/Noumea (+11)' },
    { group: 'UTC+11:00', timezone: 'Pacific/Pohnpei', label: 'Pacific/Pohnpei (+11)' },
    // UTC+10:30
    { group: 'UTC+10:30', timezone: 'Australia/Lord_Howe', label: 'Australia/Lord Howe (+10:30)' },
    // UTC+10:00
    { group: 'UTC+10:00', timezone: 'Antarctica/DumontDUrville', label: 'Antarctica/DumontDUrville (+10)' },
    { group: 'UTC+10:00', timezone: 'Asia/Ust-Nera', label: 'Asia/Ust-Nera (+10)' },
    { group: 'UTC+10:00', timezone: 'Asia/Vladivostok', label: 'Asia/Vladivostok (+10)' },
    { group: 'UTC+10:00', timezone: 'Australia/Brisbane', label: 'Australia/Brisbane (AEST)' },
    { group: 'UTC+10:00', timezone: 'Australia/Currie', label: 'Australia/Currie (AEST)' },
    { group: 'UTC+10:00', timezone: 'Australia/Hobart', label: 'Australia/Hobart (AEST)' },
    { group: 'UTC+10:00', timezone: 'Australia/Lindeman', label: 'Australia/Lindeman (AEST)' },
    { group: 'UTC+10:00', timezone: 'Australia/Melbourne', label: 'Australia/Melbourne (AEST)' },
    { group: 'UTC+10:00', timezone: 'Australia/Sydney', label: 'Australia/Sydney (AEST)' },
    { group: 'UTC+10:00', timezone: 'Pacific/Chuuk', label: 'Pacific/Chuuk (+10)' },
    { group: 'UTC+10:00', timezone: 'Pacific/Guam', label: 'Pacific/Guam (ChST)' },
    { group: 'UTC+10:00', timezone: 'Pacific/Port_Moresby', label: 'Pacific/Port Moresby (+10)' },
    { group: 'UTC+10:00', timezone: 'Pacific/Saipan', label: 'Pacific/Saipan (ChST)' },
    // UTC+09:30
    { group: 'UTC+09:30', timezone: 'Australia/Adelaide', label: 'Australia/Adelaide (ACST)' },
    { group: 'UTC+09:30', timezone: 'Australia/Broken_Hill', label: 'Australia/Broken Hill (ACST)' },
    { group: 'UTC+09:30', timezone: 'Australia/Darwin', label: 'Australia/Darwin (ACST)' },
    // UTC+09:00
    { group: 'UTC+09:00', timezone: 'Asia/Chita', label: 'Asia/Chita (+09)' },
    { group: 'UTC+09:00', timezone: 'Asia/Dili', label: 'Asia/Dili (+09)' },
    { group: 'UTC+09:00', timezone: 'Asia/Jayapura', label: 'Asia/Jayapura (WIT)' },
    { group: 'UTC+09:00', timezone: 'Asia/Khandyga', label: 'Asia/Khandyga (+09)' },
    { group: 'UTC+09:00', timezone: 'Asia/Seoul', label: 'Asia/Seoul (KST)' },
    { group: 'UTC+09:00', timezone: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)' },
    { group: 'UTC+09:00', timezone: 'Asia/Yakutsk', label: 'Asia/Yakutsk (+09)' },
    { group: 'UTC+09:00', timezone: 'Pacific/Palau', label: 'Pacific/Palau (+09)' },
    // UTC+08:45
    { group: 'UTC+08:45', timezone: 'Australia/Eucla', label: 'Australia/Eucla (+08:45)' },
    // UTC+08:30
    { group: 'UTC+08:30', timezone: 'Asia/Pyongyang', label: 'Asia/Pyongyang (KST)' },
    // UTC+08:00
    { group: 'UTC+08:00', timezone: 'Asia/Brunei', label: 'Asia/Brunei (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Choibalsan', label: 'Asia/Choibalsan (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Hong_Kong', label: 'Asia/Hong Kong (HKT)' },
    { group: 'UTC+08:00', timezone: 'Asia/Irkutsk', label: 'Asia/Irkutsk (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Kuala_Lumpur', label: 'Asia/Kuala Lumpur (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Kuching', label: 'Asia/Kuching (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Macau', label: 'Asia/Macau (CST)' },
    { group: 'UTC+08:00', timezone: 'Asia/Makassar', label: 'Asia/Makassar (WITA)' },
    { group: 'UTC+08:00', timezone: 'Asia/Manila', label: 'Asia/Manila (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Shanghai', label: 'Asia/Shanghai (CST)' },
    { group: 'UTC+08:00', timezone: 'Asia/Singapore', label: 'Asia/Singapore (+08)' },
    { group: 'UTC+08:00', timezone: 'Asia/Taipei', label: 'Asia/Taipei (CST)' },
    { group: 'UTC+08:00', timezone: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar (+08)' },
    { group: 'UTC+08:00', timezone: 'Australia/Perth', label: 'Australia/Perth (AWST)' },
    // UTC+07:00
    { group: 'UTC+07:00', timezone: 'Antarctica/Davis', label: 'Antarctica/Davis (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Bangkok', label: 'Asia/Bangkok (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Barnaul', label: 'Asia/Barnaul (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Ho_Chi_Minh', label: 'Asia/Ho Chi Minh (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Hovd', label: 'Asia/Hovd (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Jakarta', label: 'Asia/Jakarta (WIB)' },
    { group: 'UTC+07:00', timezone: 'Asia/Krasnoyarsk', label: 'Asia/Krasnoyarsk (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Novokuznetsk', label: 'Asia/Novokuznetsk (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Novosibirsk', label: 'Asia/Novosibirsk (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Phnom_Penh', label: 'Asia/Phnom_Penh (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Pontianak', label: 'Asia/Pontianak (WIB)' },
    { group: 'UTC+07:00', timezone: 'Asia/Tomsk', label: 'Asia/Tomsk (+07)' },
    { group: 'UTC+07:00', timezone: 'Asia/Vientiane', label: 'Asia/Vientiane (+07)' },
    { group: 'UTC+07:00', timezone: 'Indian/Christmas', label: 'Indian/Christmas (+07)' },
    // UTC+06:30
    { group: 'UTC+06:30', timezone: 'Asia/Yangon', label: 'Asia/Yangon (+06:30)' },
    { group: 'UTC+06:30', timezone: 'Indian/Cocos', label: 'Indian/Cocos (+06:30)' },
    // UTC+06:00
    { group: 'UTC+06:00', timezone: 'Antarctica/Vostok', label: 'Antarctica/Vostok (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Almaty', label: 'Asia/Almaty (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Bishkek', label: 'Asia/Bishkek (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Dhaka', label: 'Asia/Dhaka (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Omsk', label: 'Asia/Omsk (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Qyzylorda', label: 'Asia/Qyzylorda (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Thimphu', label: 'Asia/Thimphu (+06)' },
    { group: 'UTC+06:00', timezone: 'Asia/Urumqi', label: 'Asia/Urumqi (+06)' },
    { group: 'UTC+06:00', timezone: 'Indian/Chagos', label: 'Indian/Chagos (+06)' },
    // UTC+05:45
    { group: 'UTC+05:45', timezone: 'Asia/Kathmandu', label: 'Asia/Kathmandu (+05:45)' },
    // UTC+05:30
    { group: 'UTC+05:30', timezone: 'Asia/Colombo', label: 'Asia/Colombo (+05:30)' },
    { group: 'UTC+05:30', timezone: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
    // UTC+05:00
    { group: 'UTC+05:00', timezone: 'Antarctica/Mawson', label: 'Antarctica/Mawson (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Aqtau', label: 'Asia/Aqtau (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Aqtobe', label: 'Asia/Aqtobe (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Ashgabat', label: 'Asia/Ashgabat (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Atyrau', label: 'Asia/Atyrau (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Dushanbe', label: 'Asia/Dushanbe (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Karachi', label: 'Asia/Karachi (PKT)' },
    { group: 'UTC+05:00', timezone: 'Asia/Oral', label: 'Asia/Oral (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Samarkand', label: 'Asia/Samarkand (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Tashkent', label: 'Asia/Tashkent (+05)' },
    { group: 'UTC+05:00', timezone: 'Asia/Yekaterinburg', label: 'Asia/Yekaterinburg (+05)' },
    { group: 'UTC+05:00', timezone: 'Indian/Kerguelen', label: 'Indian/Kerguelen (+05)' },
    { group: 'UTC+05:00', timezone: 'Indian/Maldives', label: 'Indian/Maldives (+05)' },
    // UTC+04:30
    { group: 'UTC+04:30', timezone: 'Asia/Kabul', label: 'Asia/Kabul (+04:30)' },
    { group: 'UTC+04:30', timezone: 'Asia/Tehran', label: 'Asia/Tehran (+04:30)' },
    // UTC+04:00
    { group: 'UTC+04:00', timezone: 'Asia/Baku', label: 'Asia/Baku (+04)' },
    { group: 'UTC+04:00', timezone: 'Asia/Dubai', label: 'Asia/Dubai (+04)' },
    { group: 'UTC+04:00', timezone: 'Asia/Muscat', label: 'Asia/Muscat (+04)' },
    { group: 'UTC+04:00', timezone: 'Asia/Tbilisi', label: 'Asia/Tbilisi (+04)' },
    { group: 'UTC+04:00', timezone: 'Asia/Yerevan', label: 'Asia/Yerevan (+04)' },
    { group: 'UTC+04:00', timezone: 'Europe/Astrakhan', label: 'Europe/Astrakhan (+04)' },
    { group: 'UTC+04:00', timezone: 'Europe/Samara', label: 'Europe/Samara (+04)' },
    { group: 'UTC+04:00', timezone: 'Europe/Saratov', label: 'Europe/Saratov (+04)' },
    { group: 'UTC+04:00', timezone: 'Europe/Ulyanovsk', label: 'Europe/Ulyanovsk (+04)' },
    { group: 'UTC+04:00', timezone: 'Indian/Mahe', label: 'Indian/Mahe (+04)' },
    { group: 'UTC+04:00', timezone: 'Indian/Mauritius', label: 'Indian/Mauritius (+04)' },
    { group: 'UTC+04:00', timezone: 'Indian/Reunion', label: 'Indian/Reunion (+04)' },
    // UTC+03:00
    { group: 'UTC+03:00', timezone: 'Africa/Addis_Ababa', label: 'Africa/Addis Ababa (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Asmara', label: 'Africa/Asmara (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Dar_es_Salaam', label: 'Africa/Dar es Salaam (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Djibouti', label: 'Africa/Djibouti (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Juba', label: 'Africa/Juba (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Kampala', label: 'Africa/Kampala (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Khartoum', label: 'Africa/Khartoum (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Mogadishu', label: 'Africa/Mogadishu (EAT)' },
    { group: 'UTC+03:00', timezone: 'Africa/Nairobi', label: 'Africa/Nairobi (EAT)' },
    { group: 'UTC+03:00', timezone: 'Antarctica/Syowa', label: 'Antarctica/Syowa (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Aden', label: 'Asia/Aden (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Amman', label: 'Asia/Amman (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Baghdad', label: 'Asia/Baghdad (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Bahrain', label: 'Asia/Bahrain (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Beirut', label: 'Asia/Beirut (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Damascus', label: 'Asia/Damascus (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Famagusta', label: 'Asia/Famagusta (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Gaza', label: 'Asia/Gaza (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Hebron', label: 'Asia/Hebron (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Jerusalem', label: 'Asia/Jerusalem (IDT)' },
    { group: 'UTC+03:00', timezone: 'Asia/Kuwait', label: 'Asia/Kuwait (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Nicosia', label: 'Asia/Nicosia (EEST)' },
    { group: 'UTC+03:00', timezone: 'Asia/Qatar', label: 'Asia/Qatar (+03)' },
    { group: 'UTC+03:00', timezone: 'Asia/Riyadh', label: 'Asia/Riyadh (+03)' },
    { group: 'UTC+03:00', timezone: 'Europe/Athens', label: 'Europe/Athens (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Bucharest', label: 'Europe/Bucharest (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Chisinau', label: 'Europe/Chisinau (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Helsinki', label: 'Europe/Helsinki (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Istanbul', label: 'Europe/Istanbul (+03)' },
    { group: 'UTC+03:00', timezone: 'Europe/Kiev', label: 'Europe/Kiev (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Kirov', label: 'Europe/Kirov (+03)' },
    { group: 'UTC+03:00', timezone: 'Europe/Mariehamn', label: 'Europe/Mariehamn (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Minsk', label: 'Europe/Minsk (+03)' },
    { group: 'UTC+03:00', timezone: 'Europe/Moscow', label: 'Europe/Moscow (MSK)' },
    { group: 'UTC+03:00', timezone: 'Europe/Riga', label: 'Europe/Riga (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Simferopol', label: 'Europe/Simferopol (MSK)' },
    { group: 'UTC+03:00', timezone: 'Europe/Sofia', label: 'Europe/Sofia (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Tallinn', label: 'Europe/Tallinn (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Uzhgorod', label: 'Europe/Uzhgorod (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Vilnius', label: 'Europe/Vilnius (EEST)' },
    { group: 'UTC+03:00', timezone: 'Europe/Volgograd', label: 'Europe/Volgograd (+03)' },
    { group: 'UTC+03:00', timezone: 'Europe/Zaporozhye', label: 'Europe/Zaporozhye (EEST)' },
    { group: 'UTC+03:00', timezone: 'Indian/Antananarivo', label: 'Indian/Antananarivo (EAT)' },
    { group: 'UTC+03:00', timezone: 'Indian/Comoro', label: 'Indian/Comoro (EAT)' },
    { group: 'UTC+03:00', timezone: 'Indian/Mayotte', label: 'Indian/Mayotte (EAT)' },
    // UTC+02:00
    { group: 'UTC+02:00', timezone: 'Africa/Blantyre', label: 'Africa/Blantyre (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Bujumbura', label: 'Africa/Bujumbura (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Cairo', label: 'Africa/Cairo (EET)' },
    { group: 'UTC+02:00', timezone: 'Africa/Ceuta', label: 'Africa/Ceuta (CEST)' },
    { group: 'UTC+02:00', timezone: 'Africa/Gaborone', label: 'Africa/Gaborone (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Harare', label: 'Africa/Harare (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Johannesburg', label: 'Africa/Johannesburg (SAST)' },
    { group: 'UTC+02:00', timezone: 'Africa/Kigali', label: 'Africa/Kigali (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Lusaka', label: 'Africa/Lusaka (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Maputo', label: 'Africa/Maputo (CAT)' },
    { group: 'UTC+02:00', timezone: 'Africa/Maseru', label: 'Africa/Maseru (SAST)' },
    { group: 'UTC+02:00', timezone: 'Africa/Mbabane', label: 'Africa/Mbabane (SAST)' },
    { group: 'UTC+02:00', timezone: 'Africa/Tripoli', label: 'Africa/Tripoli (EET)' },
    { group: 'UTC+02:00', timezone: 'Antarctica/Troll', label: 'Antarctica/Troll (+02)' },
    { group: 'UTC+02:00', timezone: 'Arctic/Longyearbyen', label: 'Arctic/Longyearbyen (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Amsterdam', label: 'Europe/Amsterdam (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Andorra', label: 'Europe/Andorra (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Belgrade', label: 'Europe/Belgrade (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Berlin', label: 'Europe/Berlin (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Bratislava', label: 'Europe/Bratislava (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Brussels', label: 'Europe/Brussels (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Budapest', label: 'Europe/Budapest (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Busingen', label: 'Europe/Busingen (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Copenhagen', label: 'Europe/Copenhagen (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Gibraltar', label: 'Europe/Gibraltar (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Kaliningrad', label: 'Europe/Kaliningrad (EET)' },
    { group: 'UTC+02:00', timezone: 'Europe/Ljubljana', label: 'Europe/Ljubljana (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Luxembourg', label: 'Europe/Luxembourg (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Madrid', label: 'Europe/Madrid (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Malta', label: 'Europe/Malta (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Monaco', label: 'Europe/Monaco (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Oslo', label: 'Europe/Oslo (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Paris', label: 'Europe/Paris (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Podgorica', label: 'Europe/Podgorica (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Prague', label: 'Europe/Prague (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Rome', label: 'Europe/Rome (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/San_Marino', label: 'Europe/San Marino (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Sarajevo', label: 'Europe/Sarajevo (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Skopje', label: 'Europe/Skopje (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Stockholm', label: 'Europe/Stockholm (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Tirane', label: 'Europe/Tirane (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Vaduz', label: 'Europe/Vaduz (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Vatican', label: 'Europe/Vatican (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Vienna', label: 'Europe/Vienna (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Warsaw', label: 'Europe/Warsaw (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Zagreb', label: 'Europe/Zagreb (CEST)' },
    { group: 'UTC+02:00', timezone: 'Europe/Zurich', label: 'Europe/Zurich (CEST)' },
    // UTC+01:00
    { group: 'UTC+01:00', timezone: 'Africa/Algiers', label: 'Africa/Algiers (CET)' },
    { group: 'UTC+01:00', timezone: 'Africa/Bangui', label: 'Africa/Bangui (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Brazzaville', label: 'Africa/Brazzaville (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Casablanca', label: 'Africa/Casablanca (WEST)' },
    { group: 'UTC+01:00', timezone: 'Africa/Douala', label: 'Africa/Douala (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/El_Aaiun', label: 'Africa/El Aaiun (WEST)' },
    { group: 'UTC+01:00', timezone: 'Africa/Kinshasa', label: 'Africa/Kinshasa (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Lagos', label: 'Africa/Lagos (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Libreville', label: 'Africa/Libreville (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Luanda', label: 'Africa/Luanda (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Malabo', label: 'Africa/Malabo (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Ndjamena', label: 'Africa/Ndjamena (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Niamey', label: 'Africa/Niamey (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Porto-Novo', label: 'Africa/Porto-Novo (WAT)' },
    { group: 'UTC+01:00', timezone: 'Africa/Tunis', label: 'Africa/Tunis (CET)' },
    { group: 'UTC+01:00', timezone: 'Africa/Windhoek', label: 'Africa/Windhoek (WAT)' },
    { group: 'UTC+01:00', timezone: 'Atlantic/Canary', label: 'Atlantic/Canary (WEST)' },
    { group: 'UTC+01:00', timezone: 'Atlantic/Faroe', label: 'Atlantic/Faroe (WEST)' },
    { group: 'UTC+01:00', timezone: 'Atlantic/Madeira', label: 'Atlantic/Madeira (WEST)' },
    { group: 'UTC+01:00', timezone: 'Europe/Dublin', label: 'Europe/Dublin (IST)' },
    { group: 'UTC+01:00', timezone: 'Europe/Guernsey', label: 'Europe/Guernsey (BST)' },
    { group: 'UTC+01:00', timezone: 'Europe/Isle_of_Man', label: 'Europe/Isle of Man (BST)' },
    { group: 'UTC+01:00', timezone: 'Europe/Jersey', label: 'Europe/Jersey (BST)' },
    { group: 'UTC+01:00', timezone: 'Europe/Lisbon', label: 'Europe/Lisbon (WEST)' },
    { group: 'UTC+01:00', timezone: 'Europe/London', label: 'Europe/London (BST)' },
    // UTC
    { group: 'UTC', timezone: 'Africa/Abidjan', label: 'Africa/Abidjan (GMT)' },
    { group: 'UTC', timezone: 'Africa/Accra', label: 'Africa/Accra (GMT)' },
    { group: 'UTC', timezone: 'Africa/Bamako', label: 'Africa/Bamako (GMT)' },
    { group: 'UTC', timezone: 'Africa/Banjul', label: 'Africa/Banjul (GMT)' },
    { group: 'UTC', timezone: 'Africa/Bissau', label: 'Africa/Bissau (GMT)' },
    { group: 'UTC', timezone: 'Africa/Conakry', label: 'Africa/Conakry (GMT)' },
    { group: 'UTC', timezone: 'Africa/Dakar', label: 'Africa/Dakar (GMT)' },
    { group: 'UTC', timezone: 'Africa/Freetown', label: 'Africa/Freetown (GMT)' },
    { group: 'UTC', timezone: 'Africa/Lome', label: 'Africa/Lome (GMT)' },
    { group: 'UTC', timezone: 'Africa/Monrovia', label: 'Africa/Monrovia (GMT)' },
    { group: 'UTC', timezone: 'Africa/Nouakchott', label: 'Africa/Nouakchott (GMT)' },
    { group: 'UTC', timezone: 'Africa/Ouagadougou', label: 'Africa/Ouagadougou (GMT)' },
    { group: 'UTC', timezone: 'Africa/Sao_Tome', label: 'Africa/Sao_Tome (GMT)' },
    { group: 'UTC', timezone: 'America/Danmarkshavn', label: 'America/Danmarkshavn (GMT)' },
    { group: 'UTC', timezone: 'America/Scoresbysund', label: 'America/Scoresbysund (+00)' },
    { group: 'UTC', timezone: 'Atlantic/Azores', label: 'Atlantic/Azores (+00)' },
    { group: 'UTC', timezone: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik (GMT)' },
    { group: 'UTC', timezone: 'Atlantic/St_Helena', label: 'Atlantic/St_Helena (GMT)' },
    { group: 'UTC', timezone: 'UTC', label: 'UTC (UTC)' },
    // UTC-01:00
    { group: 'UTC-01:00', timezone: 'Atlantic/Cape_Verde', label: 'Atlantic/Cape Verde (-01)' },
    // UTC-02:00
    { group: 'UTC-02:00', timezone: 'America/Godthab', label: 'America/Godthab (-02)' },
    { group: 'UTC-02:00', timezone: 'America/Miquelon', label: 'America/Miquelon (-02)' },
    { group: 'UTC-02:00', timezone: 'America/Noronha', label: 'America/Noronha (-02)' },
    { group: 'UTC-02:00', timezone: 'Atlantic/South_Georgia', label: 'Atlantic/South Georgia (-02)' },
    // UTC-02:30
    { group: 'UTC-02:30', timezone: 'America/St_Johns', label: 'America/St Johns (NDT)' },
    // UTC-03:00
    { group: 'UTC-03:00', timezone: 'America/Araguaina', label: 'America/Araguaina (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos Aires (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Catamarca', label: 'America/Argentina/Catamarca (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Cordoba', label: 'America/Argentina/Cordoba (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Jujuy', label: 'America/Argentina/Jujuy (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/La_Rioja', label: 'America/Argentina/La Rioja (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Rio_Gallegos', label: 'America/Argentina/Rio Gallegos (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Salta', label: 'America/Argentina/Salta (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/San_Juan', label: 'America/Argentina/San Juan (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/San_Luis', label: 'America/Argentina/San Luis (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Tucuman', label: 'America/Argentina/Tucuman (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Argentina/Ushuaia', label: 'America/Argentina/Ushuaia (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Bahia', label: 'America/Bahia (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Belem', label: 'America/Belem (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Cayenne', label: 'America/Cayenne (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Fortaleza', label: 'America/Fortaleza (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Glace_Bay', label: 'America/Glace_Bay (ADT)' },
    { group: 'UTC-03:00', timezone: 'America/Goose_Bay', label: 'America/Goose_Bay (ADT)' },
    { group: 'UTC-03:00', timezone: 'America/Halifax', label: 'America/Halifax (ADT)' },
    { group: 'UTC-03:00', timezone: 'America/Maceio', label: 'America/Maceio (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Moncton', label: 'America/Moncton (ADT)' },
    { group: 'UTC-03:00', timezone: 'America/Montevideo', label: 'America/Montevideo (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Paramaribo', label: 'America/Paramaribo (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Punta_Arenas', label: 'America/Punta Arenas (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Recife', label: 'America/Recife (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Santarem', label: 'America/Santarem (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Sao_Paulo', label: 'America/Sao Paulo (-03)' },
    { group: 'UTC-03:00', timezone: 'America/Thule', label: 'America/Thule (ADT)' },
    { group: 'UTC-03:00', timezone: 'Antarctica/Palmer', label: 'Antarctica/Palmer (-03)' },
    { group: 'UTC-03:00', timezone: 'Antarctica/Rothera', label: 'Antarctica/Rothera (-03)' },
    { group: 'UTC-03:00', timezone: 'Atlantic/Bermuda', label: 'Atlantic/Bermuda (ADT)' },
    { group: 'UTC-03:00', timezone: 'Atlantic/Stanley', label: 'Atlantic/Stanley (-03)' },
    // UTC-04:00
    { group: 'UTC-04:00', timezone: 'America/Anguilla', label: 'America/Anguilla (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Antigua', label: 'America/Antigua (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Aruba', label: 'America/Aruba (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Asuncion', label: 'America/Asuncion (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Barbados', label: 'America/Barbados (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Blanc-Sablon', label: 'America/Blanc-Sablon (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Boa_Vista', label: 'America/Boa Vista (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Campo_Grande', label: 'America/Campo Grande (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Caracas', label: 'America/Caracas (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Cuiaba', label: 'America/Cuiaba (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Curacao', label: 'America/Curacao (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Detroit', label: 'America/Detroit (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Dominica', label: 'America/Dominica (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Grand_Turk', label: 'America/Grand Turk (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Grenada', label: 'America/Grenada (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Guadeloupe', label: 'America/Guadeloupe (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Guyana', label: 'America/Guyana (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Havana', label: 'America/Havana (CDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Marengo', label: 'America/Indiana/Marengo (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Petersburg', label: 'America/Indiana/Petersburg (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Vevay', label: 'America/Indiana/Vevay (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Vincennes', label: 'America/Indiana/Vincennes (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Indiana/Winamac', label: 'America/Indiana/Winamac (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Iqaluit', label: 'America/Iqaluit (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Kentucky/Louisville', label: 'America/Kentucky/Louisville (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Kentucky/Monticello', label: 'America/Kentucky/Monticello (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Kralendijk', label: 'America/Kralendijk (AST)' },
    { group: 'UTC-04:00', timezone: 'America/La_Paz', label: 'America/La_Paz (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Lower_Princes', label: 'America/Lower Princes (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Manaus', label: 'America/Manaus (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Marigot', label: 'America/Marigot (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Martinique', label: 'America/Martinique (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Montserrat', label: 'America/Montserrat (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Nassau', label: 'America/Nassau (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/New_York', label: 'America/New_York (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Nipigon', label: 'America/Nipigon (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Pangnirtung', label: 'America/Pangnirtung (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Port-au-Prince', label: 'America/Port-au-Prince (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Port_of_Spain', label: 'America/Port of Spain (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Porto_Velho', label: 'America/Porto Velho (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Puerto_Rico', label: 'America/Puerto Rico (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Santiago', label: 'America/Santiago (-04)' },
    { group: 'UTC-04:00', timezone: 'America/Santo_Domingo', label: 'America/Santo Domingo (AST)' },
    { group: 'UTC-04:00', timezone: 'America/St_Barthelemy', label: 'America/St Barthelemy (AST)' },
    { group: 'UTC-04:00', timezone: 'America/St_Kitts', label: 'America/St Kitts (AST)' },
    { group: 'UTC-04:00', timezone: 'America/St_Lucia', label: 'America/St Lucia (AST)' },
    { group: 'UTC-04:00', timezone: 'America/St_Thomas', label: 'America/St Thomas (AST)' },
    { group: 'UTC-04:00', timezone: 'America/St_Vincent', label: 'America/St Vincent (AST)' },
    { group: 'UTC-04:00', timezone: 'America/Thunder_Bay', label: 'America/Thunder Bay (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Toronto', label: 'America/Toronto (EDT)' },
    { group: 'UTC-04:00', timezone: 'America/Tortola', label: 'America/Tortola (AST)' },
    // UTC-05:00
    { group: 'UTC-05:00', timezone: 'America/Atikokan', label: 'America/Atikokan (EST)' },
    { group: 'UTC-05:00', timezone: 'America/Bahia_Banderas', label: 'America/Bahia Banderas (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Bogota', label: 'America/Bogota (-05)' },
    { group: 'UTC-05:00', timezone: 'America/Cancun', label: 'America/Cancun (EST)' },
    { group: 'UTC-05:00', timezone: 'America/Cayman', label: 'America/Cayman (EST)' },
    { group: 'UTC-05:00', timezone: 'America/Chicago', label: 'America/Chicago (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Eirunepe', label: 'America/Eirunepe (-05)' },
    { group: 'UTC-05:00', timezone: 'America/Guayaquil', label: 'America/Guayaquil (-05)' },
    { group: 'UTC-05:00', timezone: 'America/Indiana/Knox', label: 'America/Indiana/Knox (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Indiana/Tell_City', label: 'America/Indiana/Tell City (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Jamaica', label: 'America/Jamaica (EST)' },
    { group: 'UTC-05:00', timezone: 'America/Lima', label: 'America/Lima (-05)' },
    { group: 'UTC-05:00', timezone: 'America/Matamoros', label: 'America/Matamoros (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Menominee', label: 'America/Menominee (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Merida', label: 'America/Merida (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Mexico_City', label: 'America/Mexico City (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Monterrey', label: 'America/Monterrey (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/North_Dakota/Beulah', label: 'America/North Dakota/Beulah (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/North_Dakota/Center', label: 'America/North Dakota/Center (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/North_Dakota/New_Salem', label: 'America/North Dakota/New Salem (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Panama', label: 'America/Panama (EST)' },
    { group: 'UTC-05:00', timezone: 'America/Rainy_River', label: 'America/Rainy River (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Rankin_Inlet', label: 'America/Rankin Inlet (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Resolute', label: 'America/Resolute (CDT)' },
    { group: 'UTC-05:00', timezone: 'America/Rio_Branco', label: 'America/Rio Branco (-05)' },
    { group: 'UTC-05:00', timezone: 'America/Winnipeg', label: 'America/Winnipeg (CDT)' },
    // UTC-06:00
    { group: 'UTC-06:00', timezone: 'America/Belize', label: 'America/Belize (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Boise', label: 'America/Boise (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Cambridge_Bay', label: 'America/Cambridge Bay (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Chihuahua', label: 'America/Chihuahua (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Costa_Rica', label: 'America/Costa Rica (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Denver', label: 'America/Denver (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Edmonton', label: 'America/Edmonton (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/El_Salvador', label: 'America/El Salvador (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Guatemala', label: 'America/Guatemala (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Inuvik', label: 'America/Inuvik (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Managua', label: 'America/Managua (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Mazatlan', label: 'America/Mazatlan (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Ojinaga', label: 'America/Ojinaga (MDT)' },
    { group: 'UTC-06:00', timezone: 'America/Regina', label: 'America/Regina (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Swift_Current', label: 'America/Swift Current (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Tegucigalpa', label: 'America/Tegucigalpa (CST)' },
    { group: 'UTC-06:00', timezone: 'America/Yellowknife', label: 'America/Yellowknife (MDT)' },
    { group: 'UTC-06:00', timezone: 'Pacific/Easter', label: 'Pacific/Easter (-06)' },
    { group: 'UTC-06:00', timezone: 'Pacific/Galapagos', label: 'Pacific/Galapagos (-06)' },
    // UTC-07:00
    { group: 'UTC-07:00', timezone: 'America/Creston', label: 'America/Creston (MST)' },
    { group: 'UTC-07:00', timezone: 'America/Dawson', label: 'America/Dawson (PDT)' },
    { group: 'UTC-07:00', timezone: 'America/Dawson_Creek', label: 'America/Dawson Creek (MST)' },
    { group: 'UTC-07:00', timezone: 'America/Fort_Nelson', label: 'America/Fort Nelson (MST)' },
    { group: 'UTC-07:00', timezone: 'America/Hermosillo', label: 'America/Hermosillo (MST)' },
    { group: 'UTC-07:00', timezone: 'America/Los_Angeles', label: 'America/Los Angeles (PDT)' },
    { group: 'UTC-07:00', timezone: 'America/Phoenix', label: 'America/Phoenix (MST)' },
    { group: 'UTC-07:00', timezone: 'America/Tijuana', label: 'America/Tijuana (PDT)' },
    { group: 'UTC-07:00', timezone: 'America/Vancouver', label: 'America/Vancouver (PDT)' },
    { group: 'UTC-07:00', timezone: 'America/Whitehorse', label: 'America/Whitehorse (PDT)' },
    // UTC-08:00
    { group: 'UTC-08:00', timezone: 'America/Anchorage', label: 'America/Anchorage (AKDT)' },
    { group: 'UTC-08:00', timezone: 'America/Juneau', label: 'America/Juneau (AKDT)' },
    { group: 'UTC-08:00', timezone: 'America/Metlakatla', label: 'America/Metlakatla (AKDT)' },
    { group: 'UTC-08:00', timezone: 'America/Nome', label: 'America/Nome (AKDT)' },
    { group: 'UTC-08:00', timezone: 'America/Sitka', label: 'America/Sitka (AKDT)' },
    { group: 'UTC-08:00', timezone: 'America/Yakutat', label: 'America/Yakutat (AKDT)' },
    { group: 'UTC-08:00', timezone: 'Pacific/Pitcairn', label: 'Pacific/Pitcairn (-08)' },
    // UTC-09:00
    { group: 'UTC-09:00', timezone: 'America/Adak', label: 'America/Adak (HDT)' },
    { group: 'UTC-09:00', timezone: 'Pacific/Gambier', label: 'Pacific/Gambier (-09)' },
    // UTC-09:30
    { group: 'UTC-09:30', timezone: 'Pacific/Marquesas', label: 'Pacific/Marquesas (-09:30)' },
    // UTC-10:00
    { group: 'UTC-10:00', timezone: 'Pacific/Honolulu', label: 'Pacific/Honolulu (HST)' },
    { group: 'UTC-10:00', timezone: 'Pacific/Rarotonga', label: 'Pacific/Rarotonga (-10)' },
    { group: 'UTC-10:00', timezone: 'Pacific/Tahiti', label: 'Pacific/Tahiti (-10)' },
    // UTC-11:00
    { group: 'UTC-11:00', timezone: 'Pacific/Midway', label: 'Pacific/Midway (SST)' },
    { group: 'UTC-11:00', timezone: 'Pacific/Niue', label: 'Pacific/Niue (-11)' },
    { group: 'UTC-11:00', timezone: 'Pacific/Pago_Pago', label: 'Pacific/Pago Pago (SST)' }
]));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/subtipo_registro.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/icono.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/estadisticas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/domain/estadisticaEmpleado.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/usuario.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UsuarioService = /** @class */ (function () {
    function UsuarioService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/usuarios';
    }
    /**
     * @param {?=} filters
     * @return {?}
     */
    UsuarioService.prototype.actualizarPassword = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/password' + url_params).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    UsuarioService.prototype.restablecerPassword = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/restablecerPassword' + url_params).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    UsuarioService.prototype.getUsuarios = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} usuariosRest
         * @return {?}
         */
        function (usuariosRest) {
            /** @type {?} */
            var usuarios = usuariosRest.map((/**
             * @param {?} usuarioRest
             * @return {?}
             */
            function (usuarioRest) {
                return (/** @type {?} */ (usuarioRest));
            }));
            return usuarios;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    UsuarioService.prototype.getUsuariosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    UsuarioService.prototype.getOneUsuario = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getUsuarios(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} usuarios
         * @return {?}
         */
        function (usuarios) {
            if (usuarios == null || usuarios.length == 0) {
                return null;
            }
            else {
                return usuarios[0];
            }
        })));
    };
    /**
     * @param {?} usuario
     * @return {?}
     */
    UsuarioService.prototype.anyadirUsuario = /**
     * @param {?} usuario
     * @return {?}
     */
    function (usuario) {
        /** @type {?} */
        var usuario_post = (/** @type {?} */ ({
            email: usuario.email,
            idTipo: usuario.idTipo,
            nombre: usuario.nombre,
            apellidos: usuario.apellidos,
            listaEmpresas: usuario.listaEmpresas
        }));
        return this.http.post(this.base_url, usuario_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} usuario
     * @return {?}
     */
    UsuarioService.prototype.actualizarUsuario = /**
     * @param {?} usuario
     * @return {?}
     */
    function (usuario) {
        /** @type {?} */
        var usuario_put = (/** @type {?} */ ({
            id: usuario.id,
            email: usuario.email,
            idTipo: usuario.idTipo,
            nombre: usuario.nombre,
            apellidos: usuario.apellidos,
            listaEmpresas: usuario.listaEmpresas
        }));
        return this.http.put(this.base_url + '/' + usuario_put.id, usuario_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idUsuario
     * @return {?}
     */
    UsuarioService.prototype.eliminarUsuario = /**
     * @param {?} idUsuario
     * @return {?}
     */
    function (idUsuario) {
        return this.http.delete(this.base_url + '/' + idUsuario).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idUsuario
     * @param {?} idEmpresa
     * @return {?}
     */
    UsuarioService.prototype.asignarUsuarioEmpresa = /**
     * @param {?} idUsuario
     * @param {?} idEmpresa
     * @return {?}
     */
    function (idUsuario, idEmpresa) {
        return this.http.post(this.base_url + '/' + idUsuario + '/' + idEmpresa, null).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    UsuarioService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UsuarioService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ UsuarioService.ngInjectableDef = defineInjectable({ factory: function UsuarioService_Factory() { return new UsuarioService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: UsuarioService, providedIn: "root" });
    return UsuarioService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/dispositivo.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DispositivoService = /** @class */ (function () {
    function DispositivoService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/dispositivos';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    DispositivoService.prototype.getDispositivos = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} dispositivosRest
         * @return {?}
         */
        function (dispositivosRest) {
            /** @type {?} */
            var dispositivos = dispositivosRest.map((/**
             * @param {?} dispositivoRest
             * @return {?}
             */
            function (dispositivoRest) {
                return (/** @type {?} */ (dispositivoRest));
            }));
            return dispositivos;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    DispositivoService.prototype.getDispositivosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    DispositivoService.prototype.getOneDispositivo = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getDispositivos(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} dispositivos
         * @return {?}
         */
        function (dispositivos) {
            if (dispositivos == null || dispositivos.length == 0) {
                return null;
            }
            else {
                return dispositivos[0];
            }
        })));
    };
    /**
     * @param {?} dispositivo
     * @return {?}
     */
    DispositivoService.prototype.anyadirDispositivo = /**
     * @param {?} dispositivo
     * @return {?}
     */
    function (dispositivo) {
        /** @type {?} */
        var dispositivo_post = (/** @type {?} */ ({
            uuid: dispositivo.uuid,
            nombre: dispositivo.nombre,
            listaEmpresas: dispositivo.listaEmpresas,
            tipoFichaje: dispositivo.tipoFichaje
        }));
        return this.http.post(this.base_url, dispositivo_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} dispositivo
     * @return {?}
     */
    DispositivoService.prototype.actualizarDispositivo = /**
     * @param {?} dispositivo
     * @return {?}
     */
    function (dispositivo) {
        /** @type {?} */
        var dispositivo_put = (/** @type {?} */ ({
            id: dispositivo.id,
            uuid: dispositivo.uuid,
            nombre: dispositivo.nombre,
            fecha_modificado: dispositivo.fecha_modificado,
            listaEmpresas: dispositivo.listaEmpresas,
            tipoFichaje: dispositivo.tipoFichaje
        }));
        return this.http.put(this.base_url + '/' + dispositivo_put.id, dispositivo_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idDispositivo
     * @return {?}
     */
    DispositivoService.prototype.eliminarDispositivo = /**
     * @param {?} idDispositivo
     * @return {?}
     */
    function (idDispositivo) {
        return this.http.delete(this.base_url + '/' + idDispositivo).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    DispositivoService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DispositivoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ DispositivoService.ngInjectableDef = defineInjectable({ factory: function DispositivoService_Factory() { return new DispositivoService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: DispositivoService, providedIn: "root" });
    return DispositivoService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/zkteco.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ZktecoService = /** @class */ (function () {
    function ZktecoService(http, configService, utilService) {
        this.http = http;
        this.configService = configService;
        this.utilService = utilService;
        this.base_url = configService.api_url + '/api/v1/zktecos';
    }
    /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    ZktecoService.prototype.getZktecos = /**
     * @param {?=} filters
     * @param {?=} sort_by
     * @param {?=} offset
     * @param {?=} limit
     * @return {?}
     */
    function (filters, sort_by, offset, limit) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        if (offset === void 0) { offset = null; }
        if (limit === void 0) { limit = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters, sort_by, offset, limit);
        return this.http.get(this.base_url + url_params)
            .pipe(map((/**
         * @param {?} zktecosRest
         * @return {?}
         */
        function (zktecosRest) {
            /** @type {?} */
            var zktecos = zktecosRest.map((/**
             * @param {?} zktecoRest
             * @return {?}
             */
            function (zktecoRest) {
                return (/** @type {?} */ (zktecoRest));
            }));
            return zktecos;
        })));
    };
    /**
     * @param {?=} filters
     * @return {?}
     */
    ZktecoService.prototype.getZktecosCount = /**
     * @param {?=} filters
     * @return {?}
     */
    function (filters) {
        if (filters === void 0) { filters = null; }
        /** @type {?} */
        var url_params = this.utilService.getUrlParams(filters);
        return this.http.get(this.base_url + '/count' + url_params)
            .pipe(map((/**
         * @param {?} countRest
         * @return {?}
         */
        function (countRest) {
            return countRest.registros;
        })));
    };
    /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    ZktecoService.prototype.getOneZkteco = /**
     * @private
     * @param {?=} filters
     * @param {?=} sort_by
     * @return {?}
     */
    function (filters, sort_by) {
        if (filters === void 0) { filters = null; }
        if (sort_by === void 0) { sort_by = null; }
        return this.getZktecos(filters, sort_by, 0, 1)
            .pipe(map((/**
         * @param {?} zktecos
         * @return {?}
         */
        function (zktecos) {
            if (zktecos == null || zktecos.length == 0) {
                return null;
            }
            else {
                return zktecos[0];
            }
        })));
    };
    /**
     * @param {?} zkteco
     * @return {?}
     */
    ZktecoService.prototype.anyadirZkteco = /**
     * @param {?} zkteco
     * @return {?}
     */
    function (zkteco) {
        /** @type {?} */
        var zkteco_post = (/** @type {?} */ ({
            nombre: zkteco.nombre,
            conexion_ip: zkteco.conexion_ip,
            conexion_puerto: zkteco.conexion_puerto,
            conexion_terminal: zkteco.conexion_terminal,
            conexion_password: zkteco.conexion_password,
            timezone: zkteco.timezone,
            fecha_conexion: zkteco.fecha_conexion,
            listaEmpresas: zkteco.listaEmpresas
        }));
        return this.http.post(this.base_url, zkteco_post).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} zkteco
     * @return {?}
     */
    ZktecoService.prototype.actualizarZkteco = /**
     * @param {?} zkteco
     * @return {?}
     */
    function (zkteco) {
        /** @type {?} */
        var zkteco_put = (/** @type {?} */ ({
            id: zkteco.id,
            nombre: zkteco.nombre,
            conexion_ip: zkteco.conexion_ip,
            conexion_puerto: zkteco.conexion_puerto,
            conexion_terminal: zkteco.conexion_terminal,
            conexion_password: zkteco.conexion_password,
            timezone: zkteco.timezone,
            fecha_conexion: zkteco.fecha_conexion,
            listaEmpresas: zkteco.listaEmpresas
        }));
        return this.http.put(this.base_url + '/' + zkteco_put.id, zkteco_put).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    /**
     * @param {?} idZkteco
     * @return {?}
     */
    ZktecoService.prototype.eliminarZkteco = /**
     * @param {?} idZkteco
     * @return {?}
     */
    function (idZkteco) {
        return this.http.delete(this.base_url + '/' + idZkteco).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
        })));
    };
    ZktecoService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ZktecoService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ConfigService },
        { type: UtilService }
    ]; };
    /** @nocollapse */ ZktecoService.ngInjectableDef = defineInjectable({ factory: function ZktecoService_Factory() { return new ZktecoService(inject(HttpClient), inject(ConfigService), inject(UtilService)); }, token: ZktecoService, providedIn: "root" });
    return ZktecoService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/guards/authentication.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthenticationGuard = /** @class */ (function () {
    function AuthenticationGuard(configService, authenticationService, router) {
        this.configService = configService;
        this.authenticationService = authenticationService;
        this.router = router;
    }
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    AuthenticationGuard.prototype.canActivate = /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    function (next, state) {
        /** @type {?} */
        var login_page = this.configService.authentication_login_page;
        /** @type {?} */
        var roles_all = this.configService.authentication_roles_all;
        /** @type {?} */
        var roles_any = this.configService.authentication_roles_any;
        /** @type {?} */
        var forbidden_page = this.configService.authentication_forbidden_page;
        if (!this.authenticationService.isUserLogged()) {
            //El usuario no está logado, no dejamos seguir y vamos a login
            if (login_page != null) {
                this.router.navigate([login_page]);
            }
            return false;
        }
        else {
            //Comprobamos que el usuario los tenga si no vamos a forbidden
            /** @type {?} */
            var userHasAllRoles = this.authenticationService.userHasAllRoles(roles_all);
            /** @type {?} */
            var userHasAnyRole = this.authenticationService.userHasAnyRole(roles_any);
            /** @type {?} */
            var userHasRoles = userHasAllRoles && userHasAnyRole;
            if (!userHasRoles && forbidden_page != null) {
                this.router.navigate([forbidden_page]);
            }
            return userHasRoles;
        }
    };
    AuthenticationGuard.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AuthenticationGuard.ctorParameters = function () { return [
        { type: ConfigService },
        { type: AuthenticationService },
        { type: Router }
    ]; };
    /** @nocollapse */ AuthenticationGuard.ngInjectableDef = defineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(inject(ConfigService), inject(AuthenticationService), inject(Router)); }, token: AuthenticationGuard, providedIn: "root" });
    return AuthenticationGuard;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interceptors/error-http-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PROPERTY_MENSAJE_ERROR_INESPERADO = 'app.error.inesperado';
var ErrorHttpInterceptor = /** @class */ (function () {
    function ErrorHttpInterceptor(configService, translateService, messageService, router) {
        this.configService = configService;
        this.translateService = translateService;
        this.messageService = messageService;
        this.router = router;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    ErrorHttpInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        var _this = this;
        return next.handle(request).pipe(tap((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            if (error instanceof HttpErrorResponse) {
                console.error('Error en la petición http', error.status, error.error);
                /** @type {?} */
                var login_page = _this.configService.authentication_login_page;
                /** @type {?} */
                var forbidden_page = _this.configService.authentication_forbidden_page;
                if (error.status === 401) {
                    //Volvemos al login
                    if (login_page != null) {
                        _this.router.navigate([login_page]);
                    }
                }
                else if (error.status === 403) {
                    //No tenemos permisos
                    if (forbidden_page != null) {
                        _this.router.navigate([forbidden_page]);
                    }
                }
                else {
                    if (error.error.code != null && error.error.code > 0) {
                        _this.mostrarMensajeErrorProperty('app.error.codigo_' + error.error.code, error.error.message);
                    }
                    else if (error.error.message != null && error.error.message !== '') {
                        _this.mostrarMensajeErrorTexto(error.error.message);
                    }
                    else {
                        _this.mostrarMensajeErrorInesperado();
                    }
                }
            }
        })));
    };
    /**
     * @private
     * @return {?}
     */
    ErrorHttpInterceptor.prototype.mostrarMensajeErrorInesperado = /**
     * @private
     * @return {?}
     */
    function () {
        this.mostrarMensajeErrorProperty(PROPERTY_MENSAJE_ERROR_INESPERADO);
    };
    /**
     * @private
     * @param {?} property
     * @param {?=} mensaje_alt
     * @return {?}
     */
    ErrorHttpInterceptor.prototype.mostrarMensajeErrorProperty = /**
     * @private
     * @param {?} property
     * @param {?=} mensaje_alt
     * @return {?}
     */
    function (property, mensaje_alt) {
        var _this = this;
        if (mensaje_alt === void 0) { mensaje_alt = null; }
        this.translateService.get(property).subscribe((/**
         * @param {?} mensaje
         * @return {?}
         */
        function (mensaje) {
            if (property === mensaje && property != PROPERTY_MENSAJE_ERROR_INESPERADO) {
                if (mensaje_alt != null && mensaje_alt !== '') {
                    _this.mostrarMensajeErrorTexto(mensaje_alt);
                }
                else {
                    _this.mostrarMensajeErrorProperty(PROPERTY_MENSAJE_ERROR_INESPERADO);
                }
            }
            else {
                _this.mostrarMensajeErrorTexto(mensaje);
            }
        }));
    };
    /**
     * @private
     * @param {?} mensaje
     * @return {?}
     */
    ErrorHttpInterceptor.prototype.mostrarMensajeErrorTexto = /**
     * @private
     * @param {?} mensaje
     * @return {?}
     */
    function (mensaje) {
        this.messageService.add({
            severity: 'error',
            summary: mensaje
        });
    };
    ErrorHttpInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ErrorHttpInterceptor.ctorParameters = function () { return [
        { type: ConfigService },
        { type: TranslateService },
        { type: MessageService },
        { type: Router }
    ]; };
    return ErrorHttpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/interceptors/oauth-http-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OauthHttpInterceptor = /** @class */ (function () {
    function OauthHttpInterceptor(configService, authenticationService) {
        this.configService = configService;
        this.authenticationService = authenticationService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    OauthHttpInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        //let authentication = this._authService.authentication;
        //let authentication = this._authService.authentication;
        /** @type {?} */
        var request_envio = request;
        if (request.url.startsWith(this.configService.api_url)) {
            //Se quita de la seguridad la api de recordar password
            if (!(request.url == (this.configService.api_url + '/usuarios/password') ||
                request.url == (this.configService.api_url + '/usuarios/restablecerPassword'))) {
                //Url del api con seguridad oAuth
                /** @type {?} */
                var authentication = this.authenticationService.authentication;
                if (authentication != null && authentication.token != null && authentication.token.access_token != null) {
                    request_envio = request.clone({
                        withCredentials: true,
                        headers: request.headers.set('Authorization', 'Bearer ' + authentication.token.access_token)
                    });
                }
            }
        }
        return next.handle(request_envio);
    };
    OauthHttpInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    OauthHttpInterceptor.ctorParameters = function () { return [
        { type: ConfigService },
        { type: AuthenticationService }
    ]; };
    return OauthHttpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/loading/loading.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingService = /** @class */ (function () {
    function LoadingService() {
        this._mostrar_dialogo$ = new BehaviorSubject(false);
    }
    Object.defineProperty(LoadingService.prototype, "mostrar_dialogo$", {
        get: /**
         * @return {?}
         */
        function () {
            return this._mostrar_dialogo$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoadingService.prototype, "mostrar_dialogo", {
        get: /**
         * @return {?}
         */
        function () {
            return this._mostrar_dialogo$.getValue();
        },
        set: /**
         * @param {?} mostrar_dialogo
         * @return {?}
         */
        function (mostrar_dialogo) {
            this._mostrar_dialogo$.next(mostrar_dialogo);
        },
        enumerable: true,
        configurable: true
    });
    LoadingService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LoadingService.ctorParameters = function () { return []; };
    /** @nocollapse */ LoadingService.ngInjectableDef = defineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(); }, token: LoadingService, providedIn: "root" });
    return LoadingService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/loading/loading.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent(_loadingService) {
        this.texto = "Cargando...";
        this.loadingService = _loadingService;
    }
    /**
     * @return {?}
     */
    LoadingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.loadingService.mostrar_dialogo = false;
    };
    LoadingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-loading',
                    template: "<div id=\"loading\" *ngIf=\"loadingService.mostrar_dialogo$ | async\">\n  <i class=\"pi pi-spin pi-spinner\"></i>\n    <span>{{ texto }}</span>\n</div>\n",
                    styles: ["div#loading{font-size:1em;position:absolute;right:.5em;bottom:.5em;border:1px solid;padding:.5em}div#loading i{font-size:1.5em}div#loading span{position:relative;top:-.25em;margin-left:.5em}"]
                }] }
    ];
    /** @nocollapse */
    LoadingComponent.ctorParameters = function () { return [
        { type: LoadingService }
    ]; };
    LoadingComponent.propDecorators = {
        texto: [{ type: Input }]
    };
    return LoadingComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/loading/loading-http-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingHttpInterceptor = /** @class */ (function () {
    function LoadingHttpInterceptor(loadingService) {
        this.loadingService = loadingService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    LoadingHttpInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        var _this = this;
        this.loadingService.mostrar_dialogo = true;
        return next.handle(request).pipe(tap((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event instanceof HttpResponse) {
                _this.loadingService.mostrar_dialogo = false;
            }
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            if (error instanceof HttpErrorResponse) {
                _this.loadingService.mostrar_dialogo = false;
            }
        })));
    };
    LoadingHttpInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LoadingHttpInterceptor.ctorParameters = function () { return [
        { type: LoadingService }
    ]; };
    return LoadingHttpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/loading/loading.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingModule = /** @class */ (function () {
    function LoadingModule() {
    }
    LoadingModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LoadingComponent
                    ],
                    providers: [
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: LoadingHttpInterceptor,
                            multi: true
                        }
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        LoadingComponent
                    ]
                },] }
    ];
    return LoadingModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/block-ui/block-ui.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BlockUiComponent = /** @class */ (function () {
    function BlockUiComponent(_blockUiService) {
        this.blockUiService = _blockUiService;
    }
    /**
     * @return {?}
     */
    BlockUiComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    BlockUiComponent.decorators = [
        { type: Component, args: [{
                    selector: 'core-block-ui',
                    template: "<p-blockUI [blocked]=\"blockUiService.bloquear$ | async\"></p-blockUI>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BlockUiComponent.ctorParameters = function () { return [
        { type: BlockUiService }
    ]; };
    return BlockUiComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modules/block-ui/block-ui.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BlockUiModule = /** @class */ (function () {
    function BlockUiModule() {
    }
    BlockUiModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [BlockUiComponent],
                    imports: [
                        CommonModule,
                        BlockUIModule
                    ],
                    exports: [
                        BlockUiComponent
                    ]
                },] }
    ];
    return BlockUiModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: core.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { HttpLoaderFactory, CoreModule, Order, TipoRegistro, TipoUsuario, EstadoIncidencia, TimeZoneList, FormService, UtilService, AUTH_TIPO_USUARIO, AUTH_TIPO_EMPLEADO, AuthenticationService, EventEmiterService, RegistroService, IncidenciaService, EmpleadoService, UsuarioService, CentroService, PeriodoService, AusenciaService, MotivoAusenciaService, PrimeLocaleService, EmpresaService, DispositivoService, ZktecoService, SubtipoRegistroService, IconoService, EstadisticasService, AuthenticationGuard, ErrorHttpInterceptor, OauthHttpInterceptor, LoadingModule, BlockUiModule, BlockUiService, ListaIncidenciasComponent, GraficoRegistrosComponent, ListaRegistrosComponent, ListaEmpresasComponent, NuevaEmpresaComponent, ListaEmpleadosComponent, ListaTiposRegistroComponent, ListaAusenciasComponent, ListaEstadisticasComponent, NuevaAusenciaComponent as ɵh, NuevoEmpleadoComponent as ɵf, NuevaIncidenciaComponent as ɵd, NuevoRegistroComponent as ɵe, NuevoTipoRegistroComponent as ɵg, BlockUiComponent as ɵl, LoadingHttpInterceptor as ɵk, LoadingComponent as ɵi, LoadingService as ɵj, CONFIGURATION as ɵa, ConfigService as ɵb, OauthService as ɵc };

//# sourceMappingURL=core.js.map